var cl = Object.defineProperty;
var ll = (g, I, e) => I in g ? cl(g, I, { enumerable: !0, configurable: !0, writable: !0, value: e }) : g[I] = e;
var Yg = (g, I, e) => (ll(g, typeof I != "symbol" ? I + "" : I, e), e);
import { jsx as h, jsxs as T } from "@emotion/react/jsx-runtime";
import { useShowNotification as tl, hideNotification as il, createPolymorphicComponent as nl, Text as BI, COLOR_PALETTE as pg, Box as H, Group as B, Anchor as vI, OptimizeImage as qe, Indicator as bl, Stack as Cl, Flex as $e, ActionIcon as mg, Icon as Ng, Skeleton as gc } from "@inflearn/ds-react";
import { css as z } from "@emotion/react";
import { Stack as FI } from "@mantine/core";
import { createContext as YI, useContext as fI, useState as TI, useRef as zI, useEffect as eg, useCallback as wg, useMemo as Lg } from "react";
import { jsx as Ic, Fragment as ec, jsxs as al } from "react/jsx-runtime";
import SI from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import sl from "dayjs/plugin/localizedFormat";
import Al from "dayjs/plugin/updateLocale";
import { useAnalytics as ul } from "@inflearn/analytics";
import { useQuery as Bg, useMutation as cc, useQueryClient as rl } from "@tanstack/react-query";
import { ResponseStatus as bI, IsomorphicFetch as dl, ApiError as Zg, StatusCodeLookup as ol } from "@inflearn/datasource-rest";
var Gl = typeof global == "object" && global && global.Object === Object && global;
const lc = Gl;
var Xl = typeof self == "object" && self && self.Object === Object && self, Zl = lc || Xl || Function("return this")();
const ig = Zl;
var hl = ig.Symbol;
const Og = hl;
var tc = Object.prototype, Vl = tc.hasOwnProperty, Wl = tc.toString, rg = Og ? Og.toStringTag : void 0;
function ml(g) {
  var I = Vl.call(g, rg), e = g[rg];
  try {
    g[rg] = void 0;
    var c = !0;
  } catch {
  }
  var l = Wl.call(g);
  return c && (I ? g[rg] = e : delete g[rg]), l;
}
var Nl = Object.prototype, xl = Nl.toString;
function Rl(g) {
  return xl.call(g);
}
var Jl = "[object Null]", yl = "[object Undefined]", Ie = Og ? Og.toStringTag : void 0;
function ng(g) {
  return g == null ? g === void 0 ? yl : Jl : Ie && Ie in Object(g) ? ml(g) : Rl(g);
}
function q(g) {
  return g != null && typeof g == "object";
}
var pl = "[object Symbol]";
function Bl(g) {
  return typeof g == "symbol" || q(g) && ng(g) == pl;
}
function vl(g, I) {
  for (var e = -1, c = g == null ? 0 : g.length, l = Array(c); ++e < c; )
    l[e] = I(g[e], e, g);
  return l;
}
var Fl = Array.isArray;
const Eg = Fl;
var Yl = /\s/;
function fl(g) {
  for (var I = g.length; I-- && Yl.test(g.charAt(I)); )
    ;
  return I;
}
var Tl = /^\s+/;
function zl(g) {
  return g && g.slice(0, fl(g) + 1).replace(Tl, "");
}
function E(g) {
  var I = typeof g;
  return g != null && (I == "object" || I == "function");
}
var ee = 0 / 0, Sl = /^[-+]0x[0-9a-f]+$/i, Ul = /^0b[01]+$/i, Hl = /^0o[0-7]+$/i, wl = parseInt;
function Ll(g) {
  if (typeof g == "number")
    return g;
  if (Bl(g))
    return ee;
  if (E(g)) {
    var I = typeof g.valueOf == "function" ? g.valueOf() : g;
    g = E(I) ? I + "" : I;
  }
  if (typeof g != "string")
    return g === 0 ? g : +g;
  g = zl(g);
  var e = Ul.test(g);
  return e || Hl.test(g) ? wl(g.slice(2), e ? 2 : 8) : Sl.test(g) ? ee : +g;
}
var ce = 1 / 0, Ol = 17976931348623157e292;
function El(g) {
  if (!g)
    return g === 0 ? g : 0;
  if (g = Ll(g), g === ce || g === -ce) {
    var I = g < 0 ? -1 : 1;
    return I * Ol;
  }
  return g === g ? g : 0;
}
function Pl(g) {
  var I = El(g), e = I % 1;
  return I === I ? e ? I - e : I : 0;
}
function UI(g) {
  return g;
}
var jl = "[object AsyncFunction]", Dl = "[object Function]", kl = "[object GeneratorFunction]", Ml = "[object Proxy]";
function HI(g) {
  if (!E(g))
    return !1;
  var I = ng(g);
  return I == Dl || I == kl || I == jl || I == Ml;
}
var Ql = ig["__core-js_shared__"];
const CI = Ql;
var le = function() {
  var g = /[^.]+$/.exec(CI && CI.keys && CI.keys.IE_PROTO || "");
  return g ? "Symbol(src)_1." + g : "";
}();
function Kl(g) {
  return !!le && le in g;
}
var _l = Function.prototype, ql = _l.toString;
function $l(g) {
  if (g != null) {
    try {
      return ql.call(g);
    } catch {
    }
    try {
      return g + "";
    } catch {
    }
  }
  return "";
}
var gt = /[\\^$.*+?()[\]{}|]/g, It = /^\[object .+?Constructor\]$/, et = Function.prototype, ct = Object.prototype, lt = et.toString, tt = ct.hasOwnProperty, it = RegExp(
  "^" + lt.call(tt).replace(gt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function nt(g) {
  if (!E(g) || Kl(g))
    return !1;
  var I = HI(g) ? it : It;
  return I.test($l(g));
}
function bt(g, I) {
  return g == null ? void 0 : g[I];
}
function wI(g, I) {
  var e = bt(g, I);
  return nt(e) ? e : void 0;
}
var te = Object.create, Ct = function() {
  function g() {
  }
  return function(I) {
    if (!E(I))
      return {};
    if (te)
      return te(I);
    g.prototype = I;
    var e = new g();
    return g.prototype = void 0, e;
  };
}();
const at = Ct;
function st(g, I, e) {
  switch (e.length) {
    case 0:
      return g.call(I);
    case 1:
      return g.call(I, e[0]);
    case 2:
      return g.call(I, e[0], e[1]);
    case 3:
      return g.call(I, e[0], e[1], e[2]);
  }
  return g.apply(I, e);
}
function At(g, I) {
  var e = -1, c = g.length;
  for (I || (I = Array(c)); ++e < c; )
    I[e] = g[e];
  return I;
}
var ut = 800, rt = 16, dt = Date.now;
function ot(g) {
  var I = 0, e = 0;
  return function() {
    var c = dt(), l = rt - (c - e);
    if (e = c, l > 0) {
      if (++I >= ut)
        return arguments[0];
    } else
      I = 0;
    return g.apply(void 0, arguments);
  };
}
function ic(g) {
  return function() {
    return g;
  };
}
var Gt = function() {
  try {
    var g = wI(Object, "defineProperty");
    return g({}, "", {}), g;
  } catch {
  }
}();
const Pg = Gt;
var Xt = Pg ? function(g, I) {
  return Pg(g, "toString", {
    configurable: !0,
    enumerable: !1,
    value: ic(I),
    writable: !0
  });
} : UI;
const Zt = Xt;
var ht = ot(Zt);
const Vt = ht;
function Wt(g, I, e, c) {
  for (var l = g.length, t = e + (c ? 1 : -1); c ? t-- : ++t < l; )
    if (I(g[t], t, g))
      return t;
  return -1;
}
function mt(g) {
  return g !== g;
}
function Nt(g, I, e) {
  for (var c = e - 1, l = g.length; ++c < l; )
    if (g[c] === I)
      return c;
  return -1;
}
function xt(g, I, e) {
  return I === I ? Nt(g, I, e) : Wt(g, mt, e);
}
var Rt = 9007199254740991, Jt = /^(?:0|[1-9]\d*)$/;
function nc(g, I) {
  var e = typeof g;
  return I = I ?? Rt, !!I && (e == "number" || e != "symbol" && Jt.test(g)) && g > -1 && g % 1 == 0 && g < I;
}
function LI(g, I, e) {
  I == "__proto__" && Pg ? Pg(g, I, {
    configurable: !0,
    enumerable: !0,
    value: e,
    writable: !0
  }) : g[I] = e;
}
function $g(g, I) {
  return g === I || g !== g && I !== I;
}
var yt = Object.prototype, pt = yt.hasOwnProperty;
function Bt(g, I, e) {
  var c = g[I];
  (!(pt.call(g, I) && $g(c, e)) || e === void 0 && !(I in g)) && LI(g, I, e);
}
function vt(g, I, e, c) {
  var l = !e;
  e || (e = {});
  for (var t = -1, i = I.length; ++t < i; ) {
    var n = I[t], C = c ? c(e[n], g[n], n, e, g) : void 0;
    C === void 0 && (C = g[n]), l ? LI(e, n, C) : Bt(e, n, C);
  }
  return e;
}
var ie = Math.max;
function Ft(g, I, e) {
  return I = ie(I === void 0 ? g.length - 1 : I, 0), function() {
    for (var c = arguments, l = -1, t = ie(c.length - I, 0), i = Array(t); ++l < t; )
      i[l] = c[I + l];
    l = -1;
    for (var n = Array(I + 1); ++l < I; )
      n[l] = c[l];
    return n[I] = e(i), st(g, this, n);
  };
}
function Yt(g, I) {
  return Vt(Ft(g, I, UI), g + "");
}
var ft = 9007199254740991;
function bc(g) {
  return typeof g == "number" && g > -1 && g % 1 == 0 && g <= ft;
}
function vg(g) {
  return g != null && bc(g.length) && !HI(g);
}
function Tt(g, I, e) {
  if (!E(e))
    return !1;
  var c = typeof I;
  return (c == "number" ? vg(e) && nc(I, e.length) : c == "string" && I in e) ? $g(e[I], g) : !1;
}
function zt(g) {
  return Yt(function(I, e) {
    var c = -1, l = e.length, t = l > 1 ? e[l - 1] : void 0, i = l > 2 ? e[2] : void 0;
    for (t = g.length > 3 && typeof t == "function" ? (l--, t) : void 0, i && Tt(e[0], e[1], i) && (t = l < 3 ? void 0 : t, l = 1), I = Object(I); ++c < l; ) {
      var n = e[c];
      n && g(I, n, c, t);
    }
    return I;
  });
}
var St = Object.prototype;
function OI(g) {
  var I = g && g.constructor, e = typeof I == "function" && I.prototype || St;
  return g === e;
}
function Ut(g, I) {
  for (var e = -1, c = Array(g); ++e < g; )
    c[e] = I(e);
  return c;
}
var Ht = "[object Arguments]";
function ne(g) {
  return q(g) && ng(g) == Ht;
}
var Cc = Object.prototype, wt = Cc.hasOwnProperty, Lt = Cc.propertyIsEnumerable, Ot = ne(function() {
  return arguments;
}()) ? ne : function(g) {
  return q(g) && wt.call(g, "callee") && !Lt.call(g, "callee");
};
const GI = Ot;
function Et() {
  return !1;
}
var ac = typeof exports == "object" && exports && !exports.nodeType && exports, be = ac && typeof module == "object" && module && !module.nodeType && module, Pt = be && be.exports === ac, Ce = Pt ? ig.Buffer : void 0, jt = Ce ? Ce.isBuffer : void 0, Dt = jt || Et;
const sc = Dt;
var kt = "[object Arguments]", Mt = "[object Array]", Qt = "[object Boolean]", Kt = "[object Date]", _t = "[object Error]", qt = "[object Function]", $t = "[object Map]", gi = "[object Number]", Ii = "[object Object]", ei = "[object RegExp]", ci = "[object Set]", li = "[object String]", ti = "[object WeakMap]", ii = "[object ArrayBuffer]", ni = "[object DataView]", bi = "[object Float32Array]", Ci = "[object Float64Array]", ai = "[object Int8Array]", si = "[object Int16Array]", Ai = "[object Int32Array]", ui = "[object Uint8Array]", ri = "[object Uint8ClampedArray]", di = "[object Uint16Array]", oi = "[object Uint32Array]", y = {};
y[bi] = y[Ci] = y[ai] = y[si] = y[Ai] = y[ui] = y[ri] = y[di] = y[oi] = !0;
y[kt] = y[Mt] = y[ii] = y[Qt] = y[ni] = y[Kt] = y[_t] = y[qt] = y[$t] = y[gi] = y[Ii] = y[ei] = y[ci] = y[li] = y[ti] = !1;
function Gi(g) {
  return q(g) && bc(g.length) && !!y[ng(g)];
}
function Xi(g) {
  return function(I) {
    return g(I);
  };
}
var Ac = typeof exports == "object" && exports && !exports.nodeType && exports, Vg = Ac && typeof module == "object" && module && !module.nodeType && module, Zi = Vg && Vg.exports === Ac, aI = Zi && lc.process, hi = function() {
  try {
    var g = Vg && Vg.require && Vg.require("util").types;
    return g || aI && aI.binding && aI.binding("util");
  } catch {
  }
}();
const ae = hi;
var se = ae && ae.isTypedArray, Vi = se ? Xi(se) : Gi;
const uc = Vi;
var Wi = Object.prototype, mi = Wi.hasOwnProperty;
function rc(g, I) {
  var e = Eg(g), c = !e && GI(g), l = !e && !c && sc(g), t = !e && !c && !l && uc(g), i = e || c || l || t, n = i ? Ut(g.length, String) : [], C = n.length;
  for (var b in g)
    (I || mi.call(g, b)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (b == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    l && (b == "offset" || b == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    t && (b == "buffer" || b == "byteLength" || b == "byteOffset") || // Skip index properties.
    nc(b, C))) && n.push(b);
  return n;
}
function dc(g, I) {
  return function(e) {
    return g(I(e));
  };
}
var Ni = dc(Object.keys, Object);
const xi = Ni;
var Ri = Object.prototype, Ji = Ri.hasOwnProperty;
function yi(g) {
  if (!OI(g))
    return xi(g);
  var I = [];
  for (var e in Object(g))
    Ji.call(g, e) && e != "constructor" && I.push(e);
  return I;
}
function oc(g) {
  return vg(g) ? rc(g) : yi(g);
}
function pi(g) {
  var I = [];
  if (g != null)
    for (var e in Object(g))
      I.push(e);
  return I;
}
var Bi = Object.prototype, vi = Bi.hasOwnProperty;
function Fi(g) {
  if (!E(g))
    return pi(g);
  var I = OI(g), e = [];
  for (var c in g)
    c == "constructor" && (I || !vi.call(g, c)) || e.push(c);
  return e;
}
function Gc(g) {
  return vg(g) ? rc(g, !0) : Fi(g);
}
var Yi = wI(Object, "create");
const xg = Yi;
function fi() {
  this.__data__ = xg ? xg(null) : {}, this.size = 0;
}
function Ti(g) {
  var I = this.has(g) && delete this.__data__[g];
  return this.size -= I ? 1 : 0, I;
}
var zi = "__lodash_hash_undefined__", Si = Object.prototype, Ui = Si.hasOwnProperty;
function Hi(g) {
  var I = this.__data__;
  if (xg) {
    var e = I[g];
    return e === zi ? void 0 : e;
  }
  return Ui.call(I, g) ? I[g] : void 0;
}
var wi = Object.prototype, Li = wi.hasOwnProperty;
function Oi(g) {
  var I = this.__data__;
  return xg ? I[g] !== void 0 : Li.call(I, g);
}
var Ei = "__lodash_hash_undefined__";
function Pi(g, I) {
  var e = this.__data__;
  return this.size += this.has(g) ? 0 : 1, e[g] = xg && I === void 0 ? Ei : I, this;
}
function _(g) {
  var I = -1, e = g == null ? 0 : g.length;
  for (this.clear(); ++I < e; ) {
    var c = g[I];
    this.set(c[0], c[1]);
  }
}
_.prototype.clear = fi;
_.prototype.delete = Ti;
_.prototype.get = Hi;
_.prototype.has = Oi;
_.prototype.set = Pi;
function ji() {
  this.__data__ = [], this.size = 0;
}
function gI(g, I) {
  for (var e = g.length; e--; )
    if ($g(g[e][0], I))
      return e;
  return -1;
}
var Di = Array.prototype, ki = Di.splice;
function Mi(g) {
  var I = this.__data__, e = gI(I, g);
  if (e < 0)
    return !1;
  var c = I.length - 1;
  return e == c ? I.pop() : ki.call(I, e, 1), --this.size, !0;
}
function Qi(g) {
  var I = this.__data__, e = gI(I, g);
  return e < 0 ? void 0 : I[e][1];
}
function Ki(g) {
  return gI(this.__data__, g) > -1;
}
function _i(g, I) {
  var e = this.__data__, c = gI(e, g);
  return c < 0 ? (++this.size, e.push([g, I])) : e[c][1] = I, this;
}
function j(g) {
  var I = -1, e = g == null ? 0 : g.length;
  for (this.clear(); ++I < e; ) {
    var c = g[I];
    this.set(c[0], c[1]);
  }
}
j.prototype.clear = ji;
j.prototype.delete = Mi;
j.prototype.get = Qi;
j.prototype.has = Ki;
j.prototype.set = _i;
var qi = wI(ig, "Map");
const Xc = qi;
function $i() {
  this.size = 0, this.__data__ = {
    hash: new _(),
    map: new (Xc || j)(),
    string: new _()
  };
}
function gn(g) {
  var I = typeof g;
  return I == "string" || I == "number" || I == "symbol" || I == "boolean" ? g !== "__proto__" : g === null;
}
function II(g, I) {
  var e = g.__data__;
  return gn(I) ? e[typeof I == "string" ? "string" : "hash"] : e.map;
}
function In(g) {
  var I = II(this, g).delete(g);
  return this.size -= I ? 1 : 0, I;
}
function en(g) {
  return II(this, g).get(g);
}
function cn(g) {
  return II(this, g).has(g);
}
function ln(g, I) {
  var e = II(this, g), c = e.size;
  return e.set(g, I), this.size += e.size == c ? 0 : 1, this;
}
function bg(g) {
  var I = -1, e = g == null ? 0 : g.length;
  for (this.clear(); ++I < e; ) {
    var c = g[I];
    this.set(c[0], c[1]);
  }
}
bg.prototype.clear = $i;
bg.prototype.delete = In;
bg.prototype.get = en;
bg.prototype.has = cn;
bg.prototype.set = ln;
var tn = dc(Object.getPrototypeOf, Object);
const Zc = tn;
var nn = "[object Object]", bn = Function.prototype, Cn = Object.prototype, hc = bn.toString, an = Cn.hasOwnProperty, sn = hc.call(Object);
function An(g) {
  if (!q(g) || ng(g) != nn)
    return !1;
  var I = Zc(g);
  if (I === null)
    return !0;
  var e = an.call(I, "constructor") && I.constructor;
  return typeof e == "function" && e instanceof e && hc.call(e) == sn;
}
function un() {
  this.__data__ = new j(), this.size = 0;
}
function rn(g) {
  var I = this.__data__, e = I.delete(g);
  return this.size = I.size, e;
}
function dn(g) {
  return this.__data__.get(g);
}
function on(g) {
  return this.__data__.has(g);
}
var Gn = 200;
function Xn(g, I) {
  var e = this.__data__;
  if (e instanceof j) {
    var c = e.__data__;
    if (!Xc || c.length < Gn - 1)
      return c.push([g, I]), this.size = ++e.size, this;
    e = this.__data__ = new bg(c);
  }
  return e.set(g, I), this.size = e.size, this;
}
function Cg(g) {
  var I = this.__data__ = new j(g);
  this.size = I.size;
}
Cg.prototype.clear = un;
Cg.prototype.delete = rn;
Cg.prototype.get = dn;
Cg.prototype.has = on;
Cg.prototype.set = Xn;
var Vc = typeof exports == "object" && exports && !exports.nodeType && exports, Ae = Vc && typeof module == "object" && module && !module.nodeType && module, Zn = Ae && Ae.exports === Vc, ue = Zn ? ig.Buffer : void 0, re = ue ? ue.allocUnsafe : void 0;
function hn(g, I) {
  if (I)
    return g.slice();
  var e = g.length, c = re ? re(e) : new g.constructor(e);
  return g.copy(c), c;
}
var Vn = ig.Uint8Array;
const de = Vn;
function Wn(g) {
  var I = new g.constructor(g.byteLength);
  return new de(I).set(new de(g)), I;
}
function mn(g, I) {
  var e = I ? Wn(g.buffer) : g.buffer;
  return new g.constructor(e, g.byteOffset, g.length);
}
function Nn(g) {
  return typeof g.constructor == "function" && !OI(g) ? at(Zc(g)) : {};
}
function xn(g) {
  return function(I, e, c) {
    for (var l = -1, t = Object(I), i = c(I), n = i.length; n--; ) {
      var C = i[g ? n : ++l];
      if (e(t[C], C, t) === !1)
        break;
    }
    return I;
  };
}
var Rn = xn();
const Wc = Rn;
function Jn(g, I) {
  return g && Wc(g, I, oc);
}
function XI(g, I, e) {
  (e !== void 0 && !$g(g[I], e) || e === void 0 && !(I in g)) && LI(g, I, e);
}
function yn(g) {
  return q(g) && vg(g);
}
function ZI(g, I) {
  if (!(I === "constructor" && typeof g[I] == "function") && I != "__proto__")
    return g[I];
}
function pn(g) {
  return vt(g, Gc(g));
}
function Bn(g, I, e, c, l, t, i) {
  var n = ZI(g, e), C = ZI(I, e), b = i.get(C);
  if (b) {
    XI(g, e, b);
    return;
  }
  var a = t ? t(n, C, e + "", g, I, i) : void 0, u = a === void 0;
  if (u) {
    var A = Eg(C), G = !A && sc(C), N = !A && !G && uc(C);
    a = C, A || G || N ? Eg(n) ? a = n : yn(n) ? a = At(n) : G ? (u = !1, a = hn(C, !0)) : N ? (u = !1, a = mn(C, !0)) : a = [] : An(C) || GI(C) ? (a = n, GI(n) ? a = pn(n) : (!E(n) || HI(n)) && (a = Nn(C))) : u = !1;
  }
  u && (i.set(C, a), l(a, C, c, t, i), i.delete(C)), XI(g, e, a);
}
function mc(g, I, e, c, l) {
  g !== I && Wc(I, function(t, i) {
    if (l || (l = new Cg()), E(t))
      Bn(g, I, i, e, mc, c, l);
    else {
      var n = c ? c(ZI(g, i), t, i + "", g, I, l) : void 0;
      n === void 0 && (n = t), XI(g, i, n);
    }
  }, Gc);
}
var vn = "[object String]";
function Fn(g) {
  return typeof g == "string" || !Eg(g) && q(g) && ng(g) == vn;
}
function Yn(g, I) {
  return vl(I, function(e) {
    return g[e];
  });
}
function fn(g) {
  return g == null ? [] : Yn(g, oc(g));
}
var Tn = Math.max;
function zn(g, I, e, c) {
  g = vg(g) ? g : fn(g), e = e && !c ? Pl(e) : 0;
  var l = g.length;
  return e < 0 && (e = Tn(l + e, 0)), Fn(g) ? e <= l && g.indexOf(I, e) > -1 : !!l && xt(g, I, e) > -1;
}
function Sn(g, I, e, c) {
  return Jn(g, function(l, t, i) {
    I(c, e(l), t, i);
  }), c;
}
function Un(g, I) {
  return function(e, c) {
    return Sn(e, g, I(c), {});
  };
}
var Hn = Object.prototype, wn = Hn.toString, Ln = Un(function(g, I, e) {
  I != null && typeof I.toString != "function" && (I = wn.call(I)), g[I] = e;
}, ic(UI));
const On = Ln;
var En = zt(function(g, I, e) {
  mc(g, I, e);
});
const Nc = En;
/*! js-cookie v3.0.5 | MIT */
function fg(g) {
  for (var I = 1; I < arguments.length; I++) {
    var e = arguments[I];
    for (var c in e)
      g[c] = e[c];
  }
  return g;
}
var Pn = {
  read: function(g) {
    return g[0] === '"' && (g = g.slice(1, -1)), g.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(g) {
    return encodeURIComponent(g).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function hI(g, I) {
  function e(l, t, i) {
    if (!(typeof document > "u")) {
      i = fg({}, I, i), typeof i.expires == "number" && (i.expires = new Date(Date.now() + i.expires * 864e5)), i.expires && (i.expires = i.expires.toUTCString()), l = encodeURIComponent(l).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var n = "";
      for (var C in i)
        i[C] && (n += "; " + C, i[C] !== !0 && (n += "=" + i[C].split(";")[0]));
      return document.cookie = l + "=" + g.write(t, l) + n;
    }
  }
  function c(l) {
    if (!(typeof document > "u" || arguments.length && !l)) {
      for (var t = document.cookie ? document.cookie.split("; ") : [], i = {}, n = 0; n < t.length; n++) {
        var C = t[n].split("="), b = C.slice(1).join("=");
        try {
          var a = decodeURIComponent(C[0]);
          if (i[a] = g.read(b, a), l === a)
            break;
        } catch {
        }
      }
      return l ? i[l] : i;
    }
  }
  return Object.create(
    {
      set: e,
      get: c,
      remove: function(l, t) {
        e(
          l,
          "",
          fg({}, t, {
            expires: -1
          })
        );
      },
      withAttributes: function(l) {
        return hI(this.converter, fg({}, this.attributes, l));
      },
      withConverter: function(l) {
        return hI(fg({}, this.converter, l), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(I) },
      converter: { value: Object.freeze(g) }
    }
  );
}
var xc = hI(Pn, { path: "/" });
const Vs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xc
}, Symbol.toStringTag, { value: "Module" })), jn = {
  MODE: "development",
  CDN_URL: "https://cdn.devinflearn.com",
  API_URL: "https://www.devinflearn.com",
  SITE_URL: "https://www.devinflearn.com",
  MENTORING_SITE_URL: "https://mentoring.devinflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.devinflearn.com",
  ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  COURSE_API_URL: "https://course-api.devinflearn.com",
  UCC_API_URL: "https://ucc-api.devinflearn.com",
  RALLIT_SITE_URL: "https://www.devrallit.com",
  BUSINESS_DOMAIN: "https://business.devinflearn.com",
  ADMIN_DOMAIN: "https://admin.devinflearn.com",
  COOKIE_DOMAIN: ".devinflearn.com",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.test",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "65fef69e7b3b778bd124",
  OAUTH_GITHUB_CLIENT_ID: "41f342acfada922e9fb5",
  OAUTH_GOOGLE_CLIENT_ID: "333892070963-abo0eoss3ielmeukj8dtvpr4l0fbniun.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "1281a93457d30e1f2ffafe9fe0c197ab",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, Dn = {
  MODE: "localhost",
  CDN_URL: "https://cdn.devinflearn.com",
  API_URL: "http://localhost:3000",
  SITE_URL: "http://localhost:3000",
  MENTORING_SITE_URL: "https://mentoring.devinflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.devinflearn.com",
  ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  COURSE_API_URL: "https://course-api.devinflearn.com",
  UCC_API_URL: "https://ucc-api.devinflearn.com",
  RALLIT_SITE_URL: "https://www.devrallit.com",
  BUSINESS_DOMAIN: "http://localhost:7020",
  ADMIN_DOMAIN: "http://localhost:7010",
  COOKIE_DOMAIN: "localhost",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.test",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "65fef69e7b3b778bd124",
  OAUTH_GITHUB_CLIENT_ID: "41f342acfada922e9fb5",
  OAUTH_GOOGLE_CLIENT_ID: "333892070963-abo0eoss3ielmeukj8dtvpr4l0fbniun.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "1281a93457d30e1f2ffafe9fe0c197ab",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, oe = {
  MODE: "production",
  CDN_URL: "https://cdn.inflearn.com",
  API_URL: "https://www.inflearn.com",
  SITE_URL: "https://www.inflearn.com",
  MENTORING_SITE_URL: "https://mentoring.inflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.inflearn.com",
  ACCOUNT_API_URL: "https://account-api.inflearn.com",
  COURSE_API_URL: "https://course-api.inflearn.com",
  UCC_API_URL: "https://ucc-api.inflearn.com",
  RALLIT_SITE_URL: "https://www.rallit.com",
  BUSINESS_DOMAIN: "https://business.inflearn.com",
  ADMIN_DOMAIN: "https://admin.inflearn.com",
  COOKIE_DOMAIN: ".inflearn.com",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.web",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "5fd8e44b142806d9cbea",
  OAUTH_GITHUB_CLIENT_ID: "419780d6d3750d84d1db",
  OAUTH_GOOGLE_CLIENT_ID: "887875630717-ror9t8ig4obhvokdij07eoochpqbu5kf.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "0de1184063abadc9cef9dbf417c567a5",
  HACKLE_BROWSER_SDK_KEY: "rb1wDPCB39swIGfTAhDcz0QXvmh6hayS",
  MIXPANEL_TOKEN: "c05d8cc017a29af05e50c0d43d848d2d",
  CDN_INTEGRATION_URL: "https://cdn.inflab.com"
};
function kn() {
  return typeof window < "u" && (window != null && window.env) ? window.env : process.env.NEXT_PUBLIC_ENV || process.env.APP_ENV;
}
function Mn() {
  const g = kn();
  return g ? g === "localhost" ? Dn : g === "production" ? oe : jn : (console.error("app-shell env is not defined"), oe);
}
const v = Mn(), EI = v.CDN_URL, PI = v.SITE_URL, jg = v.MENTORING_SITE_URL, Ws = v.SOCIAL_ACCOUNT_URL, Qn = v.API_URL, Kn = `${Qn}/api`, _n = v.ACCOUNT_API_URL, qn = v.COURSE_API_URL, $n = v.UCC_API_URL, gb = v.MODE, Ge = v.RALLIT_SITE_URL, ms = v.OAUTH_APPLE_CLIENT_ID, Ns = v.OAUTH_GITHUB_CLIENT_ID, xs = v.OAUTH_GOOGLE_CLIENT_ID, Rs = v.OAUTH_KAKAO_REST_ID, Rc = v.BUSINESS_DOMAIN, Ib = v.COOKIE_DOMAIN, Js = v.HACKLE_BROWSER_SDK_KEY, eb = v.MIXPANEL_TOKEN;
v.CDN_INTEGRATION_URL;
const sI = xc.withAttributes({
  path: "/",
  domain: Ib
}).withConverter({
  write: function(g) {
    return encodeURIComponent(g);
  }
});
class Ug {
  static set(I, e, c = this.COOKIE_EXPIRE_DAY, l = "Medium") {
    sI.set(I, e, {
      expires: c,
      priority: l
    });
  }
  static get(I) {
    return sI.get(I);
  }
  static remove(I) {
    sI.remove(I);
  }
}
Yg(Ug, "COOKIE_EXPIRE_DAY", 7);
function Jc(g) {
  return g && g.__esModule && Object.prototype.hasOwnProperty.call(g, "default") ? g.default : g;
}
const cb = (...g) => {
  console != null && console.warn && (K(g[0]) && (g[0] = `react-i18next:: ${g[0]}`), console.warn(...g));
}, Xe = {}, VI = (...g) => {
  K(g[0]) && Xe[g[0]] || (K(g[0]) && (Xe[g[0]] = /* @__PURE__ */ new Date()), cb(...g));
}, yc = (g, I) => () => {
  if (g.isInitialized)
    I();
  else {
    const e = () => {
      setTimeout(() => {
        g.off("initialized", e);
      }, 0), I();
    };
    g.on("initialized", e);
  }
}, Ze = (g, I, e) => {
  g.loadNamespaces(I, yc(g, e));
}, he = (g, I, e, c) => {
  K(e) && (e = [e]), e.forEach((l) => {
    g.options.ns.indexOf(l) < 0 && g.options.ns.push(l);
  }), g.loadLanguages(I, yc(g, c));
}, lb = (g, I, e = {}) => !I.languages || !I.languages.length ? (VI("i18n.languages were undefined or empty", I.languages), !0) : I.hasLoadedNamespace(g, {
  lng: e.lng,
  precheck: (c, l) => {
    var t;
    if (((t = e.bindI18n) == null ? void 0 : t.indexOf("languageChanging")) > -1 && c.services.backendConnector.backend && c.isLanguageChangingTo && !l(c.isLanguageChangingTo, g))
      return !1;
  }
}), K = (g) => typeof g == "string", tb = (g) => typeof g == "object" && g !== null, ib = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, nb = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, bb = (g) => nb[g], Cb = (g) => g.replace(ib, bb);
let WI = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Cb
};
const ab = (g = {}) => {
  WI = {
    ...WI,
    ...g
  };
}, sb = () => WI;
let pc;
const Ab = (g) => {
  pc = g;
}, ub = () => pc, rb = {
  type: "3rdParty",
  init(g) {
    ab(g.options.react), Ab(g);
  }
}, db = YI();
class ob {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(I) {
    I.forEach((e) => {
      this.usedNamespaces[e] || (this.usedNamespaces[e] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Gb = (g, I) => {
  const e = zI();
  return eg(() => {
    e.current = I ? e.current : g;
  }, [g, I]), e.current;
}, Bc = (g, I, e, c) => g.getFixedT(I, e, c), Xb = (g, I, e, c) => wg(Bc(g, I, e, c), [g, I, e, c]), vc = (g, I = {}) => {
  var r, o, X, m;
  const {
    i18n: e
  } = I, {
    i18n: c,
    defaultNS: l
  } = fI(db) || {}, t = e || c || ub();
  if (t && !t.reportNamespaces && (t.reportNamespaces = new ob()), !t) {
    VI("You will need to pass in an i18next instance by using initReactI18next");
    const V = (S, Y) => K(Y) ? Y : tb(Y) && K(Y.defaultValue) ? Y.defaultValue : Array.isArray(S) ? S[S.length - 1] : S, J = [V, {}, !1];
    return J.t = V, J.i18n = {}, J.ready = !1, J;
  }
  (r = t.options.react) != null && r.wait && VI("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const i = {
    ...sb(),
    ...t.options.react,
    ...I
  }, {
    useSuspense: n,
    keyPrefix: C
  } = i;
  let b = g || l || ((o = t.options) == null ? void 0 : o.defaultNS);
  b = K(b) ? [b] : b || ["translation"], (m = (X = t.reportNamespaces).addUsedNamespaces) == null || m.call(X, b);
  const a = (t.isInitialized || t.initializedStoreOnce) && b.every((V) => lb(V, t, i)), u = Xb(t, I.lng || null, i.nsMode === "fallback" ? b : b[0], C), A = () => u, G = () => Bc(t, I.lng || null, i.nsMode === "fallback" ? b : b[0], C), [N, W] = TI(A);
  let R = b.join();
  I.lng && (R = `${I.lng}${R}`);
  const p = Gb(R), s = zI(!0);
  eg(() => {
    const {
      bindI18n: V,
      bindI18nStore: J
    } = i;
    s.current = !0, !a && !n && (I.lng ? he(t, I.lng, b, () => {
      s.current && W(G);
    }) : Ze(t, b, () => {
      s.current && W(G);
    })), a && p && p !== R && s.current && W(G);
    const S = () => {
      s.current && W(G);
    };
    return V && (t == null || t.on(V, S)), J && (t == null || t.store.on(J, S)), () => {
      s.current = !1, t && (V == null || V.split(" ").forEach((Y) => t.off(Y, S))), J && t && J.split(" ").forEach((Y) => t.store.off(Y, S));
    };
  }, [t, R]), eg(() => {
    s.current && a && W(A);
  }, [t, C, a]);
  const d = [N, t, a];
  if (d.t = N, d.i18n = t, d.ready = a, a || !a && !n)
    return d;
  throw new Promise((V) => {
    I.lng ? he(t, I.lng, b, () => V()) : Ze(t, b, () => V());
  });
};
function Fc(g) {
  return vc("appShell", g);
}
var eI = { exports: {} };
function Zb(g) {
  try {
    return JSON.stringify(g);
  } catch {
    return '"[Circular]"';
  }
}
var hb = Vb;
function Vb(g, I, e) {
  var c = e && e.stringify || Zb, l = 1;
  if (typeof g == "object" && g !== null) {
    var t = I.length + l;
    if (t === 1)
      return g;
    var i = new Array(t);
    i[0] = c(g);
    for (var n = 1; n < t; n++)
      i[n] = c(I[n]);
    return i.join(" ");
  }
  if (typeof g != "string")
    return g;
  var C = I.length;
  if (C === 0)
    return g;
  for (var b = "", a = 1 - l, u = -1, A = g && g.length || 0, G = 0; G < A; ) {
    if (g.charCodeAt(G) === 37 && G + 1 < A) {
      switch (u = u > -1 ? u : 0, g.charCodeAt(G + 1)) {
        case 100:
        case 102:
          if (a >= C || I[a] == null)
            break;
          u < G && (b += g.slice(u, G)), b += Number(I[a]), u = G + 2, G++;
          break;
        case 105:
          if (a >= C || I[a] == null)
            break;
          u < G && (b += g.slice(u, G)), b += Math.floor(Number(I[a])), u = G + 2, G++;
          break;
        case 79:
        case 111:
        case 106:
          if (a >= C || I[a] === void 0)
            break;
          u < G && (b += g.slice(u, G));
          var N = typeof I[a];
          if (N === "string") {
            b += "'" + I[a] + "'", u = G + 2, G++;
            break;
          }
          if (N === "function") {
            b += I[a].name || "<anonymous>", u = G + 2, G++;
            break;
          }
          b += c(I[a]), u = G + 2, G++;
          break;
        case 115:
          if (a >= C)
            break;
          u < G && (b += g.slice(u, G)), b += String(I[a]), u = G + 2, G++;
          break;
        case 37:
          u < G && (b += g.slice(u, G)), b += "%", u = G + 2, G++, a--;
          break;
      }
      ++a;
    }
    ++G;
  }
  return u === -1 ? g : (u < A && (b += g.slice(u)), b);
}
const Ve = hb;
eI.exports = P;
const Rg = zb().console || {}, Wb = {
  mapHttpRequest: Tg,
  mapHttpResponse: Tg,
  wrapRequestSerializer: AI,
  wrapResponseSerializer: AI,
  wrapErrorSerializer: AI,
  req: Tg,
  res: Tg,
  err: me,
  errWithCause: me
};
function Dg(g, I) {
  return g === "silent" ? 1 / 0 : I.levels.values[g];
}
const jI = Symbol("pino.logFuncs"), mI = Symbol("pino.hierarchy"), mb = {
  error: "log",
  fatal: "error",
  warn: "error",
  info: "log",
  debug: "log",
  trace: "log"
};
function We(g, I) {
  const e = {
    logger: I,
    parent: g[mI]
  };
  I[mI] = e;
}
function Nb(g, I, e) {
  const c = {};
  I.forEach((l) => {
    c[l] = e[l] ? e[l] : Rg[l] || Rg[mb[l] || "log"] || Jg;
  }), g[jI] = c;
}
function xb(g, I) {
  return Array.isArray(g) ? g.filter(function(c) {
    return c !== "!stdSerializers.err";
  }) : g === !0 ? Object.keys(I) : !1;
}
function P(g) {
  g = g || {}, g.browser = g.browser || {};
  const I = g.browser.transmit;
  if (I && typeof I.send != "function")
    throw Error("pino: transmit option must have a send function");
  const e = g.browser.write || Rg;
  g.browser.write && (g.browser.asObject = !0);
  const c = g.serializers || {}, l = xb(g.browser.serialize, c);
  let t = g.browser.serialize;
  Array.isArray(g.browser.serialize) && g.browser.serialize.indexOf("!stdSerializers.err") > -1 && (t = !1);
  const i = Object.keys(g.customLevels || {}), n = ["error", "fatal", "warn", "info", "debug", "trace"].concat(i);
  typeof e == "function" && n.forEach(function(W) {
    e[W] = e;
  }), (g.enabled === !1 || g.browser.disabled) && (g.level = "silent");
  const C = g.level || "info", b = Object.create(e);
  b.log || (b.log = Jg), Nb(b, n, e), We({}, b), Object.defineProperty(b, "levelVal", {
    get: u
  }), Object.defineProperty(b, "level", {
    get: A,
    set: G
  });
  const a = {
    transmit: I,
    serialize: l,
    asObject: g.browser.asObject,
    formatters: g.browser.formatters,
    levels: n,
    timestamp: Yb(g)
  };
  b.levels = Rb(g), b.level = C, b.setMaxListeners = b.getMaxListeners = b.emit = b.addListener = b.on = b.prependListener = b.once = b.prependOnceListener = b.removeListener = b.removeAllListeners = b.listeners = b.listenerCount = b.eventNames = b.write = b.flush = Jg, b.serializers = c, b._serialize = l, b._stdErrSerialize = t, b.child = N, I && (b._logEvent = NI());
  function u() {
    return Dg(this.level, this);
  }
  function A() {
    return this._level;
  }
  function G(W) {
    if (W !== "silent" && !this.levels.values[W])
      throw Error("unknown level " + W);
    this._level = W, Q(this, a, b, "error"), Q(this, a, b, "fatal"), Q(this, a, b, "warn"), Q(this, a, b, "info"), Q(this, a, b, "debug"), Q(this, a, b, "trace"), i.forEach((R) => {
      Q(this, a, b, R);
    });
  }
  function N(W, R) {
    if (!W)
      throw new Error("missing bindings for child Pino");
    R = R || {}, l && W.serializers && (R.serializers = W.serializers);
    const p = R.serializers;
    if (l && p) {
      var s = Object.assign({}, c, p), d = g.browser.serialize === !0 ? Object.keys(s) : l;
      delete W.serializers, cI([W], d, s, this._stdErrSerialize);
    }
    function r(X) {
      this._childLevel = (X._childLevel | 0) + 1, this.bindings = W, s && (this.serializers = s, this._serialize = d), I && (this._logEvent = NI(
        [].concat(X._logEvent.bindings, W)
      ));
    }
    r.prototype = this;
    const o = new r(this);
    return We(this, o), o.level = this.level, o;
  }
  return b;
}
function Rb(g) {
  const I = g.customLevels || {}, e = Object.assign({}, P.levels.values, I), c = Object.assign({}, P.levels.labels, Jb(I));
  return {
    values: e,
    labels: c
  };
}
function Jb(g) {
  const I = {};
  return Object.keys(g).forEach(function(e) {
    I[g[e]] = e;
  }), I;
}
P.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal"
  }
};
P.stdSerializers = Wb;
P.stdTimeFunctions = Object.assign({}, { nullTime: Yc, epochTime: fc, unixTime: fb, isoTime: Tb });
function yb(g) {
  const I = [];
  g.bindings && I.push(g.bindings);
  let e = g[mI];
  for (; e.parent; )
    e = e.parent, e.logger.bindings && I.push(e.logger.bindings);
  return I.reverse();
}
function Q(g, I, e, c) {
  if (Object.defineProperty(g, c, {
    value: Dg(g.level, e) > Dg(c, e) ? Jg : e[jI][c],
    writable: !0,
    enumerable: !0,
    configurable: !0
  }), !I.transmit && g[c] === Jg)
    return;
  g[c] = Bb(g, I, e, c);
  const l = yb(g);
  l.length !== 0 && (g[c] = pb(l, g[c]));
}
function pb(g, I) {
  return function() {
    return I.apply(this, [...g, ...arguments]);
  };
}
function Bb(g, I, e, c) {
  return function(l) {
    return function() {
      const i = I.timestamp(), n = new Array(arguments.length), C = Object.getPrototypeOf && Object.getPrototypeOf(this) === Rg ? Rg : this;
      for (var b = 0; b < n.length; b++)
        n[b] = arguments[b];
      if (I.serialize && !I.asObject && cI(n, this._serialize, this.serializers, this._stdErrSerialize), I.asObject || I.formatters ? l.call(C, vb(this, c, n, i, I.formatters)) : l.apply(C, n), I.transmit) {
        const a = I.transmit.level || g._level, u = e.levels.values[a], A = e.levels.values[c];
        if (A < u)
          return;
        Fb(this, {
          ts: i,
          methodLevel: c,
          methodValue: A,
          transmitLevel: a,
          transmitValue: e.levels.values[I.transmit.level || g._level],
          send: I.transmit.send,
          val: Dg(g._level, e)
        }, n);
      }
    };
  }(g[jI][c]);
}
function vb(g, I, e, c, l = {}) {
  const {
    level: t = () => g.levels.values[I],
    log: i = (A) => A
  } = l;
  g._serialize && cI(e, g._serialize, g.serializers, g._stdErrSerialize);
  const n = e.slice();
  let C = n[0];
  const b = {};
  c && (b.time = c), b.level = t(I, g.levels.values[I]);
  let a = (g._childLevel | 0) + 1;
  if (a < 1 && (a = 1), C !== null && typeof C == "object") {
    for (; a-- && typeof n[0] == "object"; )
      Object.assign(b, n.shift());
    C = n.length ? Ve(n.shift(), n) : void 0;
  } else
    typeof C == "string" && (C = Ve(n.shift(), n));
  return C !== void 0 && (b.msg = C), i(b);
}
function cI(g, I, e, c) {
  for (const l in g)
    if (c && g[l] instanceof Error)
      g[l] = P.stdSerializers.err(g[l]);
    else if (typeof g[l] == "object" && !Array.isArray(g[l]))
      for (const t in g[l])
        I && I.indexOf(t) > -1 && t in e && (g[l][t] = e[t](g[l][t]));
}
function Fb(g, I, e) {
  const c = I.send, l = I.ts, t = I.methodLevel, i = I.methodValue, n = I.val, C = g._logEvent.bindings;
  cI(
    e,
    g._serialize || Object.keys(g.serializers),
    g.serializers,
    g._stdErrSerialize === void 0 ? !0 : g._stdErrSerialize
  ), g._logEvent.ts = l, g._logEvent.messages = e.filter(function(b) {
    return C.indexOf(b) === -1;
  }), g._logEvent.level.label = t, g._logEvent.level.value = i, c(t, g._logEvent, n), g._logEvent = NI(C);
}
function NI(g) {
  return {
    ts: 0,
    messages: [],
    bindings: g || [],
    level: { label: "", value: 0 }
  };
}
function me(g) {
  const I = {
    type: g.constructor.name,
    msg: g.message,
    stack: g.stack
  };
  for (const e in g)
    I[e] === void 0 && (I[e] = g[e]);
  return I;
}
function Yb(g) {
  return typeof g.timestamp == "function" ? g.timestamp : g.timestamp === !1 ? Yc : fc;
}
function Tg() {
  return {};
}
function AI(g) {
  return g;
}
function Jg() {
}
function Yc() {
  return !1;
}
function fc() {
  return Date.now();
}
function fb() {
  return Math.round(Date.now() / 1e3);
}
function Tb() {
  return new Date(Date.now()).toISOString();
}
function zb() {
  function g(I) {
    return typeof I < "u" && I;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return g(self) || g(window) || g(this) || {};
  }
}
eI.exports.default = P;
eI.exports.pino = P;
var Sb = eI.exports;
const Ub = /* @__PURE__ */ Jc(Sb);
class Hb {
  constructor() {
    Yg(this, "logger");
    /**
     * 서버와 log level을 동기화 하기 위한 설정
     * @see {@link https://github.com/winstonjs/winston#logging-levels Winston log level}
     */
    Yg(this, "defaultLogLevelMap");
    this.defaultLogLevelMap = {
      error: 3,
      warn: 4,
      info: 6,
      debug: 7
    }, this.logger = Ub(), this.logger.levels = {
      labels: On(this.defaultLogLevelMap),
      values: this.defaultLogLevelMap
    };
  }
  debug(I) {
    this.log("debug", I);
  }
  info(I) {
    this.log("info", I);
  }
  warn(I) {
    this.log("warn", I);
  }
  error(I) {
    this.log("error", I);
  }
  log(I, e) {
    if (this.isLogLevelKey(I)) {
      this.logger[I](e);
      return;
    }
    const c = this.findLoggerTypeForSyslogLevel(I);
    c && this.logger[c](e);
  }
  isLogLevelKey(I) {
    return typeof I == "string" && zn(Object.keys(this.defaultLogLevelMap), I);
  }
  findLoggerTypeForSyslogLevel(I) {
    const e = this.logger.levels.labels[I];
    return this.isLogLevelKey(e) ? e : null;
  }
}
const Ne = new Hb(), wb = 10 * 1e3, Lb = [bI.NOT_FOUND, bI.UNAUTHORIZED, bI.BAD_PARAMETER];
class ag extends dl {
  static from(I) {
    return new ag({
      credentials: "include",
      timeout: wb,
      ...I
    });
  }
  afterRequest(I, e, c, l) {
    if (Zg.isHandledResponse(l)) {
      const t = Zg.createApiError(l, {
        status: I,
        handled: !0,
        extra: l,
        url: c.path
      }), {
        level: i,
        message: n
      } = t.logMessage();
      throw Ne[i](n), t;
    }
    return l;
  }
  performError(I) {
    if (!(I instanceof DOMException && I.name === "AbortError") && Zg.isUnhandledResponse(I)) {
      const e = Zg.createApiError({
        statusCode: ol[I.status] || String(I.status),
        message: `[${I.name}] ${I.url} | ${I}`,
        data: null
      }, {
        handled: !1,
        url: I.url,
        status: I.status
      }, Lb), {
        level: c,
        message: l
      } = e.logMessage();
      Ne[c](l);
    }
  }
}
const lI = ag.from({
  baseUrl: Kn
}), Ob = ag.from({
  baseUrl: _n
}), ys = ag.from({
  baseUrl: qn
}), ps = ag.from({
  baseUrl: $n
});
var Tc = /* @__PURE__ */ ((g) => (g.OK = "OK", g.SERVER_ERROR = "SERVER_ERROR", g.DUPLICATE = "DUPLICATE", g.NOT_FOUND = "NOT_FOUND", g.BAD_REQUEST = "BAD_REQUEST", g.BAD_PARAMETER = "BAD_PARAMETER", g.CONFLICT = "CONFLICT", g.UNAUTHORIZED = "UNAUTHORIZED", g.FORBIDDEN = "FORBIDDEN", g.PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE", g.TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS", g))(Tc || {});
const Bs = {
  V1_MESSAGE: "/user/api/v1/messages/unchecked",
  V1_USER_META: "/v1/user/meta",
  V1_GROUP_BY_USER: "/v1/group/by-user",
  V1_GROUP_ID_NOTICE_EXPOSURE: (g) => `/v1/group/${g}/notice/exposure`,
  V1_NOTICE_EXPOSURE: "/v1/notice/exposure"
}, Eb = async (g, I) => lI.get(g, I);
function vs({
  queryKey: g,
  url: I,
  options: e,
  requestOptions: c
}) {
  var t;
  const l = Bg(g, () => Eb(I, c), e);
  return {
    ...l,
    data: (t = l.data) == null ? void 0 : t.data
  };
}
const Pb = async (g, I) => lI.get(g, I);
function Fs({
  queryKey: g,
  url: I,
  options: e,
  requestOptions: c
}) {
  var t;
  const l = Bg(g, () => Pb(I, c), e);
  return {
    ...l,
    data: (t = l.data) == null ? void 0 : t.data
  };
}
const jb = async (g, I) => lI.get(g, I);
function Ys({
  queryKey: g,
  url: I,
  options: e,
  requestOptions: c
}) {
  var t;
  const l = Bg(g, () => jb(I, c), e);
  return {
    ...l,
    data: (t = l.data) == null ? void 0 : t.data
  };
}
const Db = async (g, I) => lI.get(g, I);
function fs({
  queryKey: g,
  url: I,
  options: e,
  requestOptions: c
}) {
  var t;
  const l = Bg(g, () => Db(I, c), e);
  return {
    ...l,
    data: (t = l.data) == null ? void 0 : t.data
  };
}
const DI = () => typeof window < "u", Ts = () => typeof document < "u", zs = () => typeof window < "u", kb = (g) => {
  if (typeof window > "u")
    return "";
  try {
    return new URLSearchParams(window.location.search).get(g) ?? "";
  } catch {
    return "";
  }
}, Mb = (g) => new URL(g).hostname.split(".").slice(-2).join("."), Qb = (g) => {
  try {
    const I = Mb(PI);
    if (!I)
      return !1;
    const e = new URL(g).hostname;
    return e === I || e.endsWith(`.${I}`);
  } catch {
    return !1;
  }
}, tI = (g) => g.replace(/^\/(ko|en|ja|vi)(\/|$)/, "/"), L = {
  COURSES: (g) => g === "/courses" || g.startsWith("/courses/") || g.startsWith("/course/"),
  CHALLENGES: (g) => g.startsWith("/challenges") || g.startsWith("/challenge"),
  MENTORING: (g, I) => I === jg || g.startsWith("/mentors"),
  ROADMAPS: (g) => g.startsWith("/roadmaps"),
  SEARCH: (g) => g.startsWith("/search"),
  CLIPS: (g) => g.startsWith("/clips") || g.startsWith("/clip"),
  COMMUNITY: (g) => g.startsWith("/community")
}, zc = {
  COURSES: (g) => g === "/" || g === "/courses" || g.startsWith("/courses/"),
  CHALLENGES: (g) => g === "/challenges",
  MENTORING: (g) => g === "/mentors",
  ROADMAPS: (g) => g === "/roadmaps",
  SEARCH: (g) => g === "/search",
  CLIPS: (g) => g === "/clips",
  COMMUNITY: (g) => g === "/community"
}, Ss = () => {
  if (!DI())
    return !1;
  const g = window.location.pathname, I = tI(g);
  return Object.values(zc).some((e) => e(I));
}, Kb = (g) => {
  const I = tI(g);
  return Object.values(zc).some((e) => e(I));
}, xe = (g) => {
  if (!DI())
    return !1;
  const I = window.location.pathname, e = window.location.origin, c = tI(I);
  return Qb(e) ? e === jg ? g === "MENTORING" : g === "COURSES" ? L.COURSES(c) : g === "ROADMAPS" ? L.ROADMAPS(c) : g === "CLIPS" ? L.CLIPS(c) : g === "CHALLENGES" ? L.CHALLENGES(c) : g === "COMMUNITY" ? L.COMMUNITY(c) : !1 : !1;
}, Us = () => {
  if (!DI())
    return "COURSES";
  const g = window.location.pathname, I = window.location.origin, e = kb("types"), c = tI(g);
  return L.ROADMAPS(c) ? "ROADMAPS" : L.CHALLENGES(c) ? "CHALLENGES" : L.MENTORING(c, I) ? "MENTORING" : L.CLIPS(c) ? "CLIPS" : e === "CHALLENGE" ? "CHALLENGES" : L.COMMUNITY(c) ? "COMMUNITY" : "COURSES";
}, Hg = "gnb_snapshot", Sc = {
  COURSES: "courses",
  // 강의 메뉴
  ROADMAPS: "roadmaps",
  // 로드맵 메뉴
  MENTORING: "mentoring",
  // 멘토링 메뉴
  COMMUNITY: "community",
  // 커뮤니티 메뉴
  CHALLENGES: "challenges",
  // 챌린지 메뉴
  INSTRUCTOR: "instructor",
  // 강사 메뉴
  BUSINESS: "business",
  // 비즈니스 메뉴
  clips: "clips"
  // 클립 메뉴
}, kg = {
  SHOW_MENU: "data-show-menu",
  // 메뉴 표시 여부 (예: data-show-menu-courses="1")
  LABEL: "data-label",
  // 메뉴 라벨 텍스트 (예: data-label-courses="강의")
  SHOW_BUTTON: "data-show-button",
  // 버튼 표시 여부 (예: data-show-button-profile="1")
  COUNT: "data-count",
  // 카운트 값 (예: data-count-cart="3")
  FEATURE: "data-feature",
  // A/B 테스트 플래그 (예: data-feature-196="1")
  SHOW_SEARCH_BAR: "data-show-search-bar"
  // 검색바 표시 여부 (예: data-show-search-bar="1")
}, xI = {
  LABEL: "--label",
  // 메뉴 라벨 (예: --label-courses: "강의")
  CART_COUNT: "--cart-count",
  // 장바구니 개수 (예: --cart-count: "3")
  GNB_LOGO_URL: "--gnb-logo-url",
  // GNB 로고 이미지 (예: --gnb-logo-url: url('logo.png'))
  PROFILE_THUMBNAIL_URL: "--profile-thumbnail-url"
  // 프로필 썸네일 (예: --profile-thumbnail-url: url('thumb.jpg'))
};
function Re(g) {
  const I = {};
  return g && g.split(";").forEach((e) => {
    const c = e.indexOf("=");
    if (c < 0)
      return;
    const l = decodeURIComponent(e.slice(0, c).trim()), t = decodeURIComponent(e.slice(c + 1).trim());
    l && (I[l] = t);
  }), I;
}
function _b(g) {
  return (g == null ? void 0 : g.cookieHeader) != null ? Re(g.cookieHeader) : typeof document < "u" ? Re(document.cookie) : {};
}
function qb(g) {
  if (g)
    try {
      return JSON.parse(g);
    } catch {
      return;
    }
}
const $b = (g) => g ? `url('${g.replace(/'/g, "\\'")}')` : "none", Je = (g) => g ? "1" : "0", gC = (g) => g == null || g === "" ? "0" : "1", IC = (g) => (g ?? "").toString(), Uc = (g) => `'${(g ?? "").replace(/'/g, "\\'")}'`, eC = (g, I) => {
  const e = {}, c = {};
  return Object.values(Sc).forEach((l) => {
    const t = g[l], i = l === "courses" || I;
    e[`${kg.SHOW_MENU}-${l}`] = i ? gC(t) : "0", c[`${kg.LABEL}-${l}`] = IC(t);
  }), {
    visibilityAttributes: e,
    labelAttributes: c
  };
}, cC = (g) => {
  const I = {};
  return Object.values(Sc).forEach((e) => {
    const c = g[e];
    I[`${xI.LABEL}-${e}`] = Uc(c);
  }), I;
};
function lC(g, I) {
  const e = {
    attrs: {},
    cssVars: {}
  };
  if (!g)
    return e;
  const c = g.menuList || {}, l = g.lang === "ko", {
    visibilityAttributes: t,
    labelAttributes: i
  } = eC(c, l), n = cC(c);
  Object.assign(e.cssVars, n), e.cssVars[`${xI.LABEL}-language`] = Uc(g.lang), Object.assign(e.attrs, t, i);
  const C = I != null && I.pathname ? Kb(I.pathname) : !1;
  if (e.attrs[kg.SHOW_SEARCH_BAR] = Je(C), g.hackleFeatures)
    for (const [b, a] of Object.entries(g.hackleFeatures))
      e.attrs[`${kg.FEATURE}-${b}`] = Je(!!a);
  return e.cssVars[xI.GNB_LOGO_URL] = $b(g.logo), e;
}
function Hs(g) {
  const I = _b(g), e = qb(I[Hg]), c = g != null && g.overwrite ? Nc({}, e, g.overwrite) : e;
  return lC(c, {
    pathname: g == null ? void 0 : g.pathname
  });
}
function ws(g, I = "html", e = !1) {
  if (typeof document > "u")
    return e;
  const l = (I === "html" ? document.documentElement : I === "body" ? document.body : document.querySelector(I) || document.documentElement).getAttribute(g);
  return l === null ? e : l === "1" || l === "true" || l === "True";
}
function Ls(g, I = "html", e = "") {
  if (typeof document > "u")
    return e;
  const l = (I === "html" ? document.documentElement : I === "body" ? document.body : document.querySelector(I) || document.documentElement).getAttribute(g);
  return l === null ? e : l;
}
function Os(g, I = "html") {
  if (typeof document > "u")
    return;
  const e = I === "html" ? document.documentElement : I === "body" ? document.body : document.querySelector(I) || document.documentElement;
  Object.entries(g.attrs).forEach(([c, l]) => e.setAttribute(c, l)), Object.entries(g.cssVars).forEach(([c, l]) => e.style.setProperty(c, l));
}
function tC(g) {
  return g / (24 * 60);
}
const iC = 60 * 24, nC = () => {
  const g = wg((e) => {
    const c = I(), l = typeof document < "u" && document.documentElement.lang || "ko", t = {
      ...e,
      lang: l
    };
    Ug.set(Hg, JSON.stringify(Nc({}, c, t)), tC(iC), "High");
  }, []), I = wg(() => {
    const e = Ug.get(Hg);
    if (!e)
      return null;
    try {
      return JSON.parse(e);
    } catch (c) {
      return console.error("Failed to parse GNB Snapshot:", c), Ug.remove(Hg), null;
    }
  }, []);
  return {
    setSnapshot: g,
    getSnapshot: I
  };
}, RI = (g) => !!g.group || !!g.managedGroup, bC = (g) => !!g.group, CC = (g) => !!g.managedGroup, aC = (g) => !!g.marketingPartner, sC = 42, AC = 6233, Es = (g) => g === AC || g === sC, kI = Ob, JI = {
  CLIENT_V2_ACCOUNTS_PROFILE: "/client/api/v2/accounts/profile",
  CLIENT_V2_AUTH_SIGNIN: "/client/api/v2/auth/signin",
  CLIENT_V3_AUTH_SIGNUP_VERIFY_EMAIL: "/client/api/v3/auth/signup/verify/email"
};
function Ps({
  url: g,
  options: I,
  requestOptions: e
}) {
  var l;
  const c = cc({
    mutationFn: (t) => kI.post(g, t, e),
    ...I
  });
  return {
    ...c,
    data: (l = c.data) == null ? void 0 : l.data
  };
}
function js({
  url: g,
  options: I,
  requestOptions: e
}) {
  var l;
  const c = cc({
    mutationFn: (t) => kI.post(g, t, e),
    ...I
  });
  return {
    ...c,
    data: (l = c.data) == null ? void 0 : l.data
  };
}
const uC = async (g, I) => kI.get(g, I), rC = ({
  queryKey: g,
  url: I,
  options: e,
  requestOptions: c
}) => ({
  queryKey: g,
  queryFn: () => uC(I, c),
  ...e
});
function dC(g) {
  var e;
  const I = Bg(rC(g));
  return {
    ...I,
    data: (e = I.data) == null ? void 0 : e.data
  };
}
const Ds = (g) => g * (24 * (60 * (1e3 * 60))), ks = (g) => g * 1e3, ye = (g) => g * (1e3 * 60);
function oC(g) {
  const I = g == null ? void 0 : g.options;
  return dC({
    queryKey: [JI.CLIENT_V2_ACCOUNTS_PROFILE],
    url: JI.CLIENT_V2_ACCOUNTS_PROFILE,
    options: {
      cacheTime: ye(1),
      staleTime: ye(1),
      suspense: !1,
      useErrorBoundary: !1,
      keepPreviousData: !0,
      refetchOnReconnect: !0,
      ...I
    }
  });
}
const Hc = YI(null), Ms = (g) => /* @__PURE__ */ h(Hc.Provider, { value: {
  isShowing: g.isShowing
}, children: g.children }), GC = () => {
  const g = fI(Hc);
  if (!g)
    throw Error("useShowLoginNeededNotificationContext must use in ShowLoginNeededNotificationContext");
  return g;
};
function XC(g) {
  const {
    isShowing: I
  } = GC(), {
    showNotification: e
  } = tl(), {
    t: c
  } = Fc();
  eg(() => {
    g instanceof Zg && g.statusCode === Tc.UNAUTHORIZED && I && (il("UNAUTHORIZED"), e({
      type: "error",
      id: "UNAUTHORIZED",
      title: c("로그인이 필요한 요청입니다.")
    }));
  }, [I, g]);
}
var wc = {}, ZC = (g) => encodeURIComponent(g).replace(/[!'()*]/g, (I) => `%${I.charCodeAt(0).toString(16).toUpperCase()}`), Lc = "%[a-f0-9]{2}", pe = new RegExp("(" + Lc + ")|([^%]+?)", "gi"), Be = new RegExp("(" + Lc + ")+", "gi");
function yI(g, I) {
  try {
    return [decodeURIComponent(g.join(""))];
  } catch {
  }
  if (g.length === 1)
    return g;
  I = I || 1;
  var e = g.slice(0, I), c = g.slice(I);
  return Array.prototype.concat.call([], yI(e), yI(c));
}
function hC(g) {
  try {
    return decodeURIComponent(g);
  } catch {
    for (var I = g.match(pe) || [], e = 1; e < I.length; e++)
      g = yI(I, e).join(""), I = g.match(pe) || [];
    return g;
  }
}
function VC(g) {
  for (var I = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  }, e = Be.exec(g); e; ) {
    try {
      I[e[0]] = decodeURIComponent(e[0]);
    } catch {
      var c = hC(e[0]);
      c !== e[0] && (I[e[0]] = c);
    }
    e = Be.exec(g);
  }
  I["%C2"] = "�";
  for (var l = Object.keys(I), t = 0; t < l.length; t++) {
    var i = l[t];
    g = g.replace(new RegExp(i, "g"), I[i]);
  }
  return g;
}
var WC = function(g) {
  if (typeof g != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof g + "`");
  try {
    return g = g.replace(/\+/g, " "), decodeURIComponent(g);
  } catch {
    return VC(g);
  }
}, mC = (g, I) => {
  if (!(typeof g == "string" && typeof I == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (I === "")
    return [g];
  const e = g.indexOf(I);
  return e === -1 ? [g] : [
    g.slice(0, e),
    g.slice(e + I.length)
  ];
}, NC = function(g, I) {
  for (var e = {}, c = Object.keys(g), l = Array.isArray(I), t = 0; t < c.length; t++) {
    var i = c[t], n = g[i];
    (l ? I.indexOf(i) !== -1 : I(i, n, g)) && (e[i] = n);
  }
  return e;
};
(function(g) {
  const I = ZC, e = WC, c = mC, l = NC, t = (s) => s == null, i = Symbol("encodeFragmentIdentifier");
  function n(s) {
    switch (s.arrayFormat) {
      case "index":
        return (d) => (r, o) => {
          const X = r.length;
          return o === void 0 || s.skipNull && o === null || s.skipEmptyString && o === "" ? r : o === null ? [...r, [a(d, s), "[", X, "]"].join("")] : [
            ...r,
            [a(d, s), "[", a(X, s), "]=", a(o, s)].join("")
          ];
        };
      case "bracket":
        return (d) => (r, o) => o === void 0 || s.skipNull && o === null || s.skipEmptyString && o === "" ? r : o === null ? [...r, [a(d, s), "[]"].join("")] : [...r, [a(d, s), "[]=", a(o, s)].join("")];
      case "colon-list-separator":
        return (d) => (r, o) => o === void 0 || s.skipNull && o === null || s.skipEmptyString && o === "" ? r : o === null ? [...r, [a(d, s), ":list="].join("")] : [...r, [a(d, s), ":list=", a(o, s)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const d = s.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (r) => (o, X) => X === void 0 || s.skipNull && X === null || s.skipEmptyString && X === "" ? o : (X = X === null ? "" : X, o.length === 0 ? [[a(r, s), d, a(X, s)].join("")] : [[o, a(X, s)].join(s.arrayFormatSeparator)]);
      }
      default:
        return (d) => (r, o) => o === void 0 || s.skipNull && o === null || s.skipEmptyString && o === "" ? r : o === null ? [...r, a(d, s)] : [...r, [a(d, s), "=", a(o, s)].join("")];
    }
  }
  function C(s) {
    let d;
    switch (s.arrayFormat) {
      case "index":
        return (r, o, X) => {
          if (d = /\[(\d*)\]$/.exec(r), r = r.replace(/\[\d*\]$/, ""), !d) {
            X[r] = o;
            return;
          }
          X[r] === void 0 && (X[r] = {}), X[r][d[1]] = o;
        };
      case "bracket":
        return (r, o, X) => {
          if (d = /(\[\])$/.exec(r), r = r.replace(/\[\]$/, ""), !d) {
            X[r] = o;
            return;
          }
          if (X[r] === void 0) {
            X[r] = [o];
            return;
          }
          X[r] = [].concat(X[r], o);
        };
      case "colon-list-separator":
        return (r, o, X) => {
          if (d = /(:list)$/.exec(r), r = r.replace(/:list$/, ""), !d) {
            X[r] = o;
            return;
          }
          if (X[r] === void 0) {
            X[r] = [o];
            return;
          }
          X[r] = [].concat(X[r], o);
        };
      case "comma":
      case "separator":
        return (r, o, X) => {
          const m = typeof o == "string" && o.includes(s.arrayFormatSeparator), V = typeof o == "string" && !m && u(o, s).includes(s.arrayFormatSeparator);
          o = V ? u(o, s) : o;
          const J = m || V ? o.split(s.arrayFormatSeparator).map((S) => u(S, s)) : o === null ? o : u(o, s);
          X[r] = J;
        };
      case "bracket-separator":
        return (r, o, X) => {
          const m = /(\[\])$/.test(r);
          if (r = r.replace(/\[\]$/, ""), !m) {
            X[r] = o && u(o, s);
            return;
          }
          const V = o === null ? [] : o.split(s.arrayFormatSeparator).map((J) => u(J, s));
          if (X[r] === void 0) {
            X[r] = V;
            return;
          }
          X[r] = [].concat(X[r], V);
        };
      default:
        return (r, o, X) => {
          if (X[r] === void 0) {
            X[r] = o;
            return;
          }
          X[r] = [].concat(X[r], o);
        };
    }
  }
  function b(s) {
    if (typeof s != "string" || s.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function a(s, d) {
    return d.encode ? d.strict ? I(s) : encodeURIComponent(s) : s;
  }
  function u(s, d) {
    return d.decode ? e(s) : s;
  }
  function A(s) {
    return Array.isArray(s) ? s.sort() : typeof s == "object" ? A(Object.keys(s)).sort((d, r) => Number(d) - Number(r)).map((d) => s[d]) : s;
  }
  function G(s) {
    const d = s.indexOf("#");
    return d !== -1 && (s = s.slice(0, d)), s;
  }
  function N(s) {
    let d = "";
    const r = s.indexOf("#");
    return r !== -1 && (d = s.slice(r)), d;
  }
  function W(s) {
    s = G(s);
    const d = s.indexOf("?");
    return d === -1 ? "" : s.slice(d + 1);
  }
  function R(s, d) {
    return d.parseNumbers && !Number.isNaN(Number(s)) && typeof s == "string" && s.trim() !== "" ? s = Number(s) : d.parseBooleans && s !== null && (s.toLowerCase() === "true" || s.toLowerCase() === "false") && (s = s.toLowerCase() === "true"), s;
  }
  function p(s, d) {
    d = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, d), b(d.arrayFormatSeparator);
    const r = C(d), o = /* @__PURE__ */ Object.create(null);
    if (typeof s != "string" || (s = s.trim().replace(/^[?#&]/, ""), !s))
      return o;
    for (const X of s.split("&")) {
      if (X === "")
        continue;
      let [m, V] = c(d.decode ? X.replace(/\+/g, " ") : X, "=");
      V = V === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(d.arrayFormat) ? V : u(V, d), r(u(m, d), V, o);
    }
    for (const X of Object.keys(o)) {
      const m = o[X];
      if (typeof m == "object" && m !== null)
        for (const V of Object.keys(m))
          m[V] = R(m[V], d);
      else
        o[X] = R(m, d);
    }
    return d.sort === !1 ? o : (d.sort === !0 ? Object.keys(o).sort() : Object.keys(o).sort(d.sort)).reduce((X, m) => {
      const V = o[m];
      return V && typeof V == "object" && !Array.isArray(V) ? X[m] = A(V) : X[m] = V, X;
    }, /* @__PURE__ */ Object.create(null));
  }
  g.extract = W, g.parse = p, g.stringify = (s, d) => {
    if (!s)
      return "";
    d = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, d), b(d.arrayFormatSeparator);
    const r = (V) => d.skipNull && t(s[V]) || d.skipEmptyString && s[V] === "", o = n(d), X = {};
    for (const V of Object.keys(s))
      r(V) || (X[V] = s[V]);
    const m = Object.keys(X);
    return d.sort !== !1 && m.sort(d.sort), m.map((V) => {
      const J = s[V];
      return J === void 0 ? "" : J === null ? a(V, d) : Array.isArray(J) ? J.length === 0 && d.arrayFormat === "bracket-separator" ? a(V, d) + "[]" : J.reduce(o(V), []).join("&") : a(V, d) + "=" + a(J, d);
    }).filter((V) => V.length > 0).join("&");
  }, g.parseUrl = (s, d) => {
    d = Object.assign({
      decode: !0
    }, d);
    const [r, o] = c(s, "#");
    return Object.assign(
      {
        url: r.split("?")[0] || "",
        query: p(W(s), d)
      },
      d && d.parseFragmentIdentifier && o ? { fragmentIdentifier: u(o, d) } : {}
    );
  }, g.stringifyUrl = (s, d) => {
    d = Object.assign({
      encode: !0,
      strict: !0,
      [i]: !0
    }, d);
    const r = G(s.url).split("?")[0] || "", o = g.extract(s.url), X = g.parse(o, { sort: !1 }), m = Object.assign(X, s.query);
    let V = g.stringify(m, d);
    V && (V = `?${V}`);
    let J = N(s.url);
    return s.fragmentIdentifier && (J = `#${d[i] ? a(s.fragmentIdentifier, d) : s.fragmentIdentifier}`), `${r}${V}${J}`;
  }, g.pick = (s, d, r) => {
    r = Object.assign({
      parseFragmentIdentifier: !0,
      [i]: !1
    }, r);
    const { url: o, query: X, fragmentIdentifier: m } = g.parseUrl(s, r);
    return g.stringifyUrl({
      url: o,
      query: l(X, d),
      fragmentIdentifier: m
    }, r);
  }, g.exclude = (s, d, r) => {
    const o = Array.isArray(d) ? (X) => !d.includes(X) : (X, m) => !d(X, m);
    return g.pick(s, o, r);
  };
})(wc);
const D = /* @__PURE__ */ Jc(wc), xC = {
  CLICK_SEARCHBAR: "click_searchbar",
  GNB_NOTI_ICON_CLICK: "GNB_noti-icon-click",
  GNB_ROADMAP_CLICK: "GNB_roadmap-click",
  GNB_PROFILE_ICON_CLICK: "GNB_profile-icon-click",
  GNB_OPENKNOWLEDGE_CLICK: "GNB_openknowledge-click",
  GNB_MENTORS_CLICK: "GNB_mentors-click",
  GNB_LOGIN_BTN_CLICK: "GNB_login-btn-click",
  CLICK_CATEGORY_AT_HEADER: "click_category_at_header",
  VIEW_SIGNIN_MODAL: "view_signin_modal",
  CLICK_SIGNIN_AT_SIGNIN: "click_signin_at_signin",
  CLICK_FIND_ID_AT_SIGNIN: "click_find_id_at_signin",
  CLICK_FIND_PW_AT_SIGNIN: "click_find_pw_at_signin",
  CLICK_SIGNUP_AT_SIGNIN: "click_signup_at_signin",
  /**
   * @deprecated 헤더 '인프런' 메뉴 deprecated
   * */
  GNB_COURSES_CLICK: "GNB_courses-click",
  GNB_COMMUNITY_CLICK: "GNB_community-click",
  GNB_CART_COURSE_CLICK: "GNB_cart-course-click",
  GNB_CART_TOTAL_CLICK: "GNB_cart-total-click",
  GNB_INFLEARN_LOGO_CLICK: "GNB_inflearn-logo-click",
  GNB_CART_ICON_CLICK: "GNB_cart-icon-click",
  GNB_RALLIT_CLICK: "GNB_Rallit_Click",
  GNB_SEARCH_ICON_CLICK: "GNB_search-icon-click",
  GNB_SEARCH_INPUT_CLICK: "GNB_search-input-click",
  GNB_DASHBOARD_CLICK: "GNB_dashboard-click",
  HEADER_BUSINESS_CLICK: "Header_business-click",
  HEADER_INFLEARN_CLICK: "Header_inflearn-click",
  HEADER_INSTRUCTOR_CLICK: "Header_instructor-click",
  HEADER_BIZ_INTRO_CLICK: "header_biz-intro-click",
  COMPLETE_SIGNUP: "complete_signup",
  COMPLETE_REGISTRATION: "complete_registration",
  CLICK_WELCOME_BUTTON: "click_welcome_button",
  CLICK_MYCATEGORY_GUIDE_BUTTON: "click_mycategory_guide_button",
  VIEW_MYCATEGORY: "view_mycategory",
  CLICK_SAVE_MYCATEGORY: "click_save_mycategory",
  SEARCH_COURSE: "search_course",
  EXPERIMENT_STARTED: "experiment_started",
  /**
   * 신규 헤더 신규 이벤트
   */
  CLICK_HEADER_MENU: "click_header_menu",
  CLICK_LOGO_AT_HEADER: "click_logo_at_header",
  CLICK_LOGIN_AT_HEADER: "click_login_at_header",
  CLICK_CART_AT_HEADER: "click_cart_at_header",
  CLICK_PROFILE_MENU_AT_HEADER: "click_profile_menu_at_header",
  CLICK_CATEGORY_AT_SEARCHBAR: "click_category_at_searchbar",
  CLICK_HEADER_MENU_AT_SEARCHBAR: "click_header_menu_at_searchbar",
  CLICK_RECOMMENDATION_AT_SEARCHBAR: "click_recommendation_at_searchbar",
  CLICK_HEADER_NOTICE: "click_header_notice",
  CLICK_SERVICE_MENU_AT_HEADER: "click_service_menu_at_header"
};
var Ig = { ko: "ko", en: "en", ja: "ja", vi: "vi" }, cg = Ig.ko;
Object.values(Ig);
var RC = { [Ig.ko]: "82", [Ig.en]: "1", [Ig.ja]: "81", [Ig.vi]: "84" }, f = { ko: "ko-KR", en: "en-US", ja: "ja-JP", vi: "vi-VN" };
function JC() {
  let { i18n: g } = vc();
  return Lg(() => {
    let I = g.language || cg;
    return { lang: I, locale: f[I], countryCode: RC[I], isKo: I === cg };
  }, [g.language]);
}
var Qs = ({ children: g }) => {
  let { isKo: I } = JC();
  return Ic(ec, { children: I && g });
};
SI.extend(Al);
SI.extend(sl);
SI.updateLocale("ko", { formats: { L: "YYYY. MM. DD.", LL: "YYYY년 MM월 DD일", LT: "A h:mm" } });
var hg = { [f.ko]: "KRW", [f.en]: "USD", [f.ja]: "JPY", [f.vi]: "VND" }, yC = { [hg[f.ko]]: f.ko, [hg[f.en]]: f.en, [hg[f.ja]]: f.ja, [hg[f.vi]]: f.vi }, pC = (g, I) => new Intl.NumberFormat(g, { style: "currency", currency: I }), BC = ({ locale: g, amount: I, currency: e, hiddenKRW: c = !1, leftSection: l = "", rightSection: t = "", ...i }) => {
  let n = g ?? yC[e ?? f.ko], C = e ?? hg[n], b = Lg(() => pC(n, C), [n, C]), a = Lg(() => c && g === f.ko ? I.toLocaleString() : b.format(Number(I)), [g, b, I, c]);
  return Ic(BI, { ...i, children: al(ec, { children: [l, a, t] }) });
};
nl(BC);
const x = (g) => typeof g == "string", dg = () => {
  let g, I;
  const e = new Promise((c, l) => {
    g = c, I = l;
  });
  return e.resolve = g, e.reject = I, e;
}, ve = (g) => g == null ? "" : "" + g, vC = (g, I, e) => {
  g.forEach((c) => {
    I[c] && (e[c] = I[c]);
  });
}, FC = /###/g, Fe = (g) => g && g.indexOf("###") > -1 ? g.replace(FC, ".") : g, Ye = (g) => !g || x(g), Wg = (g, I, e) => {
  const c = x(I) ? I.split(".") : I;
  let l = 0;
  for (; l < c.length - 1; ) {
    if (Ye(g))
      return {};
    const t = Fe(c[l]);
    !g[t] && e && (g[t] = new e()), Object.prototype.hasOwnProperty.call(g, t) ? g = g[t] : g = {}, ++l;
  }
  return Ye(g) ? {} : {
    obj: g,
    k: Fe(c[l])
  };
}, fe = (g, I, e) => {
  const {
    obj: c,
    k: l
  } = Wg(g, I, Object);
  if (c !== void 0 || I.length === 1) {
    c[l] = e;
    return;
  }
  let t = I[I.length - 1], i = I.slice(0, I.length - 1), n = Wg(g, i, Object);
  for (; n.obj === void 0 && i.length; )
    t = `${i[i.length - 1]}.${t}`, i = i.slice(0, i.length - 1), n = Wg(g, i, Object), n && n.obj && typeof n.obj[`${n.k}.${t}`] < "u" && (n.obj = void 0);
  n.obj[`${n.k}.${t}`] = e;
}, YC = (g, I, e, c) => {
  const {
    obj: l,
    k: t
  } = Wg(g, I, Object);
  l[t] = l[t] || [], l[t].push(e);
}, Mg = (g, I) => {
  const {
    obj: e,
    k: c
  } = Wg(g, I);
  if (e)
    return e[c];
}, fC = (g, I, e) => {
  const c = Mg(g, e);
  return c !== void 0 ? c : Mg(I, e);
}, Oc = (g, I, e) => {
  for (const c in I)
    c !== "__proto__" && c !== "constructor" && (c in g ? x(g[c]) || g[c] instanceof String || x(I[c]) || I[c] instanceof String ? e && (g[c] = I[c]) : Oc(g[c], I[c], e) : g[c] = I[c]);
  return g;
}, $ = (g) => g.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var TC = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const zC = (g) => x(g) ? g.replace(/[&<>"'\/]/g, (I) => TC[I]) : g;
class SC {
  constructor(I) {
    this.capacity = I, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(I) {
    const e = this.regExpMap.get(I);
    if (e !== void 0)
      return e;
    const c = new RegExp(I);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(I, c), this.regExpQueue.push(I), c;
  }
}
const UC = [" ", ",", "?", "!", ";"], HC = new SC(20), wC = (g, I, e) => {
  I = I || "", e = e || "";
  const c = UC.filter((i) => I.indexOf(i) < 0 && e.indexOf(i) < 0);
  if (c.length === 0)
    return !0;
  const l = HC.getRegExp(`(${c.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let t = !l.test(g);
  if (!t) {
    const i = g.indexOf(e);
    i > 0 && !l.test(g.substring(0, i)) && (t = !0);
  }
  return t;
}, pI = function(g, I) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!g)
    return;
  if (g[I])
    return g[I];
  const c = I.split(e);
  let l = g;
  for (let t = 0; t < c.length; ) {
    if (!l || typeof l != "object")
      return;
    let i, n = "";
    for (let C = t; C < c.length; ++C)
      if (C !== t && (n += e), n += c[C], i = l[n], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && C < c.length - 1)
          continue;
        t += C - t + 1;
        break;
      }
    l = i;
  }
  return l;
}, Qg = (g) => g && g.replace("_", "-"), LC = {
  type: "logger",
  log(g) {
    this.output("log", g);
  },
  warn(g) {
    this.output("warn", g);
  },
  error(g) {
    this.output("error", g);
  },
  output(g, I) {
    console && console[g] && console[g].apply(console, I);
  }
};
class Kg {
  constructor(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(I, e);
  }
  init(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = e.prefix || "i18next:", this.logger = I || LC, this.options = e, this.debug = e.debug;
  }
  log() {
    for (var I = arguments.length, e = new Array(I), c = 0; c < I; c++)
      e[c] = arguments[c];
    return this.forward(e, "log", "", !0);
  }
  warn() {
    for (var I = arguments.length, e = new Array(I), c = 0; c < I; c++)
      e[c] = arguments[c];
    return this.forward(e, "warn", "", !0);
  }
  error() {
    for (var I = arguments.length, e = new Array(I), c = 0; c < I; c++)
      e[c] = arguments[c];
    return this.forward(e, "error", "");
  }
  deprecate() {
    for (var I = arguments.length, e = new Array(I), c = 0; c < I; c++)
      e[c] = arguments[c];
    return this.forward(e, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(I, e, c, l) {
    return l && !this.debug ? null : (x(I[0]) && (I[0] = `${c}${this.prefix} ${I[0]}`), this.logger[e](I));
  }
  create(I) {
    return new Kg(this.logger, {
      prefix: `${this.prefix}:${I}:`,
      ...this.options
    });
  }
  clone(I) {
    return I = I || this.options, I.prefix = I.prefix || this.prefix, new Kg(this.logger, I);
  }
}
var O = new Kg();
class iI {
  constructor() {
    this.observers = {};
  }
  on(I, e) {
    return I.split(" ").forEach((c) => {
      this.observers[c] || (this.observers[c] = /* @__PURE__ */ new Map());
      const l = this.observers[c].get(e) || 0;
      this.observers[c].set(e, l + 1);
    }), this;
  }
  off(I, e) {
    if (this.observers[I]) {
      if (!e) {
        delete this.observers[I];
        return;
      }
      this.observers[I].delete(e);
    }
  }
  emit(I) {
    for (var e = arguments.length, c = new Array(e > 1 ? e - 1 : 0), l = 1; l < e; l++)
      c[l - 1] = arguments[l];
    this.observers[I] && Array.from(this.observers[I].entries()).forEach((i) => {
      let [n, C] = i;
      for (let b = 0; b < C; b++)
        n(...c);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((i) => {
      let [n, C] = i;
      for (let b = 0; b < C; b++)
        n.apply(n, [I, ...c]);
    });
  }
}
class Te extends iI {
  constructor(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = I || {}, this.options = e, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(I) {
    this.options.ns.indexOf(I) < 0 && this.options.ns.push(I);
  }
  removeNamespaces(I) {
    const e = this.options.ns.indexOf(I);
    e > -1 && this.options.ns.splice(e, 1);
  }
  getResource(I, e, c) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const t = l.keySeparator !== void 0 ? l.keySeparator : this.options.keySeparator, i = l.ignoreJSONStructure !== void 0 ? l.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let n;
    I.indexOf(".") > -1 ? n = I.split(".") : (n = [I, e], c && (Array.isArray(c) ? n.push(...c) : x(c) && t ? n.push(...c.split(t)) : n.push(c)));
    const C = Mg(this.data, n);
    return !C && !e && !c && I.indexOf(".") > -1 && (I = n[0], e = n[1], c = n.slice(2).join(".")), C || !i || !x(c) ? C : pI(this.data && this.data[I] && this.data[I][e], c, t);
  }
  addResource(I, e, c, l) {
    let t = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const i = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let n = [I, e];
    c && (n = n.concat(i ? c.split(i) : c)), I.indexOf(".") > -1 && (n = I.split("."), l = e, e = n[1]), this.addNamespaces(e), fe(this.data, n, l), t.silent || this.emit("added", I, e, c, l);
  }
  addResources(I, e, c) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const t in c)
      (x(c[t]) || Array.isArray(c[t])) && this.addResource(I, e, t, c[t], {
        silent: !0
      });
    l.silent || this.emit("added", I, e, c);
  }
  addResourceBundle(I, e, c, l, t) {
    let i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, n = [I, e];
    I.indexOf(".") > -1 && (n = I.split("."), l = c, c = e, e = n[1]), this.addNamespaces(e);
    let C = Mg(this.data, n) || {};
    i.skipCopy || (c = JSON.parse(JSON.stringify(c))), l ? Oc(C, c, t) : C = {
      ...C,
      ...c
    }, fe(this.data, n, C), i.silent || this.emit("added", I, e, c);
  }
  removeResourceBundle(I, e) {
    this.hasResourceBundle(I, e) && delete this.data[I][e], this.removeNamespaces(e), this.emit("removed", I, e);
  }
  hasResourceBundle(I, e) {
    return this.getResource(I, e) !== void 0;
  }
  getResourceBundle(I, e) {
    return e || (e = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(I, e)
    } : this.getResource(I, e);
  }
  getDataByLanguage(I) {
    return this.data[I];
  }
  hasLanguageSomeTranslations(I) {
    const e = this.getDataByLanguage(I);
    return !!(e && Object.keys(e) || []).find((l) => e[l] && Object.keys(e[l]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Ec = {
  processors: {},
  addPostProcessor(g) {
    this.processors[g.name] = g;
  },
  handle(g, I, e, c, l) {
    return g.forEach((t) => {
      this.processors[t] && (I = this.processors[t].process(I, e, c, l));
    }), I;
  }
};
const ze = {};
class _g extends iI {
  constructor(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), vC(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], I, this), this.options = e, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = O.create("translator");
  }
  changeLanguage(I) {
    I && (this.language = I);
  }
  exists(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (I == null)
      return !1;
    const c = this.resolve(I, e);
    return c && c.res !== void 0;
  }
  extractFromKey(I, e) {
    let c = e.nsSeparator !== void 0 ? e.nsSeparator : this.options.nsSeparator;
    c === void 0 && (c = ":");
    const l = e.keySeparator !== void 0 ? e.keySeparator : this.options.keySeparator;
    let t = e.ns || this.options.defaultNS || [];
    const i = c && I.indexOf(c) > -1, n = !this.options.userDefinedKeySeparator && !e.keySeparator && !this.options.userDefinedNsSeparator && !e.nsSeparator && !wC(I, c, l);
    if (i && !n) {
      const C = I.match(this.interpolator.nestingRegexp);
      if (C && C.length > 0)
        return {
          key: I,
          namespaces: t
        };
      const b = I.split(c);
      (c !== l || c === l && this.options.ns.indexOf(b[0]) > -1) && (t = b.shift()), I = b.join(l);
    }
    return x(t) && (t = [t]), {
      key: I,
      namespaces: t
    };
  }
  translate(I, e, c) {
    if (typeof e != "object" && this.options.overloadTranslationOptionHandler && (e = this.options.overloadTranslationOptionHandler(arguments)), typeof e == "object" && (e = {
      ...e
    }), e || (e = {}), I == null)
      return "";
    Array.isArray(I) || (I = [String(I)]);
    const l = e.returnDetails !== void 0 ? e.returnDetails : this.options.returnDetails, t = e.keySeparator !== void 0 ? e.keySeparator : this.options.keySeparator, {
      key: i,
      namespaces: n
    } = this.extractFromKey(I[I.length - 1], e), C = n[n.length - 1], b = e.lng || this.language, a = e.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (b && b.toLowerCase() === "cimode") {
      if (a) {
        const r = e.nsSeparator || this.options.nsSeparator;
        return l ? {
          res: `${C}${r}${i}`,
          usedKey: i,
          exactUsedKey: i,
          usedLng: b,
          usedNS: C,
          usedParams: this.getUsedParamsDetails(e)
        } : `${C}${r}${i}`;
      }
      return l ? {
        res: i,
        usedKey: i,
        exactUsedKey: i,
        usedLng: b,
        usedNS: C,
        usedParams: this.getUsedParamsDetails(e)
      } : i;
    }
    const u = this.resolve(I, e);
    let A = u && u.res;
    const G = u && u.usedKey || i, N = u && u.exactUsedKey || i, W = Object.prototype.toString.apply(A), R = ["[object Number]", "[object Function]", "[object RegExp]"], p = e.joinArrays !== void 0 ? e.joinArrays : this.options.joinArrays, s = !this.i18nFormat || this.i18nFormat.handleAsObject, d = !x(A) && typeof A != "boolean" && typeof A != "number";
    if (s && A && d && R.indexOf(W) < 0 && !(x(p) && Array.isArray(A))) {
      if (!e.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(G, A, {
          ...e,
          ns: n
        }) : `key '${i} (${this.language})' returned an object instead of string.`;
        return l ? (u.res = r, u.usedParams = this.getUsedParamsDetails(e), u) : r;
      }
      if (t) {
        const r = Array.isArray(A), o = r ? [] : {}, X = r ? N : G;
        for (const m in A)
          if (Object.prototype.hasOwnProperty.call(A, m)) {
            const V = `${X}${t}${m}`;
            o[m] = this.translate(V, {
              ...e,
              joinArrays: !1,
              ns: n
            }), o[m] === V && (o[m] = A[m]);
          }
        A = o;
      }
    } else if (s && x(p) && Array.isArray(A))
      A = A.join(p), A && (A = this.extendTranslation(A, I, e, c));
    else {
      let r = !1, o = !1;
      const X = e.count !== void 0 && !x(e.count), m = _g.hasDefaultValue(e), V = X ? this.pluralResolver.getSuffix(b, e.count, e) : "", J = e.ordinal && X ? this.pluralResolver.getSuffix(b, e.count, {
        ordinal: !1
      }) : "", S = X && !e.ordinal && e.count === 0 && this.pluralResolver.shouldUseIntlApi(), Y = S && e[`defaultValue${this.options.pluralSeparator}zero`] || e[`defaultValue${V}`] || e[`defaultValue${J}`] || e.defaultValue;
      !this.isValidLookup(A) && m && (r = !0, A = Y), this.isValidLookup(A) || (o = !0, A = i);
      const el = (e.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && o ? void 0 : A, sg = m && Y !== A && this.options.updateMissing;
      if (o || r || sg) {
        if (this.logger.log(sg ? "updateKey" : "missingKey", b, C, i, sg ? Y : A), t) {
          const U = this.resolve(i, {
            ...e,
            keySeparator: !1
          });
          U && U.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let Ag = [];
        const Fg = this.languageUtils.getFallbackCodes(this.options.fallbackLng, e.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Fg && Fg[0])
          for (let U = 0; U < Fg.length; U++)
            Ag.push(Fg[U]);
        else
          this.options.saveMissingTo === "all" ? Ag = this.languageUtils.toResolveHierarchy(e.lng || this.language) : Ag.push(e.lng || this.language);
        const $I = (U, M, ug) => {
          const ge = m && ug !== A ? ug : el;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(U, C, M, ge, sg, e) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(U, C, M, ge, sg, e), this.emit("missingKey", U, C, M, A);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && X ? Ag.forEach((U) => {
          const M = this.pluralResolver.getSuffixes(U, e);
          S && e[`defaultValue${this.options.pluralSeparator}zero`] && M.indexOf(`${this.options.pluralSeparator}zero`) < 0 && M.push(`${this.options.pluralSeparator}zero`), M.forEach((ug) => {
            $I([U], i + ug, e[`defaultValue${ug}`] || Y);
          });
        }) : $I(Ag, i, Y));
      }
      A = this.extendTranslation(A, I, e, u, c), o && A === i && this.options.appendNamespaceToMissingKey && (A = `${C}:${i}`), (o || r) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? A = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${C}:${i}` : i, r ? A : void 0) : A = this.options.parseMissingKeyHandler(A));
    }
    return l ? (u.res = A, u.usedParams = this.getUsedParamsDetails(e), u) : A;
  }
  extendTranslation(I, e, c, l, t) {
    var i = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      I = this.i18nFormat.parse(I, {
        ...this.options.interpolation.defaultVariables,
        ...c
      }, c.lng || this.language || l.usedLng, l.usedNS, l.usedKey, {
        resolved: l
      });
    else if (!c.skipInterpolation) {
      c.interpolation && this.interpolator.init({
        ...c,
        interpolation: {
          ...this.options.interpolation,
          ...c.interpolation
        }
      });
      const b = x(I) && (c && c.interpolation && c.interpolation.skipOnVariables !== void 0 ? c.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let a;
      if (b) {
        const A = I.match(this.interpolator.nestingRegexp);
        a = A && A.length;
      }
      let u = c.replace && !x(c.replace) ? c.replace : c;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), I = this.interpolator.interpolate(I, u, c.lng || this.language || l.usedLng, c), b) {
        const A = I.match(this.interpolator.nestingRegexp), G = A && A.length;
        a < G && (c.nest = !1);
      }
      !c.lng && this.options.compatibilityAPI !== "v1" && l && l.res && (c.lng = this.language || l.usedLng), c.nest !== !1 && (I = this.interpolator.nest(I, function() {
        for (var A = arguments.length, G = new Array(A), N = 0; N < A; N++)
          G[N] = arguments[N];
        return t && t[0] === G[0] && !c.context ? (i.logger.warn(`It seems you are nesting recursively key: ${G[0]} in key: ${e[0]}`), null) : i.translate(...G, e);
      }, c)), c.interpolation && this.interpolator.reset();
    }
    const n = c.postProcess || this.options.postProcess, C = x(n) ? [n] : n;
    return I != null && C && C.length && c.applyPostProcessor !== !1 && (I = Ec.handle(C, I, e, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...l,
        usedParams: this.getUsedParamsDetails(c)
      },
      ...c
    } : c, this)), I;
  }
  resolve(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c, l, t, i, n;
    return x(I) && (I = [I]), I.forEach((C) => {
      if (this.isValidLookup(c))
        return;
      const b = this.extractFromKey(C, e), a = b.key;
      l = a;
      let u = b.namespaces;
      this.options.fallbackNS && (u = u.concat(this.options.fallbackNS));
      const A = e.count !== void 0 && !x(e.count), G = A && !e.ordinal && e.count === 0 && this.pluralResolver.shouldUseIntlApi(), N = e.context !== void 0 && (x(e.context) || typeof e.context == "number") && e.context !== "", W = e.lngs ? e.lngs : this.languageUtils.toResolveHierarchy(e.lng || this.language, e.fallbackLng);
      u.forEach((R) => {
        this.isValidLookup(c) || (n = R, !ze[`${W[0]}-${R}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(n) && (ze[`${W[0]}-${R}`] = !0, this.logger.warn(`key "${l}" for languages "${W.join(", ")}" won't get resolved as namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), W.forEach((p) => {
          if (this.isValidLookup(c))
            return;
          i = p;
          const s = [a];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(s, a, p, R, e);
          else {
            let r;
            A && (r = this.pluralResolver.getSuffix(p, e.count, e));
            const o = `${this.options.pluralSeparator}zero`, X = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (A && (s.push(a + r), e.ordinal && r.indexOf(X) === 0 && s.push(a + r.replace(X, this.options.pluralSeparator)), G && s.push(a + o)), N) {
              const m = `${a}${this.options.contextSeparator}${e.context}`;
              s.push(m), A && (s.push(m + r), e.ordinal && r.indexOf(X) === 0 && s.push(m + r.replace(X, this.options.pluralSeparator)), G && s.push(m + o));
            }
          }
          let d;
          for (; d = s.pop(); )
            this.isValidLookup(c) || (t = d, c = this.getResource(p, R, d, e));
        }));
      });
    }), {
      res: c,
      usedKey: l,
      exactUsedKey: t,
      usedLng: i,
      usedNS: n
    };
  }
  isValidLookup(I) {
    return I !== void 0 && !(!this.options.returnNull && I === null) && !(!this.options.returnEmptyString && I === "");
  }
  getResource(I, e, c) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(I, e, c, l) : this.resourceStore.getResource(I, e, c, l);
  }
  getUsedParamsDetails() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const e = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], c = I.replace && !x(I.replace);
    let l = c ? I.replace : I;
    if (c && typeof I.count < "u" && (l.count = I.count), this.options.interpolation.defaultVariables && (l = {
      ...this.options.interpolation.defaultVariables,
      ...l
    }), !c) {
      l = {
        ...l
      };
      for (const t of e)
        delete l[t];
    }
    return l;
  }
  static hasDefaultValue(I) {
    const e = "defaultValue";
    for (const c in I)
      if (Object.prototype.hasOwnProperty.call(I, c) && e === c.substring(0, e.length) && I[c] !== void 0)
        return !0;
    return !1;
  }
}
const uI = (g) => g.charAt(0).toUpperCase() + g.slice(1);
class Se {
  constructor(I) {
    this.options = I, this.supportedLngs = this.options.supportedLngs || !1, this.logger = O.create("languageUtils");
  }
  getScriptPartFromCode(I) {
    if (I = Qg(I), !I || I.indexOf("-") < 0)
      return null;
    const e = I.split("-");
    return e.length === 2 || (e.pop(), e[e.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(e.join("-"));
  }
  getLanguagePartFromCode(I) {
    if (I = Qg(I), !I || I.indexOf("-") < 0)
      return I;
    const e = I.split("-");
    return this.formatLanguageCode(e[0]);
  }
  formatLanguageCode(I) {
    if (x(I) && I.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let l = Intl.getCanonicalLocales(I)[0];
          if (l && this.options.lowerCaseLng && (l = l.toLowerCase()), l)
            return l;
        } catch {
        }
      const e = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let c = I.split("-");
      return this.options.lowerCaseLng ? c = c.map((l) => l.toLowerCase()) : c.length === 2 ? (c[0] = c[0].toLowerCase(), c[1] = c[1].toUpperCase(), e.indexOf(c[1].toLowerCase()) > -1 && (c[1] = uI(c[1].toLowerCase()))) : c.length === 3 && (c[0] = c[0].toLowerCase(), c[1].length === 2 && (c[1] = c[1].toUpperCase()), c[0] !== "sgn" && c[2].length === 2 && (c[2] = c[2].toUpperCase()), e.indexOf(c[1].toLowerCase()) > -1 && (c[1] = uI(c[1].toLowerCase())), e.indexOf(c[2].toLowerCase()) > -1 && (c[2] = uI(c[2].toLowerCase()))), c.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? I.toLowerCase() : I;
  }
  isSupportedCode(I) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (I = this.getLanguagePartFromCode(I)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(I) > -1;
  }
  getBestMatchFromCodes(I) {
    if (!I)
      return null;
    let e;
    return I.forEach((c) => {
      if (e)
        return;
      const l = this.formatLanguageCode(c);
      (!this.options.supportedLngs || this.isSupportedCode(l)) && (e = l);
    }), !e && this.options.supportedLngs && I.forEach((c) => {
      if (e)
        return;
      const l = this.getLanguagePartFromCode(c);
      if (this.isSupportedCode(l))
        return e = l;
      e = this.options.supportedLngs.find((t) => {
        if (t === l)
          return t;
        if (!(t.indexOf("-") < 0 && l.indexOf("-") < 0) && (t.indexOf("-") > 0 && l.indexOf("-") < 0 && t.substring(0, t.indexOf("-")) === l || t.indexOf(l) === 0 && l.length > 1))
          return t;
      });
    }), e || (e = this.getFallbackCodes(this.options.fallbackLng)[0]), e;
  }
  getFallbackCodes(I, e) {
    if (!I)
      return [];
    if (typeof I == "function" && (I = I(e)), x(I) && (I = [I]), Array.isArray(I))
      return I;
    if (!e)
      return I.default || [];
    let c = I[e];
    return c || (c = I[this.getScriptPartFromCode(e)]), c || (c = I[this.formatLanguageCode(e)]), c || (c = I[this.getLanguagePartFromCode(e)]), c || (c = I.default), c || [];
  }
  toResolveHierarchy(I, e) {
    const c = this.getFallbackCodes(e || this.options.fallbackLng || [], I), l = [], t = (i) => {
      i && (this.isSupportedCode(i) ? l.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return x(I) && (I.indexOf("-") > -1 || I.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && t(this.formatLanguageCode(I)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && t(this.getScriptPartFromCode(I)), this.options.load !== "currentOnly" && t(this.getLanguagePartFromCode(I))) : x(I) && t(this.formatLanguageCode(I)), c.forEach((i) => {
      l.indexOf(i) < 0 && t(this.formatLanguageCode(i));
    }), l;
  }
}
let OC = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], EC = {
  1: (g) => +(g > 1),
  2: (g) => +(g != 1),
  3: (g) => 0,
  4: (g) => g % 10 == 1 && g % 100 != 11 ? 0 : g % 10 >= 2 && g % 10 <= 4 && (g % 100 < 10 || g % 100 >= 20) ? 1 : 2,
  5: (g) => g == 0 ? 0 : g == 1 ? 1 : g == 2 ? 2 : g % 100 >= 3 && g % 100 <= 10 ? 3 : g % 100 >= 11 ? 4 : 5,
  6: (g) => g == 1 ? 0 : g >= 2 && g <= 4 ? 1 : 2,
  7: (g) => g == 1 ? 0 : g % 10 >= 2 && g % 10 <= 4 && (g % 100 < 10 || g % 100 >= 20) ? 1 : 2,
  8: (g) => g == 1 ? 0 : g == 2 ? 1 : g != 8 && g != 11 ? 2 : 3,
  9: (g) => +(g >= 2),
  10: (g) => g == 1 ? 0 : g == 2 ? 1 : g < 7 ? 2 : g < 11 ? 3 : 4,
  11: (g) => g == 1 || g == 11 ? 0 : g == 2 || g == 12 ? 1 : g > 2 && g < 20 ? 2 : 3,
  12: (g) => +(g % 10 != 1 || g % 100 == 11),
  13: (g) => +(g !== 0),
  14: (g) => g == 1 ? 0 : g == 2 ? 1 : g == 3 ? 2 : 3,
  15: (g) => g % 10 == 1 && g % 100 != 11 ? 0 : g % 10 >= 2 && (g % 100 < 10 || g % 100 >= 20) ? 1 : 2,
  16: (g) => g % 10 == 1 && g % 100 != 11 ? 0 : g !== 0 ? 1 : 2,
  17: (g) => g == 1 || g % 10 == 1 && g % 100 != 11 ? 0 : 1,
  18: (g) => g == 0 ? 0 : g == 1 ? 1 : 2,
  19: (g) => g == 1 ? 0 : g == 0 || g % 100 > 1 && g % 100 < 11 ? 1 : g % 100 > 10 && g % 100 < 20 ? 2 : 3,
  20: (g) => g == 1 ? 0 : g == 0 || g % 100 > 0 && g % 100 < 20 ? 1 : 2,
  21: (g) => g % 100 == 1 ? 1 : g % 100 == 2 ? 2 : g % 100 == 3 || g % 100 == 4 ? 3 : 0,
  22: (g) => g == 1 ? 0 : g == 2 ? 1 : (g < 0 || g > 10) && g % 10 == 0 ? 2 : 3
};
const PC = ["v1", "v2", "v3"], jC = ["v4"], Ue = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, DC = () => {
  const g = {};
  return OC.forEach((I) => {
    I.lngs.forEach((e) => {
      g[e] = {
        numbers: I.nr,
        plurals: EC[I.fc]
      };
    });
  }), g;
};
class kC {
  constructor(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = I, this.options = e, this.logger = O.create("pluralResolver"), (!this.options.compatibilityJSON || jC.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = DC(), this.pluralRulesCache = {};
  }
  addRule(I, e) {
    this.rules[I] = e;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        const c = Qg(I === "dev" ? "en" : I), l = e.ordinal ? "ordinal" : "cardinal", t = JSON.stringify({
          cleanedCode: c,
          type: l
        });
        if (t in this.pluralRulesCache)
          return this.pluralRulesCache[t];
        const i = new Intl.PluralRules(c, {
          type: l
        });
        return this.pluralRulesCache[t] = i, i;
      } catch {
        return;
      }
    return this.rules[I] || this.rules[this.languageUtils.getLanguagePartFromCode(I)];
  }
  needsPlural(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const c = this.getRule(I, e);
    return this.shouldUseIntlApi() ? c && c.resolvedOptions().pluralCategories.length > 1 : c && c.numbers.length > 1;
  }
  getPluralFormsOfKey(I, e) {
    let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(I, c).map((l) => `${e}${l}`);
  }
  getSuffixes(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const c = this.getRule(I, e);
    return c ? this.shouldUseIntlApi() ? c.resolvedOptions().pluralCategories.sort((l, t) => Ue[l] - Ue[t]).map((l) => `${this.options.prepend}${e.ordinal ? `ordinal${this.options.prepend}` : ""}${l}`) : c.numbers.map((l) => this.getSuffix(I, l, e)) : [];
  }
  getSuffix(I, e) {
    let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const l = this.getRule(I, c);
    return l ? this.shouldUseIntlApi() ? `${this.options.prepend}${c.ordinal ? `ordinal${this.options.prepend}` : ""}${l.select(e)}` : this.getSuffixRetroCompatible(l, e) : (this.logger.warn(`no plural rule found for: ${I}`), "");
  }
  getSuffixRetroCompatible(I, e) {
    const c = I.noAbs ? I.plurals(e) : I.plurals(Math.abs(e));
    let l = I.numbers[c];
    this.options.simplifyPluralSuffix && I.numbers.length === 2 && I.numbers[0] === 1 && (l === 2 ? l = "plural" : l === 1 && (l = ""));
    const t = () => this.options.prepend && l.toString() ? this.options.prepend + l.toString() : l.toString();
    return this.options.compatibilityJSON === "v1" ? l === 1 ? "" : typeof l == "number" ? `_plural_${l.toString()}` : t() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && I.numbers.length === 2 && I.numbers[0] === 1 ? t() : this.options.prepend && c.toString() ? this.options.prepend + c.toString() : c.toString();
  }
  shouldUseIntlApi() {
    return !PC.includes(this.options.compatibilityJSON);
  }
}
const He = function(g, I, e) {
  let c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, t = fC(g, I, e);
  return !t && l && x(e) && (t = pI(g, e, c), t === void 0 && (t = pI(I, e, c))), t;
}, rI = (g) => g.replace(/\$/g, "$$$$");
class MC {
  constructor() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = O.create("interpolator"), this.options = I, this.format = I.interpolation && I.interpolation.format || ((e) => e), this.init(I);
  }
  init() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    I.interpolation || (I.interpolation = {
      escapeValue: !0
    });
    const {
      escape: e,
      escapeValue: c,
      useRawValueToEscape: l,
      prefix: t,
      prefixEscaped: i,
      suffix: n,
      suffixEscaped: C,
      formatSeparator: b,
      unescapeSuffix: a,
      unescapePrefix: u,
      nestingPrefix: A,
      nestingPrefixEscaped: G,
      nestingSuffix: N,
      nestingSuffixEscaped: W,
      nestingOptionsSeparator: R,
      maxReplaces: p,
      alwaysFormat: s
    } = I.interpolation;
    this.escape = e !== void 0 ? e : zC, this.escapeValue = c !== void 0 ? c : !0, this.useRawValueToEscape = l !== void 0 ? l : !1, this.prefix = t ? $(t) : i || "{{", this.suffix = n ? $(n) : C || "}}", this.formatSeparator = b || ",", this.unescapePrefix = a ? "" : u || "-", this.unescapeSuffix = this.unescapePrefix ? "" : a || "", this.nestingPrefix = A ? $(A) : G || $("$t("), this.nestingSuffix = N ? $(N) : W || $(")"), this.nestingOptionsSeparator = R || ",", this.maxReplaces = p || 1e3, this.alwaysFormat = s !== void 0 ? s : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const I = (e, c) => e && e.source === c ? (e.lastIndex = 0, e) : new RegExp(c, "g");
    this.regexp = I(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = I(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = I(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(I, e, c, l) {
    let t, i, n;
    const C = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, b = (G) => {
      if (G.indexOf(this.formatSeparator) < 0) {
        const p = He(e, C, G, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(p, void 0, c, {
          ...l,
          ...e,
          interpolationkey: G
        }) : p;
      }
      const N = G.split(this.formatSeparator), W = N.shift().trim(), R = N.join(this.formatSeparator).trim();
      return this.format(He(e, C, W, this.options.keySeparator, this.options.ignoreJSONStructure), R, c, {
        ...l,
        ...e,
        interpolationkey: W
      });
    };
    this.resetRegExp();
    const a = l && l.missingInterpolationHandler || this.options.missingInterpolationHandler, u = l && l.interpolation && l.interpolation.skipOnVariables !== void 0 ? l.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (G) => rI(G)
    }, {
      regex: this.regexp,
      safeValue: (G) => this.escapeValue ? rI(this.escape(G)) : rI(G)
    }].forEach((G) => {
      for (n = 0; t = G.regex.exec(I); ) {
        const N = t[1].trim();
        if (i = b(N), i === void 0)
          if (typeof a == "function") {
            const R = a(I, t, l);
            i = x(R) ? R : "";
          } else if (l && Object.prototype.hasOwnProperty.call(l, N))
            i = "";
          else if (u) {
            i = t[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${N} for interpolating ${I}`), i = "";
        else
          !x(i) && !this.useRawValueToEscape && (i = ve(i));
        const W = G.safeValue(i);
        if (I = I.replace(t[0], W), u ? (G.regex.lastIndex += i.length, G.regex.lastIndex -= t[0].length) : G.regex.lastIndex = 0, n++, n >= this.maxReplaces)
          break;
      }
    }), I;
  }
  nest(I, e) {
    let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l, t, i;
    const n = (C, b) => {
      const a = this.nestingOptionsSeparator;
      if (C.indexOf(a) < 0)
        return C;
      const u = C.split(new RegExp(`${a}[ ]*{`));
      let A = `{${u[1]}`;
      C = u[0], A = this.interpolate(A, i);
      const G = A.match(/'/g), N = A.match(/"/g);
      (G && G.length % 2 === 0 && !N || N.length % 2 !== 0) && (A = A.replace(/'/g, '"'));
      try {
        i = JSON.parse(A), b && (i = {
          ...b,
          ...i
        });
      } catch (W) {
        return this.logger.warn(`failed parsing options string in nesting for key ${C}`, W), `${C}${a}${A}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, C;
    };
    for (; l = this.nestingRegexp.exec(I); ) {
      let C = [];
      i = {
        ...c
      }, i = i.replace && !x(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      let b = !1;
      if (l[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(l[1])) {
        const a = l[1].split(this.formatSeparator).map((u) => u.trim());
        l[1] = a.shift(), C = a, b = !0;
      }
      if (t = e(n.call(this, l[1].trim(), i), i), t && l[0] === I && !x(t))
        return t;
      x(t) || (t = ve(t)), t || (this.logger.warn(`missed to resolve ${l[1]} for nesting ${I}`), t = ""), b && (t = C.reduce((a, u) => this.format(a, u, c.lng, {
        ...c,
        interpolationkey: l[1].trim()
      }), t.trim())), I = I.replace(l[0], t), this.regexp.lastIndex = 0;
    }
    return I;
  }
}
const QC = (g) => {
  let I = g.toLowerCase().trim();
  const e = {};
  if (g.indexOf("(") > -1) {
    const c = g.split("(");
    I = c[0].toLowerCase().trim();
    const l = c[1].substring(0, c[1].length - 1);
    I === "currency" && l.indexOf(":") < 0 ? e.currency || (e.currency = l.trim()) : I === "relativetime" && l.indexOf(":") < 0 ? e.range || (e.range = l.trim()) : l.split(";").forEach((i) => {
      if (i) {
        const [n, ...C] = i.split(":"), b = C.join(":").trim().replace(/^'+|'+$/g, ""), a = n.trim();
        e[a] || (e[a] = b), b === "false" && (e[a] = !1), b === "true" && (e[a] = !0), isNaN(b) || (e[a] = parseInt(b, 10));
      }
    });
  }
  return {
    formatName: I,
    formatOptions: e
  };
}, gg = (g) => {
  const I = {};
  return (e, c, l) => {
    let t = l;
    l && l.interpolationkey && l.formatParams && l.formatParams[l.interpolationkey] && l[l.interpolationkey] && (t = {
      ...t,
      [l.interpolationkey]: void 0
    });
    const i = c + JSON.stringify(t);
    let n = I[i];
    return n || (n = g(Qg(c), l), I[i] = n), n(e);
  };
};
class KC {
  constructor() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = O.create("formatter"), this.options = I, this.formats = {
      number: gg((e, c) => {
        const l = new Intl.NumberFormat(e, {
          ...c
        });
        return (t) => l.format(t);
      }),
      currency: gg((e, c) => {
        const l = new Intl.NumberFormat(e, {
          ...c,
          style: "currency"
        });
        return (t) => l.format(t);
      }),
      datetime: gg((e, c) => {
        const l = new Intl.DateTimeFormat(e, {
          ...c
        });
        return (t) => l.format(t);
      }),
      relativetime: gg((e, c) => {
        const l = new Intl.RelativeTimeFormat(e, {
          ...c
        });
        return (t) => l.format(t, c.range || "day");
      }),
      list: gg((e, c) => {
        const l = new Intl.ListFormat(e, {
          ...c
        });
        return (t) => l.format(t);
      })
    }, this.init(I);
  }
  init(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = e.interpolation.formatSeparator || ",";
  }
  add(I, e) {
    this.formats[I.toLowerCase().trim()] = e;
  }
  addCached(I, e) {
    this.formats[I.toLowerCase().trim()] = gg(e);
  }
  format(I, e, c) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const t = e.split(this.formatSeparator);
    if (t.length > 1 && t[0].indexOf("(") > 1 && t[0].indexOf(")") < 0 && t.find((n) => n.indexOf(")") > -1)) {
      const n = t.findIndex((C) => C.indexOf(")") > -1);
      t[0] = [t[0], ...t.splice(1, n)].join(this.formatSeparator);
    }
    return t.reduce((n, C) => {
      const {
        formatName: b,
        formatOptions: a
      } = QC(C);
      if (this.formats[b]) {
        let u = n;
        try {
          const A = l && l.formatParams && l.formatParams[l.interpolationkey] || {}, G = A.locale || A.lng || l.locale || l.lng || c;
          u = this.formats[b](n, G, {
            ...a,
            ...l,
            ...A
          });
        } catch (A) {
          this.logger.warn(A);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${b}`);
      return n;
    }, I);
  }
}
const _C = (g, I) => {
  g.pending[I] !== void 0 && (delete g.pending[I], g.pendingCount--);
};
class qC extends iI {
  constructor(I, e, c) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = I, this.store = e, this.services = c, this.languageUtils = c.languageUtils, this.options = l, this.logger = O.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = l.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = l.maxRetries >= 0 ? l.maxRetries : 5, this.retryTimeout = l.retryTimeout >= 1 ? l.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(c, l.backend, l);
  }
  queueLoad(I, e, c, l) {
    const t = {}, i = {}, n = {}, C = {};
    return I.forEach((b) => {
      let a = !0;
      e.forEach((u) => {
        const A = `${b}|${u}`;
        !c.reload && this.store.hasResourceBundle(b, u) ? this.state[A] = 2 : this.state[A] < 0 || (this.state[A] === 1 ? i[A] === void 0 && (i[A] = !0) : (this.state[A] = 1, a = !1, i[A] === void 0 && (i[A] = !0), t[A] === void 0 && (t[A] = !0), C[u] === void 0 && (C[u] = !0)));
      }), a || (n[b] = !0);
    }), (Object.keys(t).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: l
    }), {
      toLoad: Object.keys(t),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(n),
      toLoadNamespaces: Object.keys(C)
    };
  }
  loaded(I, e, c) {
    const l = I.split("|"), t = l[0], i = l[1];
    e && this.emit("failedLoading", t, i, e), !e && c && this.store.addResourceBundle(t, i, c, void 0, void 0, {
      skipCopy: !0
    }), this.state[I] = e ? -1 : 2, e && c && (this.state[I] = 0);
    const n = {};
    this.queue.forEach((C) => {
      YC(C.loaded, [t], i), _C(C, I), e && C.errors.push(e), C.pendingCount === 0 && !C.done && (Object.keys(C.loaded).forEach((b) => {
        n[b] || (n[b] = {});
        const a = C.loaded[b];
        a.length && a.forEach((u) => {
          n[b][u] === void 0 && (n[b][u] = !0);
        });
      }), C.done = !0, C.errors.length ? C.callback(C.errors) : C.callback());
    }), this.emit("loaded", n), this.queue = this.queue.filter((C) => !C.done);
  }
  read(I, e, c) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, t = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, i = arguments.length > 5 ? arguments[5] : void 0;
    if (!I.length)
      return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: I,
        ns: e,
        fcName: c,
        tried: l,
        wait: t,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const n = (b, a) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const u = this.waitingReads.shift();
        this.read(u.lng, u.ns, u.fcName, u.tried, u.wait, u.callback);
      }
      if (b && a && l < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, I, e, c, l + 1, t * 2, i);
        }, t);
        return;
      }
      i(b, a);
    }, C = this.backend[c].bind(this.backend);
    if (C.length === 2) {
      try {
        const b = C(I, e);
        b && typeof b.then == "function" ? b.then((a) => n(null, a)).catch(n) : n(null, b);
      } catch (b) {
        n(b);
      }
      return;
    }
    return C(I, e, n);
  }
  prepareLoading(I, e) {
    let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), l && l();
    x(I) && (I = this.languageUtils.toResolveHierarchy(I)), x(e) && (e = [e]);
    const t = this.queueLoad(I, e, c, l);
    if (!t.toLoad.length)
      return t.pending.length || l(), null;
    t.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(I, e, c) {
    this.prepareLoading(I, e, {}, c);
  }
  reload(I, e, c) {
    this.prepareLoading(I, e, {
      reload: !0
    }, c);
  }
  loadOne(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const c = I.split("|"), l = c[0], t = c[1];
    this.read(l, t, "read", void 0, void 0, (i, n) => {
      i && this.logger.warn(`${e}loading namespace ${t} for language ${l} failed`, i), !i && n && this.logger.log(`${e}loaded namespace ${t} for language ${l}`, n), this.loaded(I, i, n);
    });
  }
  saveMissing(I, e, c, l, t) {
    let i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, n = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(e)) {
      this.logger.warn(`did not save key "${c}" as the namespace "${e}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(c == null || c === "")) {
      if (this.backend && this.backend.create) {
        const C = {
          ...i,
          isUpdate: t
        }, b = this.backend.create.bind(this.backend);
        if (b.length < 6)
          try {
            let a;
            b.length === 5 ? a = b(I, e, c, l, C) : a = b(I, e, c, l), a && typeof a.then == "function" ? a.then((u) => n(null, u)).catch(n) : n(null, a);
          } catch (a) {
            n(a);
          }
        else
          b(I, e, c, l, n, C);
      }
      !I || !I[0] || this.store.addResource(I[0], e, c, l);
    }
  }
}
const we = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (g) => {
    let I = {};
    if (typeof g[1] == "object" && (I = g[1]), x(g[1]) && (I.defaultValue = g[1]), x(g[2]) && (I.tDescription = g[2]), typeof g[2] == "object" || typeof g[3] == "object") {
      const e = g[3] || g[2];
      Object.keys(e).forEach((c) => {
        I[c] = e[c];
      });
    }
    return I;
  },
  interpolation: {
    escapeValue: !0,
    format: (g) => g,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Le = (g) => (x(g.ns) && (g.ns = [g.ns]), x(g.fallbackLng) && (g.fallbackLng = [g.fallbackLng]), x(g.fallbackNS) && (g.fallbackNS = [g.fallbackNS]), g.supportedLngs && g.supportedLngs.indexOf("cimode") < 0 && (g.supportedLngs = g.supportedLngs.concat(["cimode"])), g), zg = () => {
}, $C = (g) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(g)).forEach((e) => {
    typeof g[e] == "function" && (g[e] = g[e].bind(g));
  });
};
class yg extends iI {
  constructor() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Le(I), this.services = {}, this.logger = O, this.modules = {
      external: []
    }, $C(this), e && !this.isInitialized && !I.isClone) {
      if (!this.options.initImmediate)
        return this.init(I, e), this;
      setTimeout(() => {
        this.init(I, e);
      }, 0);
    }
  }
  init() {
    var I = this;
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof e == "function" && (c = e, e = {}), !e.defaultNS && e.defaultNS !== !1 && e.ns && (x(e.ns) ? e.defaultNS = e.ns : e.ns.indexOf("translation") < 0 && (e.defaultNS = e.ns[0]));
    const l = we();
    this.options = {
      ...l,
      ...this.options,
      ...Le(e)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...l.interpolation,
      ...this.options.interpolation
    }), e.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = e.keySeparator), e.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = e.nsSeparator);
    const t = (a) => a ? typeof a == "function" ? new a() : a : null;
    if (!this.options.isClone) {
      this.modules.logger ? O.init(t(this.modules.logger), this.options) : O.init(null, this.options);
      let a;
      this.modules.formatter ? a = this.modules.formatter : typeof Intl < "u" && (a = KC);
      const u = new Se(this.options);
      this.store = new Te(this.options.resources, this.options);
      const A = this.services;
      A.logger = O, A.resourceStore = this.store, A.languageUtils = u, A.pluralResolver = new kC(u, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), a && (!this.options.interpolation.format || this.options.interpolation.format === l.interpolation.format) && (A.formatter = t(a), A.formatter.init(A, this.options), this.options.interpolation.format = A.formatter.format.bind(A.formatter)), A.interpolator = new MC(this.options), A.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, A.backendConnector = new qC(t(this.modules.backend), A.resourceStore, A, this.options), A.backendConnector.on("*", function(G) {
        for (var N = arguments.length, W = new Array(N > 1 ? N - 1 : 0), R = 1; R < N; R++)
          W[R - 1] = arguments[R];
        I.emit(G, ...W);
      }), this.modules.languageDetector && (A.languageDetector = t(this.modules.languageDetector), A.languageDetector.init && A.languageDetector.init(A, this.options.detection, this.options)), this.modules.i18nFormat && (A.i18nFormat = t(this.modules.i18nFormat), A.i18nFormat.init && A.i18nFormat.init(this)), this.translator = new _g(this.services, this.options), this.translator.on("*", function(G) {
        for (var N = arguments.length, W = new Array(N > 1 ? N - 1 : 0), R = 1; R < N; R++)
          W[R - 1] = arguments[R];
        I.emit(G, ...W);
      }), this.modules.external.forEach((G) => {
        G.init && G.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, c || (c = zg), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const a = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      a.length > 0 && a[0] !== "dev" && (this.options.lng = a[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((a) => {
      this[a] = function() {
        return I.store[a](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((a) => {
      this[a] = function() {
        return I.store[a](...arguments), I;
      };
    });
    const C = dg(), b = () => {
      const a = (u, A) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), C.resolve(A), c(u, A);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return a(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, a);
    };
    return this.options.resources || !this.options.initImmediate ? b() : setTimeout(b, 0), C;
  }
  loadResources(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : zg;
    const l = x(I) ? I : this.language;
    if (typeof I == "function" && (c = I), !this.options.resources || this.options.partialBundledLanguages) {
      if (l && l.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return c();
      const t = [], i = (n) => {
        if (!n || n === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(n).forEach((b) => {
          b !== "cimode" && t.indexOf(b) < 0 && t.push(b);
        });
      };
      l ? i(l) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((C) => i(C)), this.options.preload && this.options.preload.forEach((n) => i(n)), this.services.backendConnector.load(t, this.options.ns, (n) => {
        !n && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), c(n);
      });
    } else
      c(null);
  }
  reloadResources(I, e, c) {
    const l = dg();
    return typeof I == "function" && (c = I, I = void 0), typeof e == "function" && (c = e, e = void 0), I || (I = this.languages), e || (e = this.options.ns), c || (c = zg), this.services.backendConnector.reload(I, e, (t) => {
      l.resolve(), c(t);
    }), l;
  }
  use(I) {
    if (!I)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!I.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return I.type === "backend" && (this.modules.backend = I), (I.type === "logger" || I.log && I.warn && I.error) && (this.modules.logger = I), I.type === "languageDetector" && (this.modules.languageDetector = I), I.type === "i18nFormat" && (this.modules.i18nFormat = I), I.type === "postProcessor" && Ec.addPostProcessor(I), I.type === "formatter" && (this.modules.formatter = I), I.type === "3rdParty" && this.modules.external.push(I), this;
  }
  setResolvedLanguage(I) {
    if (!(!I || !this.languages) && !(["cimode", "dev"].indexOf(I) > -1))
      for (let e = 0; e < this.languages.length; e++) {
        const c = this.languages[e];
        if (!(["cimode", "dev"].indexOf(c) > -1) && this.store.hasLanguageSomeTranslations(c)) {
          this.resolvedLanguage = c;
          break;
        }
      }
  }
  changeLanguage(I, e) {
    var c = this;
    this.isLanguageChangingTo = I;
    const l = dg();
    this.emit("languageChanging", I);
    const t = (C) => {
      this.language = C, this.languages = this.services.languageUtils.toResolveHierarchy(C), this.resolvedLanguage = void 0, this.setResolvedLanguage(C);
    }, i = (C, b) => {
      b ? (t(b), this.translator.changeLanguage(b), this.isLanguageChangingTo = void 0, this.emit("languageChanged", b), this.logger.log("languageChanged", b)) : this.isLanguageChangingTo = void 0, l.resolve(function() {
        return c.t(...arguments);
      }), e && e(C, function() {
        return c.t(...arguments);
      });
    }, n = (C) => {
      !I && !C && this.services.languageDetector && (C = []);
      const b = x(C) ? C : this.services.languageUtils.getBestMatchFromCodes(C);
      b && (this.language || t(b), this.translator.language || this.translator.changeLanguage(b), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(b)), this.loadResources(b, (a) => {
        i(a, b);
      });
    };
    return !I && this.services.languageDetector && !this.services.languageDetector.async ? n(this.services.languageDetector.detect()) : !I && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(n) : this.services.languageDetector.detect(n) : n(I), l;
  }
  getFixedT(I, e, c) {
    var l = this;
    const t = function(i, n) {
      let C;
      if (typeof n != "object") {
        for (var b = arguments.length, a = new Array(b > 2 ? b - 2 : 0), u = 2; u < b; u++)
          a[u - 2] = arguments[u];
        C = l.options.overloadTranslationOptionHandler([i, n].concat(a));
      } else
        C = {
          ...n
        };
      C.lng = C.lng || t.lng, C.lngs = C.lngs || t.lngs, C.ns = C.ns || t.ns, C.keyPrefix !== "" && (C.keyPrefix = C.keyPrefix || c || t.keyPrefix);
      const A = l.options.keySeparator || ".";
      let G;
      return C.keyPrefix && Array.isArray(i) ? G = i.map((N) => `${C.keyPrefix}${A}${N}`) : G = C.keyPrefix ? `${C.keyPrefix}${A}${i}` : i, l.t(G, C);
    };
    return x(I) ? t.lng = I : t.lngs = I, t.ns = e, t.keyPrefix = c, t;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(I) {
    this.options.defaultNS = I;
  }
  hasLoadedNamespace(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const c = e.lng || this.resolvedLanguage || this.languages[0], l = this.options ? this.options.fallbackLng : !1, t = this.languages[this.languages.length - 1];
    if (c.toLowerCase() === "cimode")
      return !0;
    const i = (n, C) => {
      const b = this.services.backendConnector.state[`${n}|${C}`];
      return b === -1 || b === 0 || b === 2;
    };
    if (e.precheck) {
      const n = e.precheck(this, i);
      if (n !== void 0)
        return n;
    }
    return !!(this.hasResourceBundle(c, I) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(c, I) && (!l || i(t, I)));
  }
  loadNamespaces(I, e) {
    const c = dg();
    return this.options.ns ? (x(I) && (I = [I]), I.forEach((l) => {
      this.options.ns.indexOf(l) < 0 && this.options.ns.push(l);
    }), this.loadResources((l) => {
      c.resolve(), e && e(l);
    }), c) : (e && e(), Promise.resolve());
  }
  loadLanguages(I, e) {
    const c = dg();
    x(I) && (I = [I]);
    const l = this.options.preload || [], t = I.filter((i) => l.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return t.length ? (this.options.preload = l.concat(t), this.loadResources((i) => {
      c.resolve(), e && e(i);
    }), c) : (e && e(), Promise.resolve());
  }
  dir(I) {
    if (I || (I = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !I)
      return "rtl";
    const e = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], c = this.services && this.services.languageUtils || new Se(we());
    return e.indexOf(c.getLanguagePartFromCode(I)) > -1 || I.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = arguments.length > 1 ? arguments[1] : void 0;
    return new yg(I, e);
  }
  cloneInstance() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : zg;
    const c = I.forkResourceStore;
    c && delete I.forkResourceStore;
    const l = {
      ...this.options,
      ...I,
      isClone: !0
    }, t = new yg(l);
    return (I.debug !== void 0 || I.prefix !== void 0) && (t.logger = t.logger.clone(I)), ["store", "services", "language"].forEach((n) => {
      t[n] = this[n];
    }), t.services = {
      ...this.services
    }, t.services.utils = {
      hasLoadedNamespace: t.hasLoadedNamespace.bind(t)
    }, c && (t.store = new Te(this.store.data, l), t.services.resourceStore = t.store), t.translator = new _g(t.services, l), t.translator.on("*", function(n) {
      for (var C = arguments.length, b = new Array(C > 1 ? C - 1 : 0), a = 1; a < C; a++)
        b[a - 1] = arguments[a];
      t.emit(n, ...b);
    }), t.init(l, e), t.translator.options = l, t.translator.backendConnector.services.utils = {
      hasLoadedNamespace: t.hasLoadedNamespace.bind(t)
    }, t;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const F = yg.createInstance();
F.createInstance = yg.createInstance;
F.createInstance;
F.dir;
F.init;
F.loadResources;
F.reloadResources;
F.use;
F.changeLanguage;
F.getFixedT;
F.t;
F.exists;
F.setDefaultNamespace;
F.hasLoadedNamespace;
F.loadNamespaces;
F.loadLanguages;
const {
  slice: ga,
  forEach: Ia
} = [];
function ea(g) {
  return Ia.call(ga.call(arguments, 1), (I) => {
    if (I)
      for (const e in I)
        g[e] === void 0 && (g[e] = I[e]);
  }), g;
}
const Oe = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, ca = (g, I, e) => {
  const c = e || {};
  c.path = c.path || "/";
  const l = encodeURIComponent(I);
  let t = `${g}=${l}`;
  if (c.maxAge > 0) {
    const i = c.maxAge - 0;
    if (Number.isNaN(i))
      throw new Error("maxAge should be a Number");
    t += `; Max-Age=${Math.floor(i)}`;
  }
  if (c.domain) {
    if (!Oe.test(c.domain))
      throw new TypeError("option domain is invalid");
    t += `; Domain=${c.domain}`;
  }
  if (c.path) {
    if (!Oe.test(c.path))
      throw new TypeError("option path is invalid");
    t += `; Path=${c.path}`;
  }
  if (c.expires) {
    if (typeof c.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    t += `; Expires=${c.expires.toUTCString()}`;
  }
  if (c.httpOnly && (t += "; HttpOnly"), c.secure && (t += "; Secure"), c.sameSite)
    switch (typeof c.sameSite == "string" ? c.sameSite.toLowerCase() : c.sameSite) {
      case !0:
        t += "; SameSite=Strict";
        break;
      case "lax":
        t += "; SameSite=Lax";
        break;
      case "strict":
        t += "; SameSite=Strict";
        break;
      case "none":
        t += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  return t;
}, Ee = {
  create(g, I, e, c) {
    let l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    e && (l.expires = /* @__PURE__ */ new Date(), l.expires.setTime(l.expires.getTime() + e * 60 * 1e3)), c && (l.domain = c), document.cookie = ca(g, encodeURIComponent(I), l);
  },
  read(g) {
    const I = `${g}=`, e = document.cookie.split(";");
    for (let c = 0; c < e.length; c++) {
      let l = e[c];
      for (; l.charAt(0) === " "; )
        l = l.substring(1, l.length);
      if (l.indexOf(I) === 0)
        return l.substring(I.length, l.length);
    }
    return null;
  },
  remove(g) {
    this.create(g, "", -1);
  }
};
var la = {
  name: "cookie",
  // Deconstruct the options object and extract the lookupCookie property
  lookup(g) {
    let {
      lookupCookie: I
    } = g;
    if (I && typeof document < "u")
      return Ee.read(I) || void 0;
  },
  // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
  cacheUserLanguage(g, I) {
    let {
      lookupCookie: e,
      cookieMinutes: c,
      cookieDomain: l,
      cookieOptions: t
    } = I;
    e && typeof document < "u" && Ee.create(e, g, c, l, t);
  }
}, ta = {
  name: "querystring",
  // Deconstruct the options object and extract the lookupQuerystring property
  lookup(g) {
    var c;
    let {
      lookupQuerystring: I
    } = g, e;
    if (typeof window < "u") {
      let {
        search: l
      } = window.location;
      !window.location.search && ((c = window.location.hash) == null ? void 0 : c.indexOf("?")) > -1 && (l = window.location.hash.substring(window.location.hash.indexOf("?")));
      const i = l.substring(1).split("&");
      for (let n = 0; n < i.length; n++) {
        const C = i[n].indexOf("=");
        C > 0 && i[n].substring(0, C) === I && (e = i[n].substring(C + 1));
      }
    }
    return e;
  }
};
let og = null;
const Pe = () => {
  if (og !== null)
    return og;
  try {
    og = window !== "undefined" && window.localStorage !== null;
    const g = "i18next.translate.boo";
    window.localStorage.setItem(g, "foo"), window.localStorage.removeItem(g);
  } catch {
    og = !1;
  }
  return og;
};
var ia = {
  name: "localStorage",
  // Deconstruct the options object and extract the lookupLocalStorage property
  lookup(g) {
    let {
      lookupLocalStorage: I
    } = g;
    if (I && Pe())
      return window.localStorage.getItem(I) || void 0;
  },
  // Deconstruct the options object and extract the lookupLocalStorage property
  cacheUserLanguage(g, I) {
    let {
      lookupLocalStorage: e
    } = I;
    e && Pe() && window.localStorage.setItem(e, g);
  }
};
let Gg = null;
const je = () => {
  if (Gg !== null)
    return Gg;
  try {
    Gg = window !== "undefined" && window.sessionStorage !== null;
    const g = "i18next.translate.boo";
    window.sessionStorage.setItem(g, "foo"), window.sessionStorage.removeItem(g);
  } catch {
    Gg = !1;
  }
  return Gg;
};
var na = {
  name: "sessionStorage",
  lookup(g) {
    let {
      lookupSessionStorage: I
    } = g;
    if (I && je())
      return window.sessionStorage.getItem(I) || void 0;
  },
  cacheUserLanguage(g, I) {
    let {
      lookupSessionStorage: e
    } = I;
    e && je() && window.sessionStorage.setItem(e, g);
  }
}, ba = {
  name: "navigator",
  lookup(g) {
    const I = [];
    if (typeof navigator < "u") {
      const {
        languages: e,
        userLanguage: c,
        language: l
      } = navigator;
      if (e)
        for (let t = 0; t < e.length; t++)
          I.push(e[t]);
      c && I.push(c), l && I.push(l);
    }
    return I.length > 0 ? I : void 0;
  }
}, Ca = {
  name: "htmlTag",
  // Deconstruct the options object and extract the htmlTag property
  lookup(g) {
    let {
      htmlTag: I
    } = g, e;
    const c = I || (typeof document < "u" ? document.documentElement : null);
    return c && typeof c.getAttribute == "function" && (e = c.getAttribute("lang")), e;
  }
}, aa = {
  name: "path",
  // Deconstruct the options object and extract the lookupFromPathIndex property
  lookup(g) {
    var l;
    let {
      lookupFromPathIndex: I
    } = g;
    if (typeof window > "u")
      return;
    const e = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
    return Array.isArray(e) ? (l = e[typeof I == "number" ? I : 0]) == null ? void 0 : l.replace("/", "") : void 0;
  }
}, sa = {
  name: "subdomain",
  lookup(g) {
    var l, t;
    let {
      lookupFromSubdomainIndex: I
    } = g;
    const e = typeof I == "number" ? I + 1 : 1, c = typeof window < "u" && ((t = (l = window.location) == null ? void 0 : l.hostname) == null ? void 0 : t.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i));
    if (c)
      return c[e];
  }
};
function Aa() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
    convertDetectedLanguage: (g) => g
  };
}
class Pc {
  constructor(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.type = "languageDetector", this.detectors = {}, this.init(I, e);
  }
  init(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.services = I || {
      languageUtils: {}
    }, this.options = ea(e, this.options || {}, Aa()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = (l) => l.replace("-", "_")), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = c, this.addDetector(la), this.addDetector(ta), this.addDetector(ia), this.addDetector(na), this.addDetector(ba), this.addDetector(Ca), this.addDetector(aa), this.addDetector(sa);
  }
  addDetector(I) {
    return this.detectors[I.name] = I, this;
  }
  detect(I) {
    I || (I = this.options.order);
    let e = [];
    return I.forEach((c) => {
      if (this.detectors[c]) {
        let l = this.detectors[c].lookup(this.options);
        l && typeof l == "string" && (l = [l]), l && (e = e.concat(l));
      }
    }), e = e.map((c) => this.options.convertDetectedLanguage(c)), this.services.languageUtils.getBestMatchFromCodes ? e : e.length > 0 ? e[0] : null;
  }
  cacheUserLanguage(I, e) {
    e || (e = this.options.caches), e && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(I) > -1 || e.forEach((c) => {
      this.detectors[c] && this.detectors[c].cacheUserLanguage(I, this.options);
    }));
  }
}
Pc.type = "languageDetector";
const ua = {
  "(주)인프랩": "Inflab Co., Ltd.",
  "(주)인프랩 사업자 정보": "Inflab Co., Ltd. Business Information",
  "3동 5층": "Republic of Korea",
  "IT 인재 채용 서비스": "IT talents recruiting service",
  "MY 카테고리": "My category",
  "With us": "With us",
  "{{category.title}} > 전체": "{{category.title}} > All",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}, thank you for being with Inflearn. 😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}, we’re cheering for your first step forward. 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}, we’re cheering for your career growth. 👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}’s profile image",
  "{{provider}}-로그인-버튼": "{{provider}}-Login-Button",
  "{{socialProviderNameMap[provider]}}로 로그인": "Log in with {{socialProviderNameMap[provider]}}",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "With 'Inflearn Business,' you can provide an environment where all team members can",
  "가입 이메일 인증이 필요합니다.": "Email verification is required for registration.",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `This account requires email verification.
Please try again after 24 hours or contact customer support.`,
  "간편 로그인": "Social login",
  강의: "Course",
  "강의 · 기능요청": "Ask for course/function",
  "강의/강사명을 입력해주세요": "Enter the course/instructor name",
  "강의리스트 보기": "View course list",
  개: "ea",
  "개인정보보호책임자: 이동욱": "CPO: Lee Dongwook",
  개인정보처리방침: "Privacy Policy",
  검색: "Search",
  "검색바.01": "What are you interested in now?",
  "검색바.02": "Enter a keyword you’re exploring.",
  "검색바.03": "Which skill are you exploring now?",
  "검색바.04": "Discover courses for your next step.",
  "검색바.05": "Looking for something specific?",
  "검색바.06": "Type a course, topic, or keyword.",
  "검색바.07": "What do you want to learn today?",
  "검색바.08": "Search for anything.",
  "검색바.09": "What are you interested in now?",
  "검색바.10": "What do you want to learn today?",
  "검색바.11": "Which skill are you exploring now?",
  "검색할 강의 입력": "Enter course name",
  "경기도 성남시 분당구 판교로289번길 20": "5F, Bldg #3, 20, Pangyo-ro 289beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do,",
  "경제적 보상을 받아보세요.": "and get financial rewards.",
  "계정 설정": "Account Settings",
  고객센터: "Customer Services",
  고민있어요: "I need help",
  공지사항: "Notice",
  교육: "Training",
  구글: "Google",
  "구매 / 혜택": "Purchase / Benefits",
  "구매 내역": "Purchase history",
  국비지원교육: "Government-sponsored courses",
  기업: "Business",
  "기업 교육을 위한 인프런": "Inflearn for business education",
  깃허브: "GitHub",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "Search for great pieces of knowledge that’ll help you grow.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "Find practical courses that can actually help you grow.",
  난이도: "Level",
  "난이도 선택": "Select Level",
  "난이도 옵션": "Level Options",
  "난이도 초기화": "Reset Level",
  "나한테 딱 맞는 걸 찾고 싶다면": "Looking for the perfect match?",
  "어떤 강의가 나한테 맞을까?": "Which course is right for me?",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "Find courses for your goals",
  "지금 많이 듣는 강의 확인해보세요": "Check out the most popular courses right now",
  "남았어요.": "left.",
  "내 학습": "My learning",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "Naver does not support Google Login.",
  "누구나 들을 수 있는": "Open to everyone",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "Please use a different mobile browser (Chrome, Safari).",
  닫기: "Close",
  "담긴 강의가 없습니다.": "No courses in cart.",
  대시보드: "Dashboard",
  "대표자: 이형주": "CEO: Lee Hyeongjoo",
  더보기: "More",
  둘러보기: "Explore",
  "딱 맞는 강의가 기다리고 있어요.": "The perfect course for you awaits.",
  "랠릿 서비스 링크": "Rallit service link",
  로그아웃: "Log out",
  로그인: "Sign in",
  "로그인 또는 회원가입": "Log In or Sign Up",
  "로그인이 필요한 요청입니다.": "You need to log in to make this request.",
  로드맵: "Roadmap",
  "마음에 드는 강의를 수강해보세요!": "Take the course that draws your attention!",
  "많은 사람들에게 배움의 기회를 주고,": "Provide an opportunity to learn",
  "메인 페이지로 이동하기": "Go to main page",
  멘토링: "Mentoring",
  "멘토링 소개": "About mentoring",
  "멘토링 후기": "Mentoring Reviews",
  "모임/부트캠프": "Clubs/Bootcamp",
  "문제가 발생했습니다.": "An issue has occurred.",
  보관함: "Storage",
  분: "min",
  블로그: "Blog",
  비밀번호: "Password",
  "비밀번호 찾기": "Find my password",
  "비밀번호를 입력해주세요.": "Enter your password.",
  비즈니스: "Business",
  "비즈니스 브랜드 로고": "Business brand logo",
  "비즈니스 수강내역": "Business course history",
  "사업자 정보 확인": "Check business information",
  "사업자번호: 499-81-00612": "Business Registration No.: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "Go to user dashboard page",
  "사용자 알림 페이지로 이동": "Go to user notification page",
  서비스: "Service",
  "서비스 언어를 선택하세요.": "Select the service language.",
  "선수 지식이 필요한": "Prerequisite knowledge required",
  설정: "Settings",
  수강바구니: "Cart",
  "수강바구니에서 전체보기": "Go to cart",
  "수강코드 등록": "Register course code",
  수강평: "Review",
  "수강평 모아보기": "See all reviews",
  "수료증 확인": "See certificate",
  스터디: "Study Clubs",
  시간: "hr",
  신청하기: "Apply",
  "아이디(이메일) 찾기": "Find my ID (email)",
  애플: "Apple",
  어드민: "Admin",
  "언어 변경": "Change Language",
  "언어 설정": "Language Settings",
  원: "$",
  "유저 대시보드로 이동": "Go to user dashboard",
  "이 공지를 그만 볼래요": "Don't show me this notice",
  이메일: "Email",
  "이메일 또는 비밀번호를 확인해주세요.": "Check your email or password again.",
  "이메일 형식이 올바르지 않습니다.": "Invalid email format",
  "이메일을 입력해주세요.": "Enter your email.",
  "이어서 학습하기": "Continue learning",
  이용약관: "Terms of Use",
  인프랩: "Inflab",
  "인프랩 스토리": "Inflab story",
  "인프랩 실Log": "Inflab Log",
  "인프랩 테크": "Inflab tech",
  인프런: "Inflearn",
  "인프런 네이버 블로그 바로가기": "Go to Inflearn’s Naver blog",
  "인프런 네이버 포스트 바로가기": "Go to Inflearn’s Naver post",
  "인프런 메인 페이지로 이동": "Go to Inflearn main page",
  "인프런 브랜드 로고": "Inflearn brand logo",
  "인프런 비즈니스": "Inflearn business",
  "인프런 소개": "About Inflearn",
  "인프런 영문 브랜드 로고": "Inflearn English brand logo",
  "인프런 유튜브 바로가기": "Go to Inflearn’s YouTube channel",
  "인프런 인스타그램 바로가기": "Go to Inflearn’s Instagram",
  "인프런 제휴": "Inflearn partners",
  "인프런 통합 검색": "Search in Inflearn",
  "인프런 트위터 바로가기": "Go to Inflearn’s X (Twitter)",
  "인프런 페이스북 바로가기": "Go to Inflearn’s Facebook",
  "인프런 피드": "Inflearn feed",
  "인프런으로 이동하기": "Go to Inflearn",
  입문: "Beginner",
  잎: "leaf",
  "자유롭게 학습하는 환경을 제공하세요.": "learn all they want through Inflearn’s courses.",
  "자주묻는 질문": "FAQ",
  "작성한 게시글": "Written posts",
  "장바구니 페이지로 이동": "Go to cart page",
  "저작권 신고센터": "Report copyright issues",
  "전문성을 높이는": "Enhancing expertise",
  전체: "All",
  "전체 강의": "All courses",
  "전화번호: 070-4948-1181": "Phone: 070-4948-1181",
  좋아요: "Likes",
  주소: "Address",
  중급이상: "Intermediate",
  "지금 둘러 보기": "Check out now",
  지식공유: "Instructor",
  "지식공유 참여": "Teach on Inflearn",
  지식공유자: "Instructors",
  "지식공유자 되기": "Teach on Inflearn",
  지식공유참여: "Teach on Inflearn",
  지식공유하기: "Share Knowledge",
  "질문 & 답변": "QnA",
  "질문 게시판": "Questions",
  "채널톡 아이콘": "ChannelTalk icon",
  챌린지: "Challenge",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Something went wrong. Please try again later.",
  "청강대 게임스쿨": "Chungkang College Game School",
  초: "sec",
  초급: "Basic",
  "총 결제금액": "Total amount",
  "최근 강의 바로가기": "Go to recent course",
  "최근 로그인": "Recent login",
  카카오: "Kakao",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "KakaoTalk does not support Google Login.",
  "카테고리 설정": "Set category",
  커리어: "Career",
  커뮤니티: "Community",
  "코드 등록": "Register Code",
  쿠폰: "Coupon",
  "통신판매업: 2018-성남분당B-0062": "E-Commerce Business: 2018-SeongnamBundangB-0062",
  "특정 상거래법": "",
  "팀 프로젝트": "Team Projects",
  파트너스: "Partners",
  포인트: "Points",
  "포인트코드 등록": "Register point code",
  학생: "Student",
  "할인 종료까지": "Discount ends in",
  홈: "Home",
  확인: "OK",
  회원가입: "Sign up",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Surprise! Enjoy a special {{discountPercent}}% thank-you discount on our courses – don’t miss out!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 A special discount for new members has been applied to courses, so don’t wait and grab it now!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Your first-purchase discount ({{discountPercent}}%) is already applied — start learning now!"
}, ra = {
  "(주)인프랩": "株式会社インフラップ",
  "(주)인프랩 사업자 정보": "株式会社インフラップ事業者情報",
  "3동 5층": "3棟5階",
  "IT 인재 채용 서비스": "IT人材採用サービス",
  "MY 카테고리": "私のカテゴリ",
  "With us": "ウィズアス",
  "{{category.title}} > 전체": "{{category.title}} > 全体",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}さん、インフランと一緒にいてくれてありがとう。😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}さんの初飛躍を応援しています。🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}さんのキャリアを応援しています。👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}さんのプロフィール画像",
  "{{provider}}-로그인-버튼": "{{provider}}-ログイン-ボタン",
  "{{socialProviderNameMap[provider]}}로 로그인": "{{socialProviderNameMap[provider]}}でログイン",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "「インフラントビジネス」を通じてすべてのチームメンバーがインフランの講義を",
  "가입 이메일 인증이 필요합니다.": "登録メールの認証が必要です。",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `メール認証が必要なアカウントです。
24時間後に再度お試しいただくか、カスタマーサポートへお問い合わせください。`,
  "간편 로그인": "簡単ログイン",
  강의: "講義",
  "강의 · 기능요청": "講義・機能リクエスト",
  "강의/강사명을 입력해주세요": "講義/講師名を入力してください",
  "강의리스트 보기": "講義リストを見る",
  개: "個",
  "개인정보보호책임자: 이동욱": "個人情報保護責任者：イ・ドンウク",
  개인정보처리방침: "個人情報処理方針",
  검색: "検索",
  "검색바.01": "今日は何を学びますか？",
  "검색바.02": "今すぐ検索",
  "검색바.03": "キーワード入力",
  "검색바.04": "今学びたいことは何ですか？",
  "검색바.05": "「プログラミング」で検索",
  "검색바.06": "「Python」で検索",
  "검색바.07": "「デザイン」で検索",
  "검색바.08": "新しい学び、新しい未来ーインフラン",
  "검색바.09": "今日は何を学びますか？",
  "검색바.10": "「デザイン」で検索",
  "검색바.11": "キーワード入力",
  "검색할 강의 입력": "講義名を入力",
  "경기도 성남시 분당구 판교로289번길 20": "京畿道城南市盆唐区パンギョ路289番道20",
  "경제적 보상을 받아보세요.": "経済的な報酬を受け取ってください。",
  "계정 설정": "アカウント設定",
  고객센터: "カスタマーセンター",
  고민있어요: "悩みがありますか",
  공지사항: "お知らせ",
  교육: "教育",
  구글: "グーグル",
  "구매 / 혜택": "購入 / 特典",
  "구매 내역": "購入履歴",
  국비지원교육: "国費支援教育",
  기업: "企業",
  "기업 교육을 위한 인프런": "企業教育のためのインフラン",
  깃허브: "ギットハブ",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "私を成長させてくれる良い知識を探してみてください。",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "私の本当の成長を助ける実務講義を探してみてください",
  난이도: "レベル",
  "난이도 선택": "レベルを選択",
  "난이도 옵션": "レベルオプション",
  "난이도 초기화": "レベルをリセット",
  "나한테 딱 맞는 걸 찾고 싶다면": "ぴったりな講座をお探しなら",
  "어떤 강의가 나한테 맞을까?": "自分に合う講座はどれ？",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "目標に合った講座を見つける",
  "지금 많이 듣는 강의 확인해보세요": "今人気の講座をチェックしてみましょう",
  "남았어요.": "残っています。",
  "내 학습": "私の学習",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "ネイバーではグーグルログインをサポートしていません。",
  "누구나 들을 수 있는": "誰でも受講できる",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "他のモバイルブラウザ（Chrome、Safari）をご利用ください。",
  닫기: "閉じる",
  "담긴 강의가 없습니다.": "含まれている講義はありません。",
  대시보드: "ダッシュボード",
  "대표자: 이형주": "代表者：イ・ヒョンジュ",
  더보기: "もっと見る",
  둘러보기: "閲覧",
  "딱 맞는 강의가 기다리고 있어요.": "ぴったりの講義が待っています。",
  "랠릿 서비스 링크": "レリットサービスリンク",
  로그아웃: "ログアウト",
  로그인: "ログイン",
  "로그인 또는 회원가입": "ログインまたは新規登録",
  "로그인이 필요한 요청입니다.": "ログインが必要なリクエストです。",
  로드맵: "ロードマップ",
  "마음에 드는 강의를 수강해보세요!": "気に入った講義を受けてみてください！",
  "많은 사람들에게 배움의 기회를 주고,": "多くの人々に学習の機会を与え、",
  "메인 페이지로 이동하기": "メインページに移動する",
  멘토링: "メンタリング",
  "멘토링 소개": "メンタリング紹介",
  "멘토링 후기": "メンタリング後記",
  "모임/부트캠프": "集まり/ブートキャンプ",
  "문제가 발생했습니다.": "問題が発生しました。",
  보관함: "保管箱",
  분: "分",
  블로그: "ブログ",
  비밀번호: "パスワード",
  "비밀번호 찾기": "パスワード探し",
  "비밀번호를 입력해주세요.": "パスワードを入力してください。",
  비즈니스: "ビジネス",
  "비즈니스 브랜드 로고": "ビジネスブランドロゴ",
  "비즈니스 수강내역": "ビジネス受講履歴",
  "사업자 정보 확인": "事業者情報確認",
  "사업자번호: 499-81-00612": "事業者番号：499-81-00612",
  "사용자 대시보드 페이지로 이동": "ユーザーダッシュボードページに移動",
  "사용자 알림 페이지로 이동": "ユーザー通知ページに移動",
  서비스: "サービス",
  "서비스 언어를 선택하세요.": "サービス言語を選択してください。",
  "선수 지식이 필요한": "前提知識が必要な",
  설정: "設定",
  수강바구니: "受講カート",
  "수강바구니에서 전체보기": "受講カートで全体を見る",
  "수강코드 등록": "受講コード登録",
  수강평: "受講評価",
  "수강평 모아보기": "受講評価をまとめて見る",
  "수료증 확인": "修了証確認",
  스터디: "スタディ",
  시간: "時間",
  신청하기: "申し込む",
  "아이디(이메일) 찾기": "ID（メール）検索",
  애플: "アップル",
  어드민: "アドミン",
  "언어 변경": "言語変更",
  "언어 설정": "言語設定",
  원: "ウォン",
  "유저 대시보드로 이동": "ユーザーダッシュボードに移動",
  "이 공지를 그만 볼래요": "この通知をもう見たくない",
  이메일: "メール",
  "이메일 또는 비밀번호를 확인해주세요.": "メールまたはパスワードを確認してください。",
  "이메일 형식이 올바르지 않습니다.": "メールアドレスの形式が正しくありません。",
  "이메일을 입력해주세요.": "メールを入力してください。",
  "이어서 학습하기": "続けて学習する",
  이용약관: "利用約款",
  인프랩: "インフラップ",
  "인프랩 스토리": "インフラップストーリー",
  "인프랩 실Log": "インフラップ実ログ",
  "인프랩 테크": "インフラップテック",
  인프런: "インフラン",
  "인프런 네이버 블로그 바로가기": "インフランネイバーブログ直接リンク",
  "인프런 네이버 포스트 바로가기": "インフランネイバーポスト直接リンク",
  "인프런 메인 페이지로 이동": "インフランメインページに移動",
  "인프런 브랜드 로고": "インフランブランドロゴ",
  "인프런 비즈니스": "インフランビジネス",
  "인프런 소개": "インフラン紹介",
  "인프런 영문 브랜드 로고": "インフラン英文ブランドロゴ",
  "인프런 유튜브 바로가기": "インフランユーチューブ直接リンク",
  "인프런 인스타그램 바로가기": "インフランインスタグラム直接リンク",
  "인프런 제휴": "インフラン提携",
  "인프런 통합 검색": "インフラン統合検索",
  "인프런 트위터 바로가기": "インフラントゥイッター直接リンク",
  "인프런 페이스북 바로가기": "インフランフェイスブック直接リンク",
  "인프런 피드": "インフランフィード",
  "인프런으로 이동하기": "インフランへ移動する",
  입문: "入門",
  잎: "リーフ",
  "자유롭게 학습하는 환경을 제공하세요.": "自由に学習できる環境を提供してください。",
  "자주묻는 질문": "よくある質問",
  "작성한 게시글": "作成した投稿",
  "장바구니 페이지로 이동": "カートページに移動",
  "저작권 신고센터": "著作権通報センター",
  "전문성을 높이는": "専門性を高める",
  전체: "全体",
  "전체 강의": "全体講義",
  "전화번호: 070-4948-1181": "電話番号：070-4948-1181",
  좋아요: "いいね",
  주소: "住所",
  중급이상: "中級以上",
  "지금 둘러 보기": "今すぐ見る",
  지식공유: "知識共有",
  "지식공유 참여": "知識共有参加",
  지식공유자: "知識共有者",
  "지식공유자 되기": "知識共有者になる",
  지식공유참여: "知識共有参加",
  지식공유하기: "知識を共有",
  "질문 & 답변": "質問と回答",
  "질문 게시판": "質問掲示板",
  "채널톡 아이콘": "チャンネルトークアイコン",
  챌린지: "Challenge",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "処理中にエラーが発生しました。しばらくしてから再試行してください。",
  "청강대 게임스쿨": "青江大ゲームスクール",
  초: "秒",
  초급: "初級",
  "총 결제금액": "総決済金額",
  "최근 강의 바로가기": "最近の講義への直接リンク",
  "최근 로그인": "最近のログイン",
  카카오: "カカオ",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "カカオトークではグーグルログインをサポートしていません。",
  "카테고리 설정": "カテゴリ設定",
  커리어: "キャリア",
  커뮤니티: "コミュニティ",
  "코드 등록": "コード登録",
  쿠폰: "クーポン",
  "통신판매업: 2018-성남분당B-0062": "通信販売業：2018-城南盆唐B-0062",
  "특정 상거래법": "特定商取引法",
  "팀 프로젝트": "チームプロジェクト",
  파트너스: "パートナーズ",
  포인트: "ポイント",
  "포인트코드 등록": "ポイントコード登録",
  학생: "学生",
  "할인 종료까지": "割引終了まで",
  홈: "ホーム",
  확인: "確認",
  회원가입: "会員登録",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 サプライズ感謝割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 新規登録割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 初購入割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！"
}, da = {
  "(주)인프랩": "(주)인프랩",
  "(주)인프랩 사업자 정보": "(주)인프랩 사업자 정보",
  "3동 5층": "3동 5층",
  "IT 인재 채용 서비스": "IT 인재 채용 서비스",
  "MY 카테고리": "MY 카테고리",
  "With us": "With us",
  "{{category.title}} > 전체": "{{category.title}} > 전체",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}님 인프런과 함께 해주셔서 감사해요.😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}님의 첫 도약을 응원하고 있어요. 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}님의 커리어를 응원하고 있어요. 👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}님의 프로필 이미지",
  "{{provider}}-로그인-버튼": "{{provider}}-로그인-버튼",
  "{{socialProviderNameMap[provider]}}로 로그인": "{{socialProviderNameMap[provider]}}로 로그인",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를",
  "가입 이메일 인증이 필요합니다.": "가입 이메일 인증이 필요합니다.",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `이메일 인증이 필요한 계정입니다.
24시간 후 재시도하거나 고객센터에 문의해주세요.`,
  "간편 로그인": "간편 로그인",
  강의: "강의",
  "강의 · 기능요청": "강의 · 기능요청",
  "강의/강사명을 입력해주세요": "강의/강사명을 입력해주세요",
  "강의리스트 보기": "강의리스트 보기",
  개: "개",
  "개인정보보호책임자: 이동욱": "개인정보보호책임자: 이동욱",
  개인정보처리방침: "개인정보처리방침",
  검색: "검색",
  "검색바.01": "우리는 성장 기회의 평등을 추구합니다.",
  "검색바.02": "요즘 관심 있는 주제나 기술이 있나요?",
  "검색바.03": "진짜 성장을 도와줄 강의를 찾아보세요.",
  "검색바.04": "실전에서 쓸 지식을 지금 배워보세요.",
  "검색바.05": "인프런에서 성장 여정을 시작해보세요.",
  "검색바.06": "성장을 위한 콘텐츠가 여기 있어요.",
  "검색바.07": "AI 시대에 필요한 무기, 지금 배워보세요.",
  "검색바.08": "지금 배우고싶은 지식을 찾아보세요.",
  "검색바.09": "우리는 성장 기회의 평등을 추구합니다.",
  "검색바.10": "성장하는 모든 사람을 응원합니다.",
  "검색바.11": "실전에 필요한 지식을 지금 배워보세요.",
  "검색할 강의 입력": "검색할 강의 입력",
  "경기도 성남시 분당구 판교로289번길 20": "경기도 성남시 분당구 판교로289번길 20",
  "경제적 보상을 받아보세요.": "경제적 보상을 받아보세요.",
  "계정 설정": "계정 설정",
  고객센터: "고객센터",
  고민있어요: "고민있어요",
  공지사항: "공지사항",
  교육: "교육",
  구글: "구글",
  "구매 / 혜택": "구매 / 혜택",
  "구매 내역": "구매 내역",
  국비지원교육: "국비지원교육",
  기업: "기업",
  "기업 교육을 위한 인프런": "기업 교육을 위한 인프런",
  깃허브: "깃허브",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "나를 성장 시켜줄 좋은 지식들을 찾아보세요.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요",
  "나한테 딱 맞는 걸 찾고 싶다면": "나한테 딱 맞는 걸 찾고 싶다면",
  "어떤 강의가 나한테 맞을까?": "어떤 강의가 나한테 맞을까?",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "목표·관심사에 맞는 인기 강의를 찾아드릴게요",
  "지금 많이 듣는 강의 확인해보세요": "지금 많이 듣는 강의 확인해보세요",
  난이도: "난이도",
  "난이도 선택": "난이도 선택",
  "난이도 옵션": "난이도 옵션",
  "난이도 초기화": "난이도 초기화",
  "남았어요.": "남았어요.",
  "내 학습": "내 학습",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "네이버에서 구글 로그인을 지원하지 않습니다.",
  "누구나 들을 수 있는": "누구나 들을 수 있는",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.",
  닫기: "닫기",
  "담긴 강의가 없습니다.": "담긴 강의가 없습니다.",
  대시보드: "대시보드",
  "대표자: 이형주": "대표자: 이형주",
  더보기: "더보기",
  둘러보기: "둘러보기",
  "딱 맞는 강의가 기다리고 있어요.": "딱 맞는 강의가 기다리고 있어요.",
  "랠릿 서비스 링크": "랠릿 서비스 링크",
  로그아웃: "로그아웃",
  로그인: "로그인",
  "로그인 또는 회원가입": "로그인 또는 회원가입",
  "로그인이 필요한 요청입니다.": "로그인이 필요한 요청입니다.",
  로드맵: "로드맵",
  "마음에 드는 강의를 수강해보세요!": "마음에 드는 강의를 수강해보세요!",
  "많은 사람들에게 배움의 기회를 주고,": "많은 사람들에게 배움의 기회를 주고,",
  "메인 페이지로 이동하기": "메인 페이지로 이동하기",
  멘토링: "멘토링",
  "멘토링 소개": "멘토링 소개",
  "멘토링 후기": "멘토링 후기",
  "모임/부트캠프": "모임/부트캠프",
  "문제가 발생했습니다.": "문제가 발생했습니다.",
  보관함: "보관함",
  분: "분",
  블로그: "블로그",
  비밀번호: "비밀번호",
  "비밀번호 찾기": "비밀번호 찾기",
  "비밀번호를 입력해주세요.": "비밀번호를 입력해주세요.",
  비즈니스: "비즈니스",
  "비즈니스 브랜드 로고": "비즈니스 브랜드 로고",
  "비즈니스 수강내역": "비즈니스 수강내역",
  "사업자 정보 확인": "사업자 정보 확인",
  "사업자번호: 499-81-00612": "사업자번호: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "사용자 대시보드 페이지로 이동",
  "사용자 알림 페이지로 이동": "사용자 알림 페이지로 이동",
  서비스: "서비스",
  "서비스 언어를 선택하세요.": "서비스 언어를 선택하세요.",
  "선수 지식이 필요한": "선수 지식이 필요한",
  설정: "설정",
  수강바구니: "수강바구니",
  "수강바구니에서 전체보기": "수강바구니에서 전체보기",
  "수강코드 등록": "수강코드 등록",
  수강평: "수강평",
  "수강평 모아보기": "수강평 모아보기",
  "수료증 확인": "수료증 확인",
  스터디: "스터디",
  시간: "시간",
  신청하기: "신청하기",
  "아이디(이메일) 찾기": "아이디(이메일) 찾기",
  애플: "애플",
  어드민: "어드민",
  "언어 변경": "언어 변경",
  "언어 설정": "언어 설정",
  원: "원",
  "유저 대시보드로 이동": "유저 대시보드로 이동",
  "이 공지를 그만 볼래요": "이 공지를 그만 볼래요",
  이메일: "이메일",
  "이메일 또는 비밀번호를 확인해주세요.": "이메일 또는 비밀번호를 확인해주세요.",
  "이메일 형식이 올바르지 않습니다.": "이메일 형식이 올바르지 않습니다.",
  "이메일을 입력해주세요.": "이메일을 입력해주세요.",
  "이어서 학습하기": "이어서 학습하기",
  이용약관: "이용약관",
  인프랩: "인프랩",
  "인프랩 스토리": "인프랩 스토리",
  "인프랩 실Log": "인프랩 실Log",
  "인프랩 테크": "인프랩 테크",
  인프런: "인프런",
  "인프런 네이버 블로그 바로가기": "인프런 네이버 블로그 바로가기",
  "인프런 네이버 포스트 바로가기": "인프런 네이버 포스트 바로가기",
  "인프런 메인 페이지로 이동": "인프런 메인 페이지로 이동",
  "인프런 브랜드 로고": "인프런 브랜드 로고",
  "인프런 비즈니스": "인프런 비즈니스",
  "인프런 소개": "인프런 소개",
  "인프런 영문 브랜드 로고": "인프런 영문 브랜드 로고",
  "인프런 유튜브 바로가기": "인프런 유튜브 바로가기",
  "인프런 인스타그램 바로가기": "인프런 인스타그램 바로가기",
  "인프런 제휴": "인프런 제휴",
  "인프런 통합 검색": "인프런 통합 검색",
  "인프런 트위터 바로가기": "인프런 트위터 바로가기",
  "인프런 페이스북 바로가기": "인프런 페이스북 바로가기",
  "인프런 피드": "인프런 피드",
  "인프런으로 이동하기": "인프런으로 이동하기",
  입문: "입문",
  잎: "잎",
  "자유롭게 학습하는 환경을 제공하세요.": "자유롭게 학습하는 환경을 제공하세요.",
  "자주묻는 질문": "자주묻는 질문",
  "작성한 게시글": "작성한 게시글",
  "장바구니 페이지로 이동": "장바구니 페이지로 이동",
  "저작권 신고센터": "저작권 신고센터",
  "전문성을 높이는": "전문성을 높이는",
  전체: "전체",
  "전체 강의": "전체 강의",
  "전화번호: 070-4948-1181": "전화번호: 070-4948-1181",
  좋아요: "좋아요",
  주소: "주소",
  중급이상: "중급이상",
  "지금 둘러 보기": "지금 둘러 보기",
  지식공유: "지식공유",
  "지식공유 참여": "지식공유 참여",
  지식공유자: "지식공유자",
  "지식공유자 되기": "지식공유자 되기",
  지식공유참여: "지식공유참여",
  지식공유하기: "지식공유하기",
  "질문 & 답변": "질문 & 답변",
  "질문 게시판": "질문 게시판",
  "채널톡 아이콘": "채널톡 아이콘",
  챌린지: "챌린지",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  "청강대 게임스쿨": "청강대 게임스쿨",
  초: "초",
  초급: "초급",
  "총 결제금액": "총 결제금액",
  "최근 강의 바로가기": "최근 강의 바로가기",
  "최근 로그인": "최근 로그인",
  카카오: "카카오",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "카카오톡에서 구글 로그인을 지원하지 않습니다.",
  "카테고리 설정": "카테고리 설정",
  커리어: "커리어",
  커뮤니티: "커뮤니티",
  "코드 등록": "코드 등록",
  쿠폰: "쿠폰",
  "통신판매업: 2018-성남분당B-0062": "통신판매업: 2018-성남분당B-0062",
  "특정 상거래법": "",
  "팀 프로젝트": "팀 프로젝트",
  파트너스: "파트너스",
  포인트: "포인트",
  "포인트코드 등록": "포인트코드 등록",
  학생: "학생",
  "할인 종료까지": "할인 종료까지",
  홈: "홈",
  확인: "확인",
  회원가입: "회원가입",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!"
}, oa = {
  "(주)인프랩": "Công ty TNHH Inflab",
  "(주)인프랩 사업자 정보": "Thông tin doanh nghiệp Công ty TNHH Inflab",
  "3동 5층": "Đại Hàn Dân Quốc",
  "IT 인재 채용 서비스": "Dịch vụ tuyển dụng nhân tài IT",
  "MY 카테고리": "Danh mục của tôi",
  "With us": "Cùng chúng tôi",
  "{{category.title}} > 전체": "{{category.title}} > Tất cả",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}, cảm ơn bạn đã đồng hành cùng Inflearn 😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}, chúng tôi cổ vũ bước tiến đầu tiên của bạn 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}, chúng tôi cổ vũ cho sự nghiệp của bạn 👏",
  "{{profile?.name}}님의 프로필 이미지": "Hình ảnh hồ sơ của {{profile?.name}}",
  "{{provider}}-로그인-버튼": "Nút đăng nhập {{provider}}",
  "{{socialProviderNameMap[provider]}}로 로그인": "Đăng nhập với {{socialProviderNameMap[provider]}}",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "Với 'Inflearn Business', tất cả thành viên trong đội có thể tham gia các khóa học của Inflearn",
  "가입 이메일 인증이 필요합니다.": "Cần xác thực email để đăng ký.",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `Tài khoản này cần xác thực email.
Vui lòng thử lại sau 24 giờ hoặc liên hệ bộ phận hỗ trợ khách hàng.`,
  "간편 로그인": "Đăng nhập nhanh",
  강의: "Khóa học",
  "강의 · 기능요청": "Yêu cầu khóa học/tính năng",
  "강의/강사명을 입력해주세요": "Vui lòng nhập tên khóa học/giảng viên",
  "강의리스트 보기": "Xem danh sách khóa học",
  개: "cái",
  "개인정보보호책임자: 이동욱": "Người phụ trách bảo mật thông tin cá nhân: Lee Dongwook",
  개인정보처리방침: "Chính sách bảo mật",
  검색: "Tìm kiếm",
  "검색바.01": "Bạn quan tâm gì hôm nay?",
  "검색바.02": "Nhập từ khóa bạn muốn.",
  "검색바.03": "Đang tìm gì cụ thể?",
  "검색바.04": "Nhập tên khóa học hoặc chủ đề.",
  "검색바.05": "Đang tìm khóa học Python?",
  "검색바.06": "Hãy thử gõ “Python”.",
  "검색바.07": "Bạn muốn rèn kỹ năng nào?",
  "검색바.08": "Khám phá khóa học mới.",
  "검색바.09": "Bạn quan tâm gì hôm nay?",
  "검색바.10": "Bạn muốn rèn kỹ năng nào?",
  "검색바.11": "Đang tìm gì cụ thể?",
  "검색할 강의 입력": "Nhập tên khóa học",
  "경기도 성남시 분당구 판교로289번길 20": "Tầng 5, Tòa nhà số 3, 20, Pangyo-ro 289beon-gil, Quận Bundang, Thành phố Seongnam, Gyeonggi-do",
  "경제적 보상을 받아보세요.": "Hãy nhận phần thưởng tài chính.",
  "계정 설정": "Cài đặt tài khoản",
  고객센터: "Trung tâm khách hàng",
  고민있어요: "Tôi cần giúp đỡ",
  공지사항: "Thông báo",
  교육: "Đào tạo",
  구글: "Google",
  "구매 / 혜택": "Mua hàng / Ưu đãi ",
  "구매 내역": "Lịch sử mua hàng",
  국비지원교육: "Khóa học được hỗ trợ bởi nhà nước",
  기업: "Doanh nghiệp",
  "기업 교육을 위한 인프런": "Inflearn cho giáo dục doanh nghiệp",
  깃허브: "GitHub",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "Hãy tìm kiếm những kiến thức tuyệt vời giúp bạn phát triển.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "Tìm các khóa học thực tiễn giúp bạn thực sự phát triển.",
  난이도: "Cấp độ",
  "난이도 선택": "Chọn cấp độ",
  "난이도 옵션": "Tùy chọn cấp độ",
  "난이도 초기화": "Đặt lại cấp độ",
  "나한테 딱 맞는 걸 찾고 싶다면": "Bạn muốn tìm khóa học phù hợp?",
  "어떤 강의가 나한테 맞을까?": "Khóa học nào phù hợp với tôi?",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "Tìm khóa học cho mục tiêu của bạn",
  "지금 많이 듣는 강의 확인해보세요": "Xem ngay những khóa học đang được học nhiều nhất",
  "남았어요.": "còn lại.",
  "내 학습": "Học tập của tôi",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "Naver không hỗ trợ đăng nhập bằng Google.",
  "누구나 들을 수 있는": "Mở cho tất cả mọi người",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "Vui lòng sử dụng trình duyệt di động khác (Chrome, Safari).",
  닫기: "Đóng",
  "담긴 강의가 없습니다.": "Không có khóa học nào trong giỏ hàng.",
  대시보드: "Bảng điều khiển",
  "대표자: 이형주": "Người đại diện: Lee Hyeongjoo",
  더보기: "Xem thêm",
  둘러보기: "Khám phá",
  "딱 맞는 강의가 기다리고 있어요.": "Khóa học phù hợp nhất đang chờ bạn.",
  "랠릿 서비스 링크": "Liên kết dịch vụ Rallit",
  로그아웃: "Đăng xuất",
  로그인: "Đăng nhập",
  "로그인 또는 회원가입": "Đăng nhập hoặc Đăng ký",
  "로그인이 필요한 요청입니다.": "Bạn cần đăng nhập để thực hiện yêu cầu này.",
  로드맵: "Lộ trình",
  "마음에 드는 강의를 수강해보세요!": "Hãy tham gia khóa học bạn yêu thích!",
  "많은 사람들에게 배움의 기회를 주고,": "Mang lại cơ hội học tập cho nhiều người,",
  "메인 페이지로 이동하기": "Đi đến trang chính",
  멘토링: "Mentoring",
  "멘토링 소개": "Giới thiệu mentoring",
  "멘토링 후기": "Đánh giá mentoring",
  "모임/부트캠프": "Câu lạc bộ/Bootcamp",
  "문제가 발생했습니다.": "Đã xảy ra sự cố.",
  보관함: "Kho lưu trữ",
  분: "phút",
  블로그: "Blog",
  비밀번호: "Mật khẩu",
  "비밀번호 찾기": "Tìm mật khẩu",
  "비밀번호를 입력해주세요.": "Vui lòng nhập mật khẩu.",
  비즈니스: "Doanh nghiệp",
  "비즈니스 브랜드 로고": "Logo thương hiệu doanh nghiệp",
  "비즈니스 수강내역": "Lịch sử khóa học doanh nghiệp",
  "사업자 정보 확인": "Kiểm tra thông tin doanh nghiệp",
  "사업자번호: 499-81-00612": "Mã số kinh doanh: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "Đi đến trang bảng điều khiển người dùng",
  "사용자 알림 페이지로 이동": "Đi đến trang thông báo của người dùng",
  서비스: "Dịch vụ",
  "서비스 언어를 선택하세요.": "Vui lòng chọn ngôn ngữ dịch vụ.",
  "선수 지식이 필요한": "Yêu cầu kiến thức nền tảng",
  설정: "Cài đặt",
  수강바구니: "Giỏ khóa học",
  "수강바구니에서 전체보기": "Xem toàn bộ trong giỏ khóa học",
  "수강코드 등록": "Đăng ký mã khóa học",
  수강평: "Đánh giá khóa học",
  "수강평 모아보기": "Xem tất cả đánh giá",
  "수료증 확인": "Xem chứng chỉ hoàn thành",
  스터디: "Câu lạc bộ học tập",
  시간: "giờ",
  신청하기: "Đăng ký",
  "아이디(이메일) 찾기": "Tìm ID (email)",
  애플: "Apple",
  어드민: "Quản trị viên",
  "언어 변경": "Thay đổi ngôn ngữ",
  "언어 설정": "Cài đặt ngôn ngữ",
  원: "₫",
  "유저 대시보드로 이동": "Đi đến bảng điều khiển người dùng",
  "이 공지를 그만 볼래요": "Không muốn thấy thông báo này nữa",
  이메일: "Email",
  "이메일 또는 비밀번호를 확인해주세요.": "Vui lòng kiểm tra lại email hoặc mật khẩu.",
  "이메일 형식이 올바르지 않습니다.": "Định dạng email không hợp lệ.",
  "이메일을 입력해주세요.": "Vui lòng nhập email.",
  "이어서 학습하기": "Tiếp tục học",
  이용약관: "Điều khoản sử dụng",
  인프랩: "Inflab",
  "인프랩 스토리": "Câu chuyện về Inflab",
  "인프랩 실Log": "Nhật ký của Inflab",
  "인프랩 테크": "Công nghệ của Inflab",
  인프런: "Inflearn",
  "인프런 네이버 블로그 바로가기": "Đi đến blog Naver của Inflearn",
  "인프런 네이버 포스트 바로가기": "Đi đến bài viết Naver của Inflearn",
  "인프런 메인 페이지로 이동": "Đi đến trang chính của Inflearn",
  "인프런 브랜드 로고": "Logo thương hiệu Inflearn",
  "인프런 비즈니스": "Inflearn doanh nghiệp",
  "인프런 소개": "Giới thiệu Inflearn",
  "인프런 영문 브랜드 로고": "Logo thương hiệu tiếng Anh của Inflearn",
  "인프런 유튜브 바로가기": "Đi đến kênh YouTube của Inflearn",
  "인프런 인스타그램 바로가기": "Đi đến Instagram của Inflearn",
  "인프런 제휴": "Đối tác Inflearn",
  "인프런 통합 검색": "Tìm kiếm trong Inflearn",
  "인프런 트위터 바로가기": "Đi đến X (Twitter) của Inflearn",
  "인프런 페이스북 바로가기": "Đi đến Facebook của Inflearn",
  "인프런 피드": "Bảng tin Inflearn",
  "인프런으로 이동하기": "Đi đến Inflearn",
  입문: "Nhập môn",
  잎: "lá",
  "자유롭게 학습하는 환경을 제공하세요.": "Hãy cung cấp một môi trường học tập tự do.",
  "자주묻는 질문": "Câu hỏi thường gặp",
  "작성한 게시글": "Bài viết đã tạo",
  "장바구니 페이지로 이동": "Đi đến trang giỏ hàng",
  "저작권 신고센터": "Trung tâm báo cáo vi phạm bản quyền",
  "전문성을 높이는": "Nâng cao chuyên môn",
  전체: "Tất cả",
  "전체 강의": "Tất cả khóa học",
  "전화번호: 070-4948-1181": "Số điện thoại: 070-4948-1181",
  좋아요: "Thích",
  주소: "Địa chỉ",
  중급이상: "Trung cấp trở lên",
  "지금 둘러 보기": "Xem ngay bây giờ",
  지식공유: "Chia sẻ kiến thức",
  "지식공유 참여": "Tham gia chia sẻ kiến thức",
  지식공유자: "Người chia sẻ kiến thức",
  "지식공유자 되기": "Trở thành người chia sẻ kiến thức",
  지식공유참여: "Tham gia chia sẻ kiến thức",
  지식공유하기: "Chia sẻ kiến thức",
  "질문 & 답변": "Hỏi & Đáp",
  "질문 게시판": "Bảng câu hỏi",
  "채널톡 아이콘": "Biểu tượng ChannelTalk",
  챌린지: "Challenge",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Đã xảy ra lỗi trong quá trình xử lý. Vui lòng thử lại sau.",
  "청강대 게임스쿨": "Trường Game Chungkang",
  초: "giây",
  초급: "Cơ bản",
  "총 결제금액": "Tổng số tiền thanh toán",
  "최근 강의 바로가기": "Đi đến khóa học gần đây",
  "최근 로그인": "Đăng nhập gần đây",
  카카오: "Kakao",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "KakaoTalk không hỗ trợ đăng nhập bằng Google.",
  "카테고리 설정": "Cài đặt danh mục",
  커리어: "Sự nghiệp",
  커뮤니티: "Cộng đồng",
  "코드 등록": "Đăng ký mã",
  쿠폰: "Coupon",
  "통신판매업: 2018-성남분당B-0062": "Ngành bán hàng trực tuyến: 2018-SeongnamBundangB-0062",
  "특정 상거래법": "",
  "팀 프로젝트": "Dự án nhóm",
  파트너스: "Đối tác",
  포인트: "Điểm",
  "포인트코드 등록": "Đăng ký mã điểm",
  학생: "Học sinh",
  "할인 종료까지": "Kết thúc giảm giá trong",
  홈: "Trang chủ",
  확인: "Xác nhận",
  회원가입: "Đăng ký thành viên",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá cảm ơn bất ngờ ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá cho thành viên mới ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá lần mua đầu tiên ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!"
}, jc = {
  ko: {
    appShell: da
  },
  en: {
    appShell: ua
  },
  vi: {
    appShell: oa
  },
  ja: {
    appShell: ra
  }
}, Dc = Object.keys(jc), qg = F.createInstance();
qg.use(Pc).use(rb).init({
  defaultNS: "appShell",
  fallbackLng: cg,
  supportedLngs: Dc,
  detection: {
    order: ["path"]
  },
  interpolation: {
    escapeValue: !1
  },
  debug: !1,
  cleanCode: !0,
  // e.g. EN -> en
  resources: jc
});
function Ga(g) {
  return !!Dc.find((I) => I === g);
}
function lg() {
  return Ga(qg.language) ? qg.language : cg;
}
function kc() {
  return lg() === cg;
}
function Ks(g, I) {
  return () => qg.t(g, I) ?? "";
}
function _s(g, I = lg()) {
  return D.stringifyUrl({
    url: g,
    query: {
      lang: I
    }
  });
}
const tg = {
  EMAIL: "info@inflearn.com",
  SITE: PI,
  MEMBER_HISTORY: "https://doc.clickup.com/d/3gfz7-5843/log/3gfz7-75205/%EC%9D%B8%ED%94%84%EB%9E%A9-%EC%8B%A4-log",
  STORY: "https://story.inflab.com/",
  TECH_BLOG: "https://tech.inflab.com/",
  RALLIT_BUSINESS: "https://business.rallit.com/"
};
function Xa() {
  return kc() ? tg.SITE : `${tg.SITE}/${lg()}`;
}
function Z(g, I) {
  const e = I ?? (gb === "localhost" ? "" : tg.SITE), c = g.startsWith("/") ? g : `/${g}`;
  return kc() ? `${e}${c}` : `${e}/${lg()}${c}`;
}
const qs = {
  INFO_PRIVACY: Z("/policy/privacy"),
  INFO_TERMS: Z("/policy/terms-of-service"),
  BIZ_INFO: "http://www.ftc.go.kr/bizCommPop.do?wrkr_no=4998100612",
  INF_EMAIL: `mailto:${tg.EMAIL}`
}, $s = {
  SPECIFIED_COMMERCIAL_TRANSACTIONS: `${tg.SITE}/ja/policy/specified-commercial-transactions`
}, gA = {
  RALLIT_SITE: Ge,
  RALLIT_MY_LOG: `${Ge}/my/log`
}, IA = `${tg.SITE}/channeltalk`, k = {
  CHALLENGES: Z("/challenges"),
  MAIN: Xa(),
  WITH_US: Z("/pages/withus"),
  INSTRUCTOR: Z(lg() === cg ? "/instructor" : "/instructor/courses"),
  INSTRUCTOR_ABROAD: Z("/instructor/courses"),
  APPLY_INSTRUCTOR: Z("/instructor/application"),
  APPLY_B2B: Z("/intro-group"),
  SIGN_UP: Z("/signup"),
  SIGN_IN: Z("/signin"),
  SIGNUP_EMAIL_REVERIFY: Z("/signup/email/reverify"),
  INTRO_GROUP: Z("/intro-group"),
  COURSES: (g) => {
    const I = g != null && g.category ? `/${g == null ? void 0 : g.category}` : "", e = g != null && g.subCategory ? `/${g == null ? void 0 : g.subCategory}` : "", c = ((g == null ? void 0 : g.searchKeyword) ?? "").trim();
    return c ? k.SEARCH({
      order: g == null ? void 0 : g.order,
      types: g == null ? void 0 : g.types,
      skill: g == null ? void 0 : g.skill,
      searchKeyword: c,
      completionAttributionToken: g == null ? void 0 : g.completionAttributionToken,
      selectedSuggestion: g == null ? void 0 : g.selectedSuggestion,
      selectedPosition: g == null ? void 0 : g.selectedPosition,
      levels: g == null ? void 0 : g.levels,
      tab: g == null ? void 0 : g.tab
    }) : D.stringifyUrl({
      url: Z(`/courses${I}${e}`),
      query: {
        order: g == null ? void 0 : g.order,
        types: g == null ? void 0 : g.types,
        skill: g == null ? void 0 : g.skill,
        s: c,
        completionAttributionToken: g == null ? void 0 : g.completionAttributionToken,
        selectedSuggestion: g == null ? void 0 : g.selectedSuggestion,
        selectedPosition: g == null ? void 0 : g.selectedPosition,
        levels: g == null ? void 0 : g.levels,
        onboarding: g == null ? void 0 : g.onboarding,
        redirectTo: g == null ? void 0 : g.redirectTo
      }
    }, {
      skipNull: !0,
      skipEmptyString: !0
    });
  },
  SEARCH: (g) => D.stringifyUrl({
    url: Z("/search"),
    query: {
      order: g == null ? void 0 : g.order,
      types: g == null ? void 0 : g.types,
      skill: g == null ? void 0 : g.skill,
      s: g == null ? void 0 : g.searchKeyword,
      completionAttributionToken: g == null ? void 0 : g.completionAttributionToken,
      selectedSuggestion: g == null ? void 0 : g.selectedSuggestion,
      selectedPosition: g == null ? void 0 : g.selectedPosition,
      levels: g == null ? void 0 : g.levels,
      tab: g == null ? void 0 : g.tab
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  COMMUNITY: Z("/community"),
  COMMUNITY_USER_POSTS: Z("/my/posts/question"),
  COMMUNITY_WITH_SEARCH: ({
    keyword: g
  }) => D.stringifyUrl({
    url: Z("/community"),
    query: {
      s: g
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  ROADMAPS: Z("/roadmaps"),
  ROADMAPS_WITH_SEARCH: ({
    keyword: g,
    sort: I,
    pageNumber: e
  }) => D.stringifyUrl({
    url: Z("/roadmaps"),
    query: {
      s: g,
      sort: I,
      page_number: e
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  ENROLLED_ROADMAPS: Z("/user/roadmaps/enrolled"),
  MENTORS: Z("/mentors", jg),
  MENTORING_WITH_SEARCH: ({
    keyword: g
  }) => D.stringifyUrl({
    url: Z("/mentors", jg),
    query: {
      s: g
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  COMMUNITY_QUESTION: Z("/community/questions"),
  COMMUNITY_REVIEWS: Z("/community/reviews"),
  BLOGS: Z("/blogs"),
  COMMUNITY_STUDIES: Z("/community/studies"),
  COMMUNITY_CHATS: Z("/community/chats"),
  COMMUNITY_PROJECTS: Z("/community/projects"),
  COMMUNITY_MENTORINGS_REVIEWS: Z("/community/mentorings-reviews"),
  NOTICE_LIST: Z("/notices"),
  STORIES: Z("/pages"),
  INFLEARN: Z("/inflearn"),
  REQUEST_TO_INFLEARN: Z("/request-to-inflearn"),
  ACCOUNT_DASHBOARD: Z("/users/me/dashboard"),
  ACCOUNT_SETTING: Z("/my/settings/account"),
  CARTS: Z("/carts"),
  MESSAGE_LIST: Z("/user/messages"),
  EVENTS: Z("/pages?type=event"),
  LOGOUT: (g) => D.stringifyUrl({
    url: `${PI}/signout`,
    query: {
      lang: lg(),
      redirectTo: g.redirectTo
    }
  }),
  LECTURE_LAST_VOUCHER: (g, I) => Z(`/course/${g}/unit/${I}`),
  FIND_ID: Z("/signin/find/id"),
  청강대게임스쿨: Z("/tag-curation/tag/18123"),
  FIND_PW: Z("/signin/find/password"),
  USER_MENTORINGS: Z("/my/mentorings"),
  USER_POSTS: Z("/my/posts"),
  MY_PARTNERS: Z("/my/partners"),
  MY_PARTNERS_LINKS: Z("/my/partners-links"),
  PARTNERS_NEW: Z("/partners/new"),
  USER_INQUIRIES: Z("/user/inquiries"),
  USER_LIKES: Z("/my/likes"),
  USER_SETTINGS_ACCOUNT: Z("/my/settings/account"),
  USER_COURSES: Z("/my/courses"),
  MY_RECEIVED_GIFTS: Z("/my/gifts/received"),
  USER_POINT: Z("/user/points"),
  USER_COUPONS: Z("/user/coupons"),
  FAQ: Z("/faq"),
  KDT: Z("/tag-curation/common_tag/kdt"),
  PARTNERS_LANDING: Z("/pages/partners"),
  BUSINESS: (g) => `${Rc}/new/groups/${g}/dashboard`,
  BUSINESS_ENROLMENTS: Z("/biz-enrolments"),
  USER_PROFILE: (g, I) => Z(I ? `/users/${g}/@${I}` : `/users/${g}`),
  ORDERS: Z("/my/orders"),
  FIND_RECOMMEND_COURSES: Z("/courses?charge=free&order=seq"),
  CERTIFICATE: Z("/certificate"),
  COURSE_DETAIL: (g) => Z(`/course/${g}`),
  CLIPS: Z("/clips"),
  CLIPS_WITH_SEARCH: ({
    searchKeyword: g,
    sort: I
  }) => D.stringifyUrl({
    url: Z("/clips"),
    query: {
      s: g,
      sort: I
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  })
}, eA = {
  MY_CATEGORY: "my-category"
}, dI = {
  /** 푸터 등은 `/intro-group`(리다이렉트)을 쓰지만 여기는 비즈니스 도메인을 직접 가리킨다 */
  B2B: `${Rc}/intro`,
  LIFELONG_VOUCHER: Z("/pages/lifelongvoucher_2026"),
  /** ?from=header 는 트래킹용 파라미터  */
  AI_REFUND: `${Z("/pages/company_pre_b")}?from=header`
}, cA = {
  INTRO: Z("/inflearn"),
  FEED: Z("/pages"),
  OPEN_KNOWLEDGE: Z("/open-knowledge"),
  MENTORS_INTRO: Z("/mentors-intro"),
  INTRO_GROUP: Z("/intro-group"),
  PARTNERS: Z("/partners"),
  COURSE_CODE: Z("/course-code"),
  POINT_CODE: Z("/point-code"),
  COPYRIGHT: Z("/copyright"),
  REQUEST_TO_INFLEARN: Z("/request-to-inflearn")
}, lA = {
  NAVER_BLOG: "https://blog.naver.com/inflearn",
  INSTAGRAM: "https://www.instagram.com/inflearn__official",
  YOUTUBE: "https://www.youtube.com/channel/UC0Y0T9JpgIBbyGDjvy9PbOg",
  FACEBOOK: "https://www.facebook.com/inflearn",
  TWITTER: "https://twitter.com/inflearn",
  THREADS: "https://www.threads.com/@inflearn__official"
}, tA = {
  AI_CHAT: "https://www.inflearn.com/chat/set-cookie"
};
function Za() {
  const g = rl(), {
    analytics: I
  } = ul(), e = () => {
    var l, t;
    try {
      const i = g.getQueryData([JI.CLIENT_V2_ACCOUNTS_PROFILE]);
      if (!(i != null && i.data))
        return {
          user_id: null,
          user_name: null,
          user_email: null,
          user_group_id: null,
          user_group_subscription_id: null,
          role_b2b: !1,
          role_b2c: !1,
          role_admin: !1,
          role_instructor: !1
        };
      const {
        id: n,
        name: C,
        email: b
      } = i.data;
      return {
        user_id: n,
        user_name: C,
        user_email: b,
        user_group_id: (l = i.data.group) == null ? void 0 : l.id,
        user_group_subscription_id: (t = i.data.group) == null ? void 0 : t.groupSubscriptionId,
        role_b2b: RI(i.data),
        role_b2c: !RI(i.data),
        role_admin: i.data.isAdmin,
        role_instructor: i.data.isInstructor
      };
    } catch {
      return {
        user_id: null,
        user_name: null,
        user_email: null,
        user_group_id: null,
        user_group_subscription_id: null,
        role_b2b: !1,
        role_b2c: !1,
        role_admin: !1,
        role_instructor: !1
      };
    }
  };
  return {
    trackEvent: (l, t) => I.track(l, {
      mixpanelToken: eb,
      userId: e().user_id,
      mxp___user: e(),
      ...t
    })
  };
}
function ha() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const iA = process.env.NODE_ENV === "production" ? {
  name: "lidyt8",
  styles: "*{box-sizing:border-box;}a{text-decoration:none;}.hidden{display:none;}.disabledScroll{overflow:hidden;}"
} : {
  name: "ncoqxb-globals",
  styles: "*{box-sizing:border-box;}a{text-decoration:none;}.hidden{display:none;}.disabledScroll{overflow:hidden;};label:globals;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9zdHlsZXMvZ2xvYmFscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFbUIiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL3N0eWxlcy9nbG9iYWxzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5jb25zdCBnbG9iYWxzID0gY3NzYFxuICAqIHtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB9XG5cbiAgYSB7XG4gICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuICB9XG5cbiAgLmhpZGRlbiB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxuXG4gIC5kaXNhYmxlZFNjcm9sbCB7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgZ2xvYmFscztcbiJdfQ== */",
  toString: ha
}, nA = {
  mobile: 768,
  tablet: 1024,
  laptop: 1365,
  desktop: 1920
}, Sg = {
  desktop: "@media (max-width: 1200px)",
  tablet: "@media (max-width: 1024px)",
  mobile: "@media (max-width: 768px)",
  smallMobile: "@media (max-width: 480px)"
};
function w(g) {
  return g === "mobile" ? Sg.mobile : g === "tablet" ? Sg.tablet : Sg.desktop;
}
const MI = (g = !1) => ({
  HEADER: g ? 72 : 200,
  HEADER_NOTICE: g ? 73 : 201,
  SCRIM: g ? 10 : 200,
  // NOTE: drawer overlay
  MOBILE_ASIDE: g ? 76 : 201,
  // NOTE: drawer
  BOTTOM_NAVIGATION: g ? 74 : 200,
  MOVE_TOP: g ? 9 : 200,
  // NOTE: 모달  dimmed 영역의 zIndex 201보다 작아야 함
  POPOVER: g ? 10 : 15,
  SEARCHBAR_MODAL: 202
}), Va = {
  CHILDREN_WRAPPER: "children-wrapper",
  HEADER_DIVIDER_DESKTOP: "header-divider-desktop",
  HEADER_DIVIDER_MOBILE: "header-divider-mobile",
  HEADER_CONTAINER_DESKTOP: "header-container-desktop",
  HEADER_CONTAINER_MOBILE: "header-container-mobile",
  /**
   * @NOTE
   * 헤더 아래로 돌출되는 검색바 영역을 실제 레이아웃 공간으로 확보하는 스페이서.
   * main/footer 를 transform 으로 밀어내던 방식은 스크롤 중 콘텐츠가 움직이는
   * 체감 CLS(드득거림)를 유발해서 flow 상의 공간 확보로 대체함
   */
  HEADER_SEARCH_BAR_SPACER: "header-search-bar-spacer",
  FOOTER_CONTAINER: "footer-container",
  /**
   * @NOTE
   * 아래로 스크롤 했을 때 모바일 헤더 가려지게 하기 위한 식별자
   */
  HEADER_MOBILE_TOP: "header-mobile-top",
  /**
   * @NOTE
   * 아래로 스크롤 했을 때 바텀 네비 가려지게 하기 위한 식별자
   * 앤트맨에서 참조하기 위해 사용
   */
  HEADER_MOBILE_BOTTOM: "header-mobile-bottom",
  HEADER_INTEGRATED: "header-integrated"
}, De = {
  DESKTOP: 37,
  MOBILE: 34
}, Mc = {
  DESKTOP: {
    DEFAULT: 65,
    SEARCH_BAR: 80
  },
  MOBILE: {
    DEFAULT: 50,
    /** searchBarStyles 의 상단 패딩 4 + 검색바 46 + 하단 패딩 10 */
    SEARCH_BAR: 60
  }
}, Qc = Mc.DESKTOP.DEFAULT, bA = Mc.MOBILE.DEFAULT, Wa = /* @__PURE__ */ z({
  position: "relative",
  display: "flex",
  alignItems: "center",
  height: Qc,
  padding: "0 32px",
  maxWidth: 1440,
  width: "100%",
  minHeight: "unset",
  [w("tablet")]: {
    padding: "0 32px",
    height: "auto"
  },
  [w("mobile")]: {
    padding: "0 16px",
    height: "auto"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleHeaderContent;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ma = /* @__PURE__ */ z({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  height: De.DESKTOP,
  padding: "0 32px",
  maxWidth: 1440,
  width: "100%",
  [w("tablet")]: {
    height: De.MOBILE
  },
  [w("mobile")]: {
    padding: "0 16px"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleIntegratedHeaderContent;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function Na() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const xa = [{
  label: "기업 교육",
  href: dI.B2B,
  value: "integrated_b2b"
}, {
  label: "평생교육이용권",
  href: dI.LIFELONG_VOUCHER,
  value: "integrated_lifelong_voucher"
}, {
  label: "AI 교육 90% 환급",
  href: dI.AI_REFUND,
  value: "integrated_ai_refund"
}], Ra = ({
  onLinkClick: g,
  containerStyles: I
}) => /* @__PURE__ */ h(H, { css: [ma, I, process.env.NODE_ENV === "production" ? "" : ";label:IntegratedHeaderLinks;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ h(B, { spacing: 12, align: "center", noWrap: !0, children: xa.map(({
  label: e,
  href: c,
  value: l
}, t) => /* @__PURE__ */ T(B, { spacing: 12, align: "center", noWrap: !0, children: [
  t !== 0 && /* @__PURE__ */ h(H, { css: pa }),
  /* @__PURE__ */ h(vI, { href: c, underline: !1, onClick: () => g == null ? void 0 : g(l), children: /* @__PURE__ */ h(BI, { css: ya, children: e }) })
] }, l)) }) }), Ja = process.env.NODE_ENV === "production" ? {
  name: "nr8bfq",
  styles: "display:flex;justify-content:center;width:100%;background-color:white"
} : {
  name: "knl97s-styleIntegratedHeaderRoot",
  styles: "display:flex;justify-content:center;width:100%;background-color:white;label:styleIntegratedHeaderRoot;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Na
}, ya = /* @__PURE__ */ z({
  color: pg.gray[7],
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.5,
  whiteSpace: "nowrap",
  [w("tablet")]: {
    fontSize: 12
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleIntegratedHeaderLinkText;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), pa = /* @__PURE__ */ z({
  width: 1,
  height: 12,
  backgroundColor: pg.gray[3]
}, process.env.NODE_ENV === "production" ? "" : ";label:styleIntegratedHeaderDivider;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL2NvbXBvbmVudHMvaW50ZWdyYXRlZEhlYWRlckNvbnRlbnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtFcUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvbmV4dC9IZWFkZXIvY29tcG9uZW50cy9pbnRlZ3JhdGVkSGVhZGVyQ29udGVudC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IEludGVycG9sYXRpb24sIFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgQW5jaG9yLCBCb3gsIENPTE9SX1BBTEVUVEUsIEdyb3VwLCBUZXh0IH0gZnJvbSAnQGluZmxlYXJuL2RzLXJlYWN0JztcblxuaW1wb3J0IHsgSU5URUdSQVRFRF9IRUFERVJfVVJMIH0gZnJvbSAnLi4vLi4vLi4vLi4vY29uc3RhbnRzL3VybHMnO1xuaW1wb3J0IHsgbWVkaWFRdWVyaWVzIH0gZnJvbSAnLi4vLi4vLi4vLi4vc3R5bGVzJztcbmltcG9ydCB7IHN0eWxlSW50ZWdyYXRlZEhlYWRlckNvbnRlbnQgfSBmcm9tICcuLi9zdHlsZXMnO1xuXG4vKipcbiAqIEludGVncmF0ZWRIZWFkZXIg7JmAIFNTUiDsiqTsvIjroIjthqTsnbQg6rO17Jyg7ZWY64qUIO2RnO2YhCDqs4TsuLUuXG4gKiBza2VsZXRvbiDsl5TtirjrpqzqsIAgYW5hbHl0aWNzL3JlYWN0LXF1ZXJ5IOulvCDrsojrk6Tsl5Ag64GM7Ja07Jik7KeAIOyViuuPhOuhnSDtm4Ug7J2Y7KG07J2EIOuRkOyngCDslYrripTri6QuXG4gKi9cbmV4cG9ydCBjb25zdCBJTlRFR1JBVEVEX0hFQURFUl9MSU5LUyA9IFtcbiAgeyBsYWJlbDogJ+q4sOyXhSDqtZDsnKEnLCBocmVmOiBJTlRFR1JBVEVEX0hFQURFUl9VUkwuQjJCLCB2YWx1ZTogJ2ludGVncmF0ZWRfYjJiJyB9LFxuICB7XG4gICAgbGFiZWw6ICftj4nsg53qtZDsnKHsnbTsmqnqtownLFxuICAgIGhyZWY6IElOVEVHUkFURURfSEVBREVSX1VSTC5MSUZFTE9OR19WT1VDSEVSLFxuICAgIHZhbHVlOiAnaW50ZWdyYXRlZF9saWZlbG9uZ192b3VjaGVyJyxcbiAgfSxcbiAge1xuICAgIGxhYmVsOiAnQUkg6rWQ7JyhIDkwJSDtmZjquIknLFxuICAgIGhyZWY6IElOVEVHUkFURURfSEVBREVSX1VSTC5BSV9SRUZVTkQsXG4gICAgdmFsdWU6ICdpbnRlZ3JhdGVkX2FpX3JlZnVuZCcsXG4gIH0sXG5dIGFzIGNvbnN0O1xuXG5leHBvcnQgY29uc3QgSW50ZWdyYXRlZEhlYWRlckxpbmtzID0gKHtcbiAgb25MaW5rQ2xpY2ssXG4gIGNvbnRhaW5lclN0eWxlcyxcbn06IHtcbiAgb25MaW5rQ2xpY2s/OiAodmFsdWU6IHN0cmluZykgPT4gdm9pZDtcbiAgY29udGFpbmVyU3R5bGVzPzogSW50ZXJwb2xhdGlvbjxUaGVtZT47XG59KSA9PiAoXG4gIDxCb3ggY3NzPXtbc3R5bGVJbnRlZ3JhdGVkSGVhZGVyQ29udGVudCwgY29udGFpbmVyU3R5bGVzXX0+XG4gICAgPEdyb3VwIHNwYWNpbmc9ezEyfSBhbGlnbj1cImNlbnRlclwiIG5vV3JhcD5cbiAgICAgIHtJTlRFR1JBVEVEX0hFQURFUl9MSU5LUy5tYXAoKHsgbGFiZWwsIGhyZWYsIHZhbHVlIH0sIGluZGV4KSA9PiAoXG4gICAgICAgIDxHcm91cCBrZXk9e3ZhbHVlfSBzcGFjaW5nPXsxMn0gYWxpZ249XCJjZW50ZXJcIiBub1dyYXA+XG4gICAgICAgICAge2luZGV4ICE9PSAwICYmIDxCb3ggY3NzPXtzdHlsZUludGVncmF0ZWRIZWFkZXJEaXZpZGVyfSAvPn1cbiAgICAgICAgICA8QW5jaG9yIGhyZWY9e2hyZWZ9IHVuZGVybGluZT17ZmFsc2V9IG9uQ2xpY2s9eygpID0+IG9uTGlua0NsaWNrPy4odmFsdWUpfT5cbiAgICAgICAgICAgIDxUZXh0IGNzcz17c3R5bGVJbnRlZ3JhdGVkSGVhZGVyTGlua1RleHR9PntsYWJlbH08L1RleHQ+XG4gICAgICAgICAgPC9BbmNob3I+XG4gICAgICAgIDwvR3JvdXA+XG4gICAgICApKX1cbiAgICA8L0dyb3VwPlxuICA8L0JveD5cbik7XG5cbmV4cG9ydCBjb25zdCBzdHlsZUludGVncmF0ZWRIZWFkZXJSb290ID0gY3NzKHtcbiAgZGlzcGxheTogJ2ZsZXgnLFxuICBqdXN0aWZ5Q29udGVudDogJ2NlbnRlcicsXG4gIHdpZHRoOiAnMTAwJScsXG4gIGJhY2tncm91bmRDb2xvcjogJ3doaXRlJyxcbn0pO1xuXG5jb25zdCBzdHlsZUludGVncmF0ZWRIZWFkZXJMaW5rVGV4dCA9IGNzcyh7XG4gIGNvbG9yOiBDT0xPUl9QQUxFVFRFLmdyYXlbN10sXG4gIGZvbnRTaXplOiAxNCxcbiAgZm9udFdlaWdodDogNTAwLFxuICBsaW5lSGVpZ2h0OiAxLjUsXG4gIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuXG4gIFttZWRpYVF1ZXJpZXMoJ3RhYmxldCcpXToge1xuICAgIGZvbnRTaXplOiAxMixcbiAgfSxcbn0pO1xuXG5jb25zdCBzdHlsZUludGVncmF0ZWRIZWFkZXJEaXZpZGVyID0gY3NzKHtcbiAgd2lkdGg6IDEsXG4gIGhlaWdodDogMTIsXG4gIGJhY2tncm91bmRDb2xvcjogQ09MT1JfUEFMRVRURS5ncmF5WzNdLFxufSk7XG4iXX0= */"), CA = ({
  styles: g
}) => /* @__PURE__ */ h(H, { component: "header", id: Va.HEADER_INTEGRATED, css: [Ja, g == null ? void 0 : g.root, process.env.NODE_ENV === "production" ? "" : ";label:IntegratedHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvU2tlbGV0b24vSW50ZWdyYXRlZEhlYWRlclNrZWxldG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3QkkiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvbmV4dC9Ta2VsZXRvbi9JbnRlZ3JhdGVkSGVhZGVyU2tlbGV0b24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBJbnRlcnBvbGF0aW9uLCBUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEJveCB9IGZyb20gJ0BpbmZsZWFybi9kcy1yZWFjdCc7XG5cbmltcG9ydCB7XG4gIEludGVncmF0ZWRIZWFkZXJMaW5rcyxcbiAgc3R5bGVJbnRlZ3JhdGVkSGVhZGVyUm9vdCxcbn0gZnJvbSAnLi4vSGVhZGVyL2NvbXBvbmVudHMvaW50ZWdyYXRlZEhlYWRlckNvbnRlbnQnO1xuaW1wb3J0IHsgSEVBREVSX0VMRU1FTlRfSURTIH0gZnJvbSAnLi4vSGVhZGVyL3N0eWxlcyc7XG5cbi8qKlxuICog7Ya17ZWpIO2XpOuNlOydmCBTU1IvU3VzcGVuc2Ug7Iqk7LyI66CI7YakLlxuICog7ZWY7J2065Oc66CI7J207IWYIOyghOydtOudvCBLb09ubHkg66W8IOyTuCDsiJgg7JeG7Ja07IScIOuFuOy2nCDtjJDri6jsnYAg7Zi47Lac67aA7JeQIOunoeq4tOuLpC5cbiAqL1xuZXhwb3J0IGNvbnN0IEludGVncmF0ZWRIZWFkZXJTa2VsZXRvbiA9ICh7XG4gIHN0eWxlcyxcbn06IHtcbiAgc3R5bGVzPzoge1xuICAgIHJvb3Q/OiBJbnRlcnBvbGF0aW9uPFRoZW1lPjtcbiAgICBjb250YWluZXI/OiBJbnRlcnBvbGF0aW9uPFRoZW1lPjtcbiAgfTtcbn0pID0+IChcbiAgPEJveFxuICAgIGNvbXBvbmVudD1cImhlYWRlclwiXG4gICAgaWQ9e0hFQURFUl9FTEVNRU5UX0lEUy5IRUFERVJfSU5URUdSQVRFRH1cbiAgICBjc3M9e1tzdHlsZUludGVncmF0ZWRIZWFkZXJSb290LCBzdHlsZXM/LnJvb3RdfT5cbiAgICA8SW50ZWdyYXRlZEhlYWRlckxpbmtzIGNvbnRhaW5lclN0eWxlcz17c3R5bGVzPy5jb250YWluZXJ9IC8+XG4gIDwvQm94PlxuKTtcbiJdfQ== */"], children: /* @__PURE__ */ h(Ra, { containerStyles: g == null ? void 0 : g.container }) });
var Kc = {}, QI = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", e = "globe", c = 512, l = 512, t = [127760], i = "f0ac", n = "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z";
  g.definition = {
    prefix: I,
    iconName: e,
    icon: [
      c,
      l,
      t,
      i,
      n
    ]
  }, g.faGlobe = g.definition, g.prefix = I, g.iconName = e, g.width = c, g.height = l, g.ligatures = t, g.unicode = i, g.svgPathData = n, g.aliases = t;
})(QI);
var _c = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", e = "grid", c = 448, l = 512, t = ["grid-3"], i = "e195", n = "M0 72C0 49.9 17.9 32 40 32H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V72zM0 232c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V232zM128 392v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40zM160 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V72zM288 232v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM160 392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392zM448 72v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM320 232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V232zM448 392v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z";
  g.definition = {
    prefix: I,
    iconName: e,
    icon: [
      c,
      l,
      t,
      i,
      n
    ]
  }, g.faGrid = g.definition, g.prefix = I, g.iconName = e, g.width = c, g.height = l, g.ligatures = t, g.unicode = i, g.svgPathData = n, g.aliases = t;
})(_c);
const Ba = (g) => {
  const I = zI(g);
  I.current = g, eg(() => {
    let e = window.location.href;
    const c = () => {
      e = window.location.href, I.current();
    };
    function l() {
      const i = window.location.href;
      e !== i && (e = i, c());
    }
    window.addEventListener("popstate", c);
    const t = setInterval(l, 100);
    return () => {
      window.removeEventListener("popstate", c), clearInterval(t);
    };
  }, []);
}, aA = {
  COURSES: "COURSES",
  CHALLENGES: "CHALLENGES",
  MENTORING: "MENTORING",
  CLIPS: "CLIPS",
  ROADMAPS: "ROADMAPS",
  COMMUNITY: "COMMUNITY"
}, KI = 285, va = 25 * 3, oI = {
  COURSES: {
    icon: "course",
    text: "강의",
    href: k.COURSES()
  },
  CHALLENGES: {
    icon: "challenge",
    text: "챌린지",
    href: k.CHALLENGES
  },
  MENTORING: {
    icon: "mentoring",
    text: "멘토링",
    href: k.MENTORS
  },
  ROADMAPS: {
    icon: "roadmap",
    text: "로드맵",
    href: k.ROADMAPS
  },
  COMMUNITY: {
    icon: "community",
    text: "커뮤니티",
    href: k.COMMUNITY
  },
  CLIPS: {
    icon: "clip",
    text: "클립",
    href: k.CLIPS
  }
}, qc = {
  // 검색바 내부 요소들
  SEARCH_MENU_DROPDOWN: 1,
  // 메뉴 드롭다운
  SEARCH_INPUT: 2,
  // 검색 입력 필드
  EXPLORE_ITEM: 2,
  // 검색 입력 필드의 둘러보기 아이템
  SEARCH_BUTTON: 3,
  // 검색 버튼
  // 메인 GNB 요소들
  BRAND_LOGO: 10,
  // 브랜드 로고
  MENU_LIST: 20,
  // 메뉴 리스트
  // 플로팅 버튼들
  MOVE_TOP: 30,
  // 맨 위로 이동 버튼
  // 제외할 요소들
  HIDDEN: -1
  // 탭 포커스에서 제외
};
function _I() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Fa = process.env.NODE_ENV === "production" ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : {
  name: "1hwwzz7-menuLabel",
  styles: "white-space:nowrap;label:menuLabel;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _I
}, Ya = process.env.NODE_ENV === "production" ? {
  name: "1j389vi",
  styles: "font-weight:700"
} : {
  name: "l85uma-MenuItemWithIcon",
  styles: "font-weight:700;label:MenuItemWithIcon;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _I
};
const fa = ({
  type: g,
  label: I,
  showIndicator: e = !1,
  onClick: c,
  skeletonType: l
}) => {
  const t = /* @__PURE__ */ h(B, { w: 32, h: 32, align: "center", position: "center", children: /* @__PURE__ */ h(qe, { src: `${EI}/assets/images/header/${oI[g].icon}.png`, alt: oI[g].text, w: va, width: 32, height: 32 }) }), i = /* @__PURE__ */ h(za, { type: g, isSkeleton: !!l, children: /* @__PURE__ */ h(BI, { size: 16, color: "gray.9", fw: 700, className: l ? `class-label-${l.toLowerCase()}` : "", css: Fa, children: !l && I }) });
  return /* @__PURE__ */ h(vI, { h: 44, py: 6, px: 10, href: g ? oI[g].href : void 0, tabIndex: qc.MENU_LIST, display: "flex", css: /* @__PURE__ */ z({
    flexShrink: 0,
    "&:hover": {
      textDecoration: "none",
      borderRadius: 50,
      backgroundColor: pg.gray[0]
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:MenuItemWithIcon;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), onClick: c, children: e ? /* @__PURE__ */ h(bl, { size: 16, radius: "xl", label: "N", position: "top-end", color: "red", offset: 3, inline: !0, children: /* @__PURE__ */ T(B, { align: "center", spacing: 4, noWrap: !0, children: [
    t,
    i
  ] }) }) : /* @__PURE__ */ T(B, { align: "center", spacing: 4, css: Ya, noWrap: !0, children: [
    t,
    i
  ] }) });
};
var Ta = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1y6y0da-MenuListActiveWrapper",
  styles: "position:relative;label:MenuListActiveWrapper;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _I
};
const za = ({
  type: g,
  children: I,
  isSkeleton: e = !1
}) => {
  const [c, l] = TI(() => e ? !1 : xe(g)), t = wg(() => {
    if (e)
      return;
    const i = xe(g);
    l(i);
  }, [g, e]);
  return Ba(t), /* @__PURE__ */ T(H, { css: Ta, children: [
    I,
    c && /* @__PURE__ */ h(H, { w: "100%", h: 3, css: /* @__PURE__ */ z({
      position: "absolute",
      bottom: -2,
      left: "50%",
      transform: "translateX(-50%)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:MenuListActiveWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ h(H, { w: "100%", h: 2, css: /* @__PURE__ */ z({
      borderRadius: 8,
      backgroundColor: pg.infgreen[7]
    }, process.env.NODE_ENV === "production" ? "" : ";label:MenuListActiveWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") }) })
  ] });
}, ke = 20, Me = 4, Qe = 10, Sa = (g) => g ? 58 : 46, Ua = ({
  showMenuList: g,
  isAntMan: I
}) => /* @__PURE__ */ z({
  width: 520,
  zIndex: MI(I).HEADER,
  position: "absolute",
  paddingTop: ke,
  top: g ? "auto" : 28,
  height: g ? `calc(58px + ${ke}px)` : "auto",
  transform: "translateX(-50%)",
  left: "50%",
  transition: "top 0.2s ease-out, padding-top 0.2s ease-out, height 0.2s ease-out",
  [w("tablet")]: {
    display: "none"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleAppShellSearchBarWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvU2VhcmNoQmFyL3NlYXJjaEJhclN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQ0UiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvbmV4dC9TZWFyY2hCYXIvc2VhcmNoQmFyU3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgQ09MT1JfUEFMRVRURSB9IGZyb20gJ0BpbmZsZWFybi9kcy1yZWFjdCc7XG5cbmltcG9ydCB7IGdldFpJbmRleCwgbWVkaWFRdWVyaWVzIH0gZnJvbSAnLi4vLi4vLi4vc3R5bGVzJztcblxuLyoqXG4gKiBTZWFyY2hCYXIg6rSA66CoIOyInOyImCDsiqTtg4Dsnbwv7IOB7IiYIOuqqOydjC5cbiAqXG4gKiBTdGlja3lIZWFkZXJTa2VsZXRvbihza2VsZXRvbiDsl5Ttirjrpqwp7J20IFNlYXJjaEJhciDsiqTtg4DsnbzsnYQg7ZWE7JqU66GcIO2VmOuKlOuNsCxcbiAqIOy7tO2PrOuEjO2KuCDtjIzsnbwoQXBwU2hlbGxTZWFyY2hCYXJJdGVtIOuTsSnsl5DshJwgaW1wb3J0IO2VmOuptCB1c2VPbmJvYXJkaW5nQ29udGV4dCDihpJcbiAqIEBpbmZsZWFybi9tb2RhbHMo7Jio67O065SpIOuNsOydtO2EsCDslb0gOTAwS0Ip7JmAIFNlYXJjaEJhciDsu7Ttj6zrhIztirgg7KCE7LK06rCAIHNrZWxldG9uXG4gKiDssq3tgazsl5Ag7J2465287J24IOuyiOuTpOuQnOuLpC4g7Iqk7LyI66CI7Yak7J20IOyKpO2DgOydvOunjCDssLjsobDtlaAg7IiYIOyeiOuPhOuhnSDsnZjsobTshLEg7JeG64qUXG4gKiDtjIzsnbzroZwg67aE66as7ZWc64ukLlxuICovXG5cbmV4cG9ydCBjb25zdCBTRUFSQ0hfQkFSX1BBRERJTkdfVE9QID0gMjA7XG5cbi8qKlxuICogQE5PVEVcbiAqIOydtCDqsJLsnYQg67CU6r6466m0IEhFQURFUl9PRkZTRVRfSEVJR0hULk1PQklMRS5TRUFSQ0hfQkFSIOuPhCDqsJnsnbQg6rCx7Iug7ZW07JW8IO2VnOuLpC5cbiAqICjsg4Hri6gg7Yyo65SpICsgUExBQ0VIT0xERVJfSEVJR0hUKGZhbHNlKSA0NiArIO2VmOuLqCDtjKjrlKkgPSBTRUFSQ0hfQkFSKVxuICovXG5leHBvcnQgY29uc3QgU0VBUkNIX0JBUl9NT0JJTEVfUEFERElOR19UT1AgPSA0O1xuZXhwb3J0IGNvbnN0IFNFQVJDSF9CQVJfTU9CSUxFX1BBRERJTkdfQk9UVE9NID0gMTA7XG5cbmV4cG9ydCBjb25zdCBQTEFDRUhPTERFUl9IRUlHSFQgPSAoc2hvd01lbnVMaXN0OiBib29sZWFuKSA9PiAoc2hvd01lbnVMaXN0ID8gNTggOiA0Nik7XG5cbmV4cG9ydCBjb25zdCBzdHlsZUFwcFNoZWxsU2VhcmNoQmFyV3JhcHBlciA9ICh7XG4gIHNob3dNZW51TGlzdCxcbiAgaXNBbnRNYW4sXG59OiB7XG4gIHNob3dNZW51TGlzdDogYm9vbGVhbjtcbiAgaXNBbnRNYW46IGJvb2xlYW47XG59KSA9PlxuICBjc3Moe1xuICAgIHdpZHRoOiA1MjAsXG4gICAgekluZGV4OiBnZXRaSW5kZXgoaXNBbnRNYW4pLkhFQURFUixcbiAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcbiAgICBwYWRkaW5nVG9wOiBTRUFSQ0hfQkFSX1BBRERJTkdfVE9QLFxuICAgIHRvcDogIXNob3dNZW51TGlzdCA/IDI4IDogJ2F1dG8nLFxuICAgIGhlaWdodDogc2hvd01lbnVMaXN0ID8gYGNhbGMoNThweCArICR7U0VBUkNIX0JBUl9QQURESU5HX1RPUH1weClgIDogJ2F1dG8nLFxuICAgIHRyYW5zZm9ybTogJ3RyYW5zbGF0ZVgoLTUwJSknLFxuICAgIGxlZnQ6ICc1MCUnLFxuICAgIHRyYW5zaXRpb246ICd0b3AgMC4ycyBlYXNlLW91dCwgcGFkZGluZy10b3AgMC4ycyBlYXNlLW91dCwgaGVpZ2h0IDAuMnMgZWFzZS1vdXQnLFxuICAgIFttZWRpYVF1ZXJpZXMoJ3RhYmxldCcpXToge1xuICAgICAgZGlzcGxheTogJ25vbmUnLFxuICAgIH0sXG4gIH0pO1xuXG5leHBvcnQgY29uc3Qgc3R5bGVBcHBTaGVsbFNlYXJjaEJhcklubmVyV3JhcHBlciA9ICh7XG4gIHNob3dNZW51TGlzdCxcbiAgaXNGb2N1c2VkLFxuICBpc01vYmlsZSxcbn06IHtcbiAgc2hvd01lbnVMaXN0OiBib29sZWFuO1xuICBpc0ZvY3VzZWQ6IGJvb2xlYW47XG4gIGlzTW9iaWxlOiBib29sZWFuO1xufSkgPT4ge1xuICBjb25zdCBkZWZhdWx0V2lkdGggPSBzaG93TWVudUxpc3QgPyA1MTggOiA0MjA7XG4gIGNvbnN0IHdpZHRoID0gaXNNb2JpbGUgPyAnMTAwJScgOiBkZWZhdWx0V2lkdGg7XG5cbiAgcmV0dXJuIGNzcyh7XG4gICAgd2lkdGgsXG4gICAgaGVpZ2h0OiBQTEFDRUhPTERFUl9IRUlHSFQoc2hvd01lbnVMaXN0KSxcbiAgICBwYWRkaW5nTGVmdDogc2hvd01lbnVMaXN0ID8gOCA6IDcsXG4gICAgcGFkZGluZ1JpZ2h0OiBzaG93TWVudUxpc3QgPyA4IDogNyxcbiAgICB0cmFuc2l0aW9uOlxuICAgICAgJ3dpZHRoIDAuMnMgZWFzZS1vdXQsIGhlaWdodCAwLjJzIGVhc2Utb3V0LCBib3JkZXItcmFkaXVzIDAuMnMgZWFzZS1vdXQsIGJvcmRlciAwLjJzIGVhc2Utb3V0LCBib3gtc2hhZG93IDAuMnMgZWFzZS1vdXQnLFxuICAgIGJvcmRlclJhZGl1czogNTAsXG4gICAgYm9yZGVyOiBgMXB4IHNvbGlkICR7Q09MT1JfUEFMRVRURS5ncmF5W2lzRm9jdXNlZCA/IDkgOiAzXX1gLFxuICAgIGJhY2tncm91bmRDb2xvcjogJ3doaXRlJyxcbiAgICBib3hTaGFkb3c6XG4gICAgICAhaXNNb2JpbGUgJiYgaXNGb2N1c2VkXG4gICAgICAgID8gJzAgMXB4IDNweCAwIHJnYmEoMCwgMCwgMCwgMC4wNSksIDAgMzZweCAyOHB4IC03cHggcmdiYSgwLCAwLCAwLCAwLjA1KSwgMCAxN3B4IDE3cHggLTdweCByZ2JhKDAsIDAsIDAsIDAuMDQpJ1xuICAgICAgICA6ICdub25lJyxcbiAgfSk7XG59O1xuXG5leHBvcnQgY29uc3Qgc3R5bGVBcHBTaGVsbFNlYXJjaEJhck1vYmlsZVdyYXBwZXIgPSAoeyBzaG93TWVudUxpc3QgfTogeyBzaG93TWVudUxpc3Q6IGJvb2xlYW4gfSkgPT5cbiAgY3NzKHtcbiAgICBkaXNwbGF5OiAnbm9uZScsXG4gICAgekluZGV4OiBnZXRaSW5kZXgodHJ1ZSkuSEVBREVSLFxuICAgIHRvcDogIXNob3dNZW51TGlzdCA/IDEyIDogJ2F1dG8nLFxuICAgIGhlaWdodDogJ2F1dG8nLFxuICAgIGJhY2tncm91bmRDb2xvcjogJ3doaXRlJyxcbiAgICB0cmFuc2l0aW9uOiAndG9wIDAuMnMgZWFzZS1vdXQsIHBhZGRpbmctdG9wIDAuMnMgZWFzZS1vdXQsIGhlaWdodCAwLjJzIGVhc2Utb3V0JyxcbiAgICBbbWVkaWFRdWVyaWVzKCd0YWJsZXQnKV06IHtcbiAgICAgIGRpc3BsYXk6ICdmbGV4JyxcbiAgICAgIG1hcmdpbjogJzAgLTMycHgnLFxuICAgICAgcGFkZGluZzogYCR7U0VBUkNIX0JBUl9NT0JJTEVfUEFERElOR19UT1B9cHggMzJweCAke1NFQVJDSF9CQVJfTU9CSUxFX1BBRERJTkdfQk9UVE9NfXB4YCxcbiAgICB9LFxuICAgIFttZWRpYVF1ZXJpZXMoJ21vYmlsZScpXToge1xuICAgICAgbWFyZ2luOiAnMCAtMTZweCcsXG4gICAgICBwYWRkaW5nOiBgJHtTRUFSQ0hfQkFSX01PQklMRV9QQURESU5HX1RPUH1weCAxNnB4ICR7U0VBUkNIX0JBUl9NT0JJTEVfUEFERElOR19CT1RUT019cHhgLFxuICAgIH0sXG4gIH0pO1xuIl19 */"), $c = ({
  showMenuList: g,
  isFocused: I,
  isMobile: e
}) => /* @__PURE__ */ z({
  width: e ? "100%" : g ? 518 : 420,
  height: Sa(g),
  paddingLeft: g ? 8 : 7,
  paddingRight: g ? 8 : 7,
  transition: "width 0.2s ease-out, height 0.2s ease-out, border-radius 0.2s ease-out, border 0.2s ease-out, box-shadow 0.2s ease-out",
  borderRadius: 50,
  border: `1px solid ${pg.gray[I ? 9 : 3]}`,
  backgroundColor: "white",
  boxShadow: !e && I ? "0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 36px 28px -7px rgba(0, 0, 0, 0.05), 0 17px 17px -7px rgba(0, 0, 0, 0.04)" : "none"
}, process.env.NODE_ENV === "production" ? "" : ";label:styleAppShellSearchBarInnerWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Ha = ({
  showMenuList: g
}) => /* @__PURE__ */ z({
  display: "none",
  zIndex: MI(!0).HEADER,
  top: g ? "auto" : 12,
  height: "auto",
  backgroundColor: "white",
  transition: "top 0.2s ease-out, padding-top 0.2s ease-out, height 0.2s ease-out",
  [w("tablet")]: {
    display: "flex",
    margin: "0 -32px",
    padding: `${Me}px 32px ${Qe}px`
  },
  [w("mobile")]: {
    margin: "0 -16px",
    padding: `${Me}px 16px ${Qe}px`
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleAppShellSearchBarMobileWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), gl = YI({
  profile: void 0,
  isLoading: !1
}), sA = ({
  children: g
}) => {
  const {
    data: I,
    isLoading: e,
    error: c
  } = oC();
  XC(c);
  const l = Lg(() => ({
    profile: I ? {
      ...I,
      isB2b: RI(I),
      isGroupManager: CC(I),
      isGroupUser: bC(I),
      isPartner: aC(I)
    } : void 0,
    isLoading: e
  }), [I, e]);
  return /* @__PURE__ */ h(gl.Provider, { value: l, children: g });
}, wa = () => {
  const g = fI(gl);
  if (!g)
    throw new Error("useProfileContext must be used within a ProfileProvider");
  return g;
};
function Il() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const La = `${EI}/assets/images/header/inflearn_logo_business.svg`, Oa = `${EI}/assets/brand/logo.png?t=1`, Ke = 48, _e = 42, AA = ({
  isMobile: g = !1
}) => {
  var C;
  const {
    getSnapshot: I,
    setSnapshot: e
  } = nC(), {
    trackEvent: c
  } = Za(), {
    profile: l
  } = wa(), i = (l == null ? void 0 : l.isB2b) ? ((C = l == null ? void 0 : l.group) == null ? void 0 : C.logoUrl) ?? La : Oa, n = I();
  return eg(() => {
    (!n || n.logo !== i) && e({
      logo: i
    });
  }, [i, e, I, n]), /* @__PURE__ */ h(Pa, { url: i, onClick: () => {
    c(xC.CLICK_LOGO_AT_HEADER);
  }, isMobile: g });
}, qI = ({
  onClick: g,
  children: I
}) => {
  const {
    t: e
  } = Fc();
  return /* @__PURE__ */ h(vI, { href: k.MAIN, "aria-label": e("인프런 메인 페이지로 이동"), tabIndex: qc.BRAND_LOGO, css: ja, onClick: g, children: I });
};
var Ea = process.env.NODE_ENV === "production" ? {
  name: "1qesdsb",
  styles: "background-color:white"
} : {
  name: "uzjx03-HeaderBrandLogoImage",
  styles: "background-color:white;label:HeaderBrandLogoImage;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Il
};
const Pa = ({
  url: g,
  onClick: I,
  isMobile: e
}) => {
  const [c, l] = TI(!1);
  return /* @__PURE__ */ h(Cl, { pos: "relative", children: /* @__PURE__ */ T(qI, { onClick: I, children: [
    /* @__PURE__ */ h($e, { h: e ? _e : Ke, children: /* @__PURE__ */ h(qe, { w: 201, height: e ? _e : Ke, src: g, alt: "inflearn logo", onLoad: () => {
      l(!0);
    } }) }),
    !c && /* @__PURE__ */ h(H, { pos: "absolute", top: 0, left: 0, w: "auto", h: "auto", css: Ea, children: /* @__PURE__ */ h(H, { className: "class-logo" }) })
  ] }) });
}, ja = process.env.NODE_ENV === "production" ? {
  name: "1eingpo",
  styles: "display:flex;height:100%;align-items:center;& picture{display:flex;width:100%;height:100%;}"
} : {
  name: "1qgh1ec-styleHeaderBrandLogo",
  styles: "display:flex;height:100%;align-items:center;& picture{display:flex;width:100%;height:100%;};label:styleHeaderBrandLogo;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Il
};
function Da() {
  return /* @__PURE__ */ h(B, { w: KI, mt: -4, children: /* @__PURE__ */ h(B, { className: "class-show-logo", children: /* @__PURE__ */ h(qI, { children: /* @__PURE__ */ h(H, { className: "class-logo" }) }) }) });
}
function ka() {
  return /* @__PURE__ */ h(B, { w: KI, mt: -4, children: /* @__PURE__ */ h(B, { className: "class-show-logo", children: /* @__PURE__ */ h(qI, { children: /* @__PURE__ */ h(H, { className: "class-logo" }) }) }) });
}
function nI() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function uA({
  styles: g,
  isAntMan: I,
  showLanguageSectionButton: e = !0
}) {
  var c, l, t, i;
  return /* @__PURE__ */ h($e, { component: "header", className: "class-show-search-bar-header", css: [/* @__PURE__ */ z({
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    width: "100%",
    backgroundColor: "#fff",
    zIndex: MI(I).HEADER,
    alignItems: "flex-start",
    justifyContent: "center",
    [w("tablet")]: {
      height: 50
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:StickyHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), (c = g == null ? void 0 : g.header) == null ? void 0 : c.root, process.env.NODE_ENV === "production" ? "" : ";label:StickyHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ T(B, { css: [Wa, ls, (l = g == null ? void 0 : g.header) == null ? void 0 : l.container, process.env.NODE_ENV === "production" ? "" : ";label:StickyHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
    /* @__PURE__ */ h(Qa, { styles: (t = g == null ? void 0 : g.header) == null ? void 0 : t.desktop, isAntMan: I, showLanguageSectionButton: e }),
    /* @__PURE__ */ h(Is, { styles: (i = g == null ? void 0 : g.header) == null ? void 0 : i.mobile, showLanguageSectionButton: e })
  ] }) });
}
var Ma = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1gwiwrs-DesktopHeaderSkeleton",
  styles: "position:relative;label:DesktopHeaderSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: nI
};
const Qa = ({
  styles: g,
  isAntMan: I,
  showLanguageSectionButton: e
}) => /* @__PURE__ */ h(FI, { justify: "start", align: "center", w: "100%", className: "class-show-search-bar-wrapper", css: /* @__PURE__ */ z({
  backgroundColor: "white",
  [w("tablet")]: {
    height: "auto"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ T(B, { position: "apart", align: "center", spacing: 0, w: "100%", h: Qc, noWrap: !0, css: [/* @__PURE__ */ z({
  [w("tablet")]: {
    display: "none"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), g == null ? void 0 : g.root, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
  /* @__PURE__ */ h(Da, {}),
  /* @__PURE__ */ T(H, { css: Ma, children: [
    /* @__PURE__ */ h($a, {}),
    /* @__PURE__ */ h(qa, { isAntMan: I })
  ] }),
  /* @__PURE__ */ h(Ka, { showLanguageSectionButton: e })
] }) }), Ka = ({
  showLanguageSectionButton: g
}) => /* @__PURE__ */ T(B, { w: KI, spacing: 10, position: "right", children: [
  /* @__PURE__ */ h(mg, { variant: "light", size: "n-md", color: "gray", radius: "xl", disabled: !0, children: /* @__PURE__ */ h(Ng, { icon: _c.faGrid }) }),
  g && /* @__PURE__ */ h(mg, { variant: "light", size: "n-md", color: "gray", radius: "xl", disabled: !0, children: /* @__PURE__ */ h(Ng, { icon: QI.faGlobe }) }),
  /* @__PURE__ */ h(gc, { width: 92, height: 42, radius: "xl" })
] });
var _a = process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "184j5yn-SearchBarSkeleton",
  styles: "flex:1;label:SearchBarSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL1N0aWNreUhlYWRlclNrZWxldG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErSlciLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvbmV4dC9IZWFkZXIvU3RpY2t5SGVhZGVyU2tlbGV0b24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBJbnRlcnBvbGF0aW9uLCBUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEFjdGlvbkljb24sIEJveCwgRmxleCwgR3JvdXAsIEljb24sIFNrZWxldG9uIH0gZnJvbSAnQGluZmxlYXJuL2RzLXJlYWN0JztcbmltcG9ydCB7IHNvbGlkIH0gZnJvbSAnQGluZmxlYXJuL2ZvbnRhd2Vzb21lLXN2Zy1jb3JlL2ltcG9ydC5tYWNybyc7XG5pbXBvcnQgeyBTdGFjayB9IGZyb20gJ0BtYW50aW5lL2NvcmUnO1xuXG5pbXBvcnQgeyBNZW51SXRlbVdpdGhJY29uIH0gZnJvbSAnLi9jb21wb25lbnRzL01lbnVJdGVtV2l0aEljb24nO1xuaW1wb3J0IHR5cGUgeyBNRU5VX0lURU1TIH0gZnJvbSAnLi9jb25zdGFudHMvbWVudUl0ZW1zJztcbmltcG9ydCB7IEdOQl9TSURFX1dJRFRIIH0gZnJvbSAnLi9jb25zdGFudHMvbWVudUl0ZW1zJztcbmltcG9ydCB7IEhFQURFUl9IRUlHSFQsIHN0eWxlSGVhZGVyQ29udGVudCB9IGZyb20gJy4vc3R5bGVzJztcbmltcG9ydCB7IGdldFpJbmRleCwgbWVkaWFRdWVyaWVzIH0gZnJvbSAnLi4vLi4vLi4vc3R5bGVzJztcbmltcG9ydCB7XG4gIHN0eWxlQXBwU2hlbGxTZWFyY2hCYXJJbm5lcldyYXBwZXIsXG4gIHN0eWxlQXBwU2hlbGxTZWFyY2hCYXJNb2JpbGVXcmFwcGVyLFxuICBzdHlsZUFwcFNoZWxsU2VhcmNoQmFyV3JhcHBlcixcbn0gZnJvbSAnLi4vU2VhcmNoQmFyL3NlYXJjaEJhclN0eWxlcyc7XG5pbXBvcnQge1xuICBIZWFkZXJCcmFuZExvZ29Ta2VsZXRvbixcbiAgSGVhZGVyQnJhbmRMb2dvU2tlbGV0b25Nb2JpbGUsXG59IGZyb20gJy4uL1NrZWxldG9uL0hlYWRlckJyYW5kTG9nb1NrZWxldG9uJztcblxudHlwZSBTdGlja3lIZWFkZXJTa2VsZXRvblByb3BzID0ge1xuICBpc0FudE1hbjogYm9vbGVhbjtcbiAgLyoqXG4gICAqIOyLpOygnCDtl6TrjZQoUmlnaHRTZWN0aW9uKeyZgCDqsJnsnYAg7KGw6rG07Jy866GcIOyWuOyWtCDrsoTtirwg7J6Q66as66W8IOyeoeyVhOyVvCDtlZzri6QuXG4gICAqIO2YuOyKpO2KuOqwgCBTa2VsZXRvbkhlYWRlciDrpbwg7KeB7KCRIOyTsOuKlCDqsr3smrDrpbwg7JyE7ZW0IOq4sOuzuOqwkuydgCDrhbjstpwodHJ1ZSkuXG4gICAqL1xuICBzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uPzogYm9vbGVhbjtcbiAgc3R5bGVzPzoge1xuICAgIGhlYWRlcj86IHtcbiAgICAgIHJvb3Q/OiBJbnRlcnBvbGF0aW9uPFRoZW1lPjtcbiAgICAgIGNvbnRhaW5lcj86IEludGVycG9sYXRpb248VGhlbWU+O1xuICAgICAgbW9iaWxlPzoge1xuICAgICAgICByb290PzogSW50ZXJwb2xhdGlvbjxUaGVtZT47XG4gICAgICB9O1xuICAgICAgZGVza3RvcD86IHtcbiAgICAgICAgcm9vdD86IEludGVycG9sYXRpb248VGhlbWU+O1xuICAgICAgfTtcbiAgICB9O1xuICB9O1xufTtcblxuZXhwb3J0IGZ1bmN0aW9uIFN0aWNreUhlYWRlclNrZWxldG9uKHtcbiAgc3R5bGVzLFxuICBpc0FudE1hbixcbiAgc2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbiA9IHRydWUsXG59OiBTdGlja3lIZWFkZXJTa2VsZXRvblByb3BzKSB7XG4gIHJldHVybiAoXG4gICAgPEZsZXhcbiAgICAgIGNvbXBvbmVudD1cImhlYWRlclwiXG4gICAgICBjbGFzc05hbWU9XCJjbGFzcy1zaG93LXNlYXJjaC1iYXItaGVhZGVyXCJcbiAgICAgIGNzcz17W1xuICAgICAgICBjc3Moe1xuICAgICAgICAgIHBvc2l0aW9uOiAnc3RpY2t5JyxcbiAgICAgICAgICB0b3A6IDAsXG4gICAgICAgICAgbGVmdDogMCxcbiAgICAgICAgICByaWdodDogMCxcbiAgICAgICAgICB3aWR0aDogJzEwMCUnLFxuICAgICAgICAgIGJhY2tncm91bmRDb2xvcjogJyNmZmYnLFxuICAgICAgICAgIHpJbmRleDogZ2V0WkluZGV4KGlzQW50TWFuKS5IRUFERVIsXG4gICAgICAgICAgYWxpZ25JdGVtczogJ2ZsZXgtc3RhcnQnLFxuICAgICAgICAgIGp1c3RpZnlDb250ZW50OiAnY2VudGVyJyxcblxuICAgICAgICAgIFttZWRpYVF1ZXJpZXMoJ3RhYmxldCcpXToge1xuICAgICAgICAgICAgaGVpZ2h0OiA1MCxcbiAgICAgICAgICB9LFxuICAgICAgICB9KSxcbiAgICAgICAgc3R5bGVzPy5oZWFkZXI/LnJvb3QsXG4gICAgICBdfT5cbiAgICAgIDxHcm91cCBjc3M9e1tzdHlsZUhlYWRlckNvbnRlbnQsIHN0eWxlSGVhZGVyQ29udGFpbmVySW5uZXIsIHN0eWxlcz8uaGVhZGVyPy5jb250YWluZXJdfT5cbiAgICAgICAgPERlc2t0b3BIZWFkZXJTa2VsZXRvblxuICAgICAgICAgIHN0eWxlcz17c3R5bGVzPy5oZWFkZXI/LmRlc2t0b3B9XG4gICAgICAgICAgaXNBbnRNYW49e2lzQW50TWFufVxuICAgICAgICAgIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b249e3Nob3dMYW5ndWFnZVNlY3Rpb25CdXR0b259XG4gICAgICAgIC8+XG4gICAgICAgIDxNb2JpbGVIZWFkZXJTa2VsZXRvblxuICAgICAgICAgIHN0eWxlcz17c3R5bGVzPy5oZWFkZXI/Lm1vYmlsZX1cbiAgICAgICAgICBzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uPXtzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9ufVxuICAgICAgICAvPlxuICAgICAgPC9Hcm91cD5cbiAgICA8L0ZsZXg+XG4gICk7XG59XG5cbmNvbnN0IERlc2t0b3BIZWFkZXJTa2VsZXRvbiA9ICh7XG4gIHN0eWxlcyxcbiAgaXNBbnRNYW4sXG4gIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b24sXG59OiB7XG4gIHN0eWxlcz86IHtcbiAgICByb290PzogSW50ZXJwb2xhdGlvbjxUaGVtZT47XG4gIH07XG4gIGlzQW50TWFuOiBib29sZWFuO1xuICBzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uOiBib29sZWFuO1xufSkgPT4gKFxuICA8U3RhY2tcbiAgICBqdXN0aWZ5PVwic3RhcnRcIlxuICAgIGFsaWduPVwiY2VudGVyXCJcbiAgICB3PVwiMTAwJVwiXG4gICAgY2xhc3NOYW1lPVwiY2xhc3Mtc2hvdy1zZWFyY2gtYmFyLXdyYXBwZXJcIlxuICAgIGNzcz17e1xuICAgICAgYmFja2dyb3VuZENvbG9yOiAnd2hpdGUnLFxuICAgICAgW21lZGlhUXVlcmllcygndGFibGV0JyldOiB7XG4gICAgICAgIGhlaWdodDogJ2F1dG8nLFxuICAgICAgfSxcbiAgICB9fT5cbiAgICA8R3JvdXBcbiAgICAgIHBvc2l0aW9uPVwiYXBhcnRcIlxuICAgICAgYWxpZ249XCJjZW50ZXJcIlxuICAgICAgc3BhY2luZz17MH1cbiAgICAgIHc9XCIxMDAlXCJcbiAgICAgIGg9e0hFQURFUl9IRUlHSFR9XG4gICAgICBub1dyYXBcbiAgICAgIGNzcz17W1xuICAgICAgICBjc3Moe1xuICAgICAgICAgIFttZWRpYVF1ZXJpZXMoJ3RhYmxldCcpXToge1xuICAgICAgICAgICAgZGlzcGxheTogJ25vbmUnLFxuICAgICAgICAgIH0sXG4gICAgICAgIH0pLFxuICAgICAgICBzdHlsZXM/LnJvb3QsXG4gICAgICBdfT5cbiAgICAgIDxIZWFkZXJCcmFuZExvZ29Ta2VsZXRvbiAvPlxuICAgICAgPEJveCBjc3M9e3sgcG9zaXRpb246ICdyZWxhdGl2ZScgfX0+XG4gICAgICAgIDxNZW51TGlzdFNrZWxldG9uIC8+XG4gICAgICAgIDxTZWFyY2hCYXJTa2VsZXRvbiBpc0FudE1hbj17aXNBbnRNYW59IC8+XG4gICAgICA8L0JveD5cbiAgICAgIDxSaWdodFNlY3Rpb25Ta2VsZXRvbiBzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uPXtzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9ufSAvPlxuICAgIDwvR3JvdXA+XG4gIDwvU3RhY2s+XG4pO1xuXG5jb25zdCBSaWdodFNlY3Rpb25Ta2VsZXRvbiA9ICh7XG4gIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b24sXG59OiB7XG4gIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b246IGJvb2xlYW47XG59KSA9PiAoXG4gIDxHcm91cCB3PXtHTkJfU0lERV9XSURUSH0gc3BhY2luZz17MTB9IHBvc2l0aW9uPVwicmlnaHRcIj5cbiAgICA8QWN0aW9uSWNvbiB2YXJpYW50PVwibGlnaHRcIiBzaXplPVwibi1tZFwiIGNvbG9yPVwiZ3JheVwiIHJhZGl1cz1cInhsXCIgZGlzYWJsZWQ+XG4gICAgICA8SWNvbiBpY29uPXtzb2xpZCgnZ3JpZCcpfSAvPlxuICAgIDwvQWN0aW9uSWNvbj5cbiAgICB7c2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbiAmJiAoXG4gICAgICA8QWN0aW9uSWNvbiB2YXJpYW50PVwibGlnaHRcIiBzaXplPVwibi1tZFwiIGNvbG9yPVwiZ3JheVwiIHJhZGl1cz1cInhsXCIgZGlzYWJsZWQ+XG4gICAgICAgIDxJY29uIGljb249e3NvbGlkKCdnbG9iZScpfSAvPlxuICAgICAgPC9BY3Rpb25JY29uPlxuICAgICl9XG4gICAgPFNrZWxldG9uIHdpZHRoPXs5Mn0gaGVpZ2h0PXs0Mn0gcmFkaXVzPVwieGxcIiAvPlxuICA8L0dyb3VwPlxuKTtcblxuY29uc3QgU2VhcmNoQmFyU2tlbGV0b24gPSAoeyBpc0FudE1hbiB9OiB7IGlzQW50TWFuOiBib29sZWFuIH0pID0+IChcbiAgPEdyb3VwXG4gICAgY2xhc3NOYW1lPVwiY2xhc3Mtc2hvdy1zZWFyY2gtYmFyXCJcbiAgICBjc3M9e3N0eWxlQXBwU2hlbGxTZWFyY2hCYXJXcmFwcGVyKHsgc2hvd01lbnVMaXN0OiB0cnVlLCBpc0FudE1hbiB9KX0+XG4gICAgPEdyb3VwXG4gICAgICBjc3M9e3N0eWxlQXBwU2hlbGxTZWFyY2hCYXJJbm5lcldyYXBwZXIoe1xuICAgICAgICBzaG93TWVudUxpc3Q6IHRydWUsXG4gICAgICAgIGlzRm9jdXNlZDogZmFsc2UsXG4gICAgICAgIGlzTW9iaWxlOiBmYWxzZSxcbiAgICAgIH0pfT5cbiAgICAgIDxCb3ggY3NzPXt7IGZsZXg6IDEgfX0+PC9Cb3g+XG4gICAgICA8QWN0aW9uSWNvbiB0eXBlPVwic3VibWl0XCIgc2l6ZT1cIm4tbWRcIiB2YXJpYW50PVwiZmlsbGVkXCIgY29sb3I9XCJpbmZncmVlblwiIHJhZGl1cz17OTk5fSBkaXNhYmxlZD5cbiAgICAgICAgPEljb24gaWNvbj17c29saWQoJ3NlYXJjaCcpfSBzaXplPVwibWRcIiAvPlxuICAgICAgPC9BY3Rpb25JY29uPlxuICAgIDwvR3JvdXA+XG4gIDwvR3JvdXA+XG4pO1xuXG5jb25zdCBNZW51TGlzdFNrZWxldG9uID0gKCkgPT4gKFxuICA8R3JvdXAgaD17NDR9PlxuICAgIDxHcm91cCBzcGFjaW5nPXsxMH0gY2xhc3NOYW1lPVwiY2xhc3Mtc2hvdy1tZW51LWxpc3RcIiBub1dyYXA+XG4gICAgICA8TWVudUl0ZW1XaXRoSWNvblNrZWxldG9uIHR5cGU9XCJDT1VSU0VTXCIgLz5cbiAgICAgIDxNZW51SXRlbVdpdGhJY29uU2tlbGV0b24gdHlwZT1cIkNIQUxMRU5HRVNcIiBzaG93SW5kaWNhdG9yIC8+XG4gICAgICA8TWVudUl0ZW1XaXRoSWNvblNrZWxldG9uIHR5cGU9XCJNRU5UT1JJTkdcIiAvPlxuICAgICAgPE1lbnVJdGVtV2l0aEljb25Ta2VsZXRvbiB0eXBlPVwiQ0xJUFNcIiBzaG93SW5kaWNhdG9yIC8+XG4gICAgICA8TWVudUl0ZW1XaXRoSWNvblNrZWxldG9uIHR5cGU9XCJST0FETUFQU1wiIC8+XG4gICAgPC9Hcm91cD5cbiAgPC9Hcm91cD5cbik7XG5cbmNvbnN0IE1lbnVJdGVtV2l0aEljb25Ta2VsZXRvbiA9ICh7XG4gIHR5cGUsXG4gIHNob3dJbmRpY2F0b3IgPSBmYWxzZSxcbn06IHtcbiAgdHlwZToga2V5b2YgdHlwZW9mIE1FTlVfSVRFTVM7XG4gIHNob3dJbmRpY2F0b3I/OiBib29sZWFuO1xufSkgPT4gKFxuICA8U3RhY2sganVzdGlmeT1cImNlbnRlclwiIGNsYXNzTmFtZT17YGNsYXNzLXNob3ctbWVudS0ke3R5cGUudG9Mb3dlckNhc2UoKX1gfT5cbiAgICA8TWVudUl0ZW1XaXRoSWNvbiB0eXBlPXt0eXBlfSBza2VsZXRvblR5cGU9e3R5cGV9IHNob3dJbmRpY2F0b3I9e3Nob3dJbmRpY2F0b3J9IC8+XG4gIDwvU3RhY2s+XG4pO1xuXG50eXBlIE1vYmlsZUhlYWRlclNrZWxldG9uUHJvcHMgPSB7XG4gIHN0eWxlcz86IHtcbiAgICByb290PzogSW50ZXJwb2xhdGlvbjxUaGVtZT47XG4gIH07XG4gIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b246IGJvb2xlYW47XG59O1xuXG5jb25zdCBNb2JpbGVIZWFkZXJTa2VsZXRvbiA9ICh7IHN0eWxlcywgc2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbiB9OiBNb2JpbGVIZWFkZXJTa2VsZXRvblByb3BzKSA9PiAoXG4gIDxTdGFja1xuICAgIHc9XCIxMDAlXCJcbiAgICBzcGFjaW5nPXswfVxuICAgIGNzcz17e1xuICAgICAgZGlzcGxheTogJ25vbmUnLFxuICAgICAgW21lZGlhUXVlcmllcygndGFibGV0JyldOiB7XG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcbiAgICAgIH0sXG4gICAgfX0+XG4gICAgPEdyb3VwIHc9XCIxMDAlXCIgaD17NTB9IGNzcz17W3N0eWxlcz8ucm9vdF19PlxuICAgICAgPEhlYWRlckJyYW5kTG9nb1NrZWxldG9uTW9iaWxlIC8+XG4gICAgICA8R3JvdXAgcG9zaXRpb249XCJyaWdodFwiIHNwYWNpbmc9ezh9IG1sPXsxMH0gbm9XcmFwIGNzcz17eyBmbGV4OiAxIH19PlxuICAgICAgICB7c2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbiAmJiAoXG4gICAgICAgICAgPEFjdGlvbkljb24gdmFyaWFudD1cImxpZ2h0XCIgc2l6ZT1cIm4tc21cIiBjb2xvcj1cImdyYXlcIiByYWRpdXM9XCJ4bFwiIGRpc2FibGVkPlxuICAgICAgICAgICAgPEljb24gaWNvbj17c29saWQoJ2dsb2JlJyl9IC8+XG4gICAgICAgICAgPC9BY3Rpb25JY29uPlxuICAgICAgICApfVxuICAgICAgICA8U2tlbGV0b24gd2lkdGg9ezM2fSBoZWlnaHQ9ezM2fSByYWRpdXM9XCJ4bFwiIHZpc2libGUgLz5cbiAgICAgIDwvR3JvdXA+XG4gICAgPC9Hcm91cD5cbiAgICA8U2VhcmNoQmFyU2tlbGV0b25Nb2JpbGUgLz5cbiAgPC9TdGFjaz5cbik7XG5cbmNvbnN0IFNlYXJjaEJhclNrZWxldG9uTW9iaWxlID0gKCkgPT4gKFxuICA8R3JvdXBcbiAgICB3PVwiMTAwdndcIlxuICAgIGNsYXNzTmFtZT1cImNsYXNzLXNob3ctc2VhcmNoLWJhclwiXG4gICAgY3NzPXtzdHlsZUFwcFNoZWxsU2VhcmNoQmFyTW9iaWxlV3JhcHBlcih7IHNob3dNZW51TGlzdDogZmFsc2UgfSl9PlxuICAgIDxHcm91cFxuICAgICAgdz1cIjEwMCVcIlxuICAgICAgY3NzPXtzdHlsZUFwcFNoZWxsU2VhcmNoQmFySW5uZXJXcmFwcGVyKHtcbiAgICAgICAgc2hvd01lbnVMaXN0OiBmYWxzZSxcbiAgICAgICAgaXNGb2N1c2VkOiBmYWxzZSxcbiAgICAgICAgaXNNb2JpbGU6IHRydWUsXG4gICAgICB9KX0+XG4gICAgICA8Qm94IGNzcz17eyBmbGV4OiAxIH19PjwvQm94PlxuICAgICAgPEFjdGlvbkljb24gdHlwZT1cInN1Ym1pdFwiIHNpemU9XCJuLXhzXCIgdmFyaWFudD1cImZpbGxlZFwiIGNvbG9yPVwiaW5mZ3JlZW5cIiByYWRpdXM9ezk5OX0gZGlzYWJsZWQ+XG4gICAgICAgIDxJY29uIGljb249e3NvbGlkKCdzZWFyY2gnKX0gc2l6ZT1cIm1kXCIgLz5cbiAgICAgIDwvQWN0aW9uSWNvbj5cbiAgICA8L0dyb3VwPlxuICA8L0dyb3VwPlxuKTtcblxuZXhwb3J0IGNvbnN0IHN0eWxlSGVhZGVyQ29udGFpbmVySW5uZXIgPSBjc3Moe1xuICBtYXhXaWR0aDogMTQ0MCxcbiAgcGFkZGluZzogJzAgMzJweCcsXG4gIGJhY2tncm91bmRDb2xvcjogJ3doaXRlJyxcblxuICBbbWVkaWFRdWVyaWVzKCdtb2JpbGUnKV06IHtcbiAgICBwYWRkaW5nOiAnMCAxNnB4JyxcbiAgfSxcbn0pO1xuIl19 */",
  toString: nI
};
const qa = ({
  isAntMan: g
}) => /* @__PURE__ */ h(B, { className: "class-show-search-bar", css: Ua({
  showMenuList: !0,
  isAntMan: g
}), children: /* @__PURE__ */ T(B, { css: $c({
  showMenuList: !0,
  isFocused: !1,
  isMobile: !1
}), children: [
  /* @__PURE__ */ h(H, { css: _a }),
  /* @__PURE__ */ h(mg, { type: "submit", size: "n-md", variant: "filled", color: "infgreen", radius: 999, disabled: !0, children: /* @__PURE__ */ h(Ng, { icon: Kc.faSearch, size: "md" }) })
] }) }), $a = () => /* @__PURE__ */ h(B, { h: 44, children: /* @__PURE__ */ T(B, { spacing: 10, className: "class-show-menu-list", noWrap: !0, children: [
  /* @__PURE__ */ h(Xg, { type: "COURSES" }),
  /* @__PURE__ */ h(Xg, { type: "CHALLENGES", showIndicator: !0 }),
  /* @__PURE__ */ h(Xg, { type: "MENTORING" }),
  /* @__PURE__ */ h(Xg, { type: "CLIPS", showIndicator: !0 }),
  /* @__PURE__ */ h(Xg, { type: "ROADMAPS" })
] }) }), Xg = ({
  type: g,
  showIndicator: I = !1
}) => /* @__PURE__ */ h(FI, { justify: "center", className: `class-show-menu-${g.toLowerCase()}`, children: /* @__PURE__ */ h(fa, { type: g, skeletonType: g, showIndicator: I }) });
var gs = process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "ow3ghr-MobileHeaderSkeleton",
  styles: "flex:1;label:MobileHeaderSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: nI
};
const Is = ({
  styles: g,
  showLanguageSectionButton: I
}) => /* @__PURE__ */ T(FI, { w: "100%", spacing: 0, css: /* @__PURE__ */ z({
  display: "none",
  [w("tablet")]: {
    display: "flex"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:MobileHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
  /* @__PURE__ */ T(B, { w: "100%", h: 50, css: [g == null ? void 0 : g.root, process.env.NODE_ENV === "production" ? "" : ";label:MobileHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
    /* @__PURE__ */ h(ka, {}),
    /* @__PURE__ */ T(B, { position: "right", spacing: 8, ml: 10, noWrap: !0, css: gs, children: [
      I && /* @__PURE__ */ h(mg, { variant: "light", size: "n-sm", color: "gray", radius: "xl", disabled: !0, children: /* @__PURE__ */ h(Ng, { icon: QI.faGlobe }) }),
      /* @__PURE__ */ h(gc, { width: 36, height: 36, radius: "xl", visible: !0 })
    ] })
  ] }),
  /* @__PURE__ */ h(cs, {})
] });
var es = process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "11fw941-SearchBarSkeletonMobile",
  styles: "flex:1;label:SearchBarSkeletonMobile;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: nI
};
const cs = () => /* @__PURE__ */ h(B, { w: "100vw", className: "class-show-search-bar", css: Ha({
  showMenuList: !1
}), children: /* @__PURE__ */ T(B, { w: "100%", css: $c({
  showMenuList: !1,
  isFocused: !1,
  isMobile: !0
}), children: [
  /* @__PURE__ */ h(H, { css: es }),
  /* @__PURE__ */ h(mg, { type: "submit", size: "n-xs", variant: "filled", color: "infgreen", radius: 999, disabled: !0, children: /* @__PURE__ */ h(Ng, { icon: Kc.faSearch, size: "md" }) })
] }) }), ls = /* @__PURE__ */ z({
  maxWidth: 1440,
  padding: "0 32px",
  backgroundColor: "white",
  [w("mobile")]: {
    padding: "0 16px"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleHeaderContainerInner;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
export {
  Va as $,
  JI as A,
  EI as B,
  Ug as C,
  Dc as D,
  cg as E,
  qg as F,
  Ws as G,
  Ns as H,
  db as I,
  xs as J,
  ms as K,
  On as L,
  bg as M,
  zn as N,
  Rs as O,
  vc as P,
  An as Q,
  F as R,
  Og as S,
  rb as T,
  CA as U,
  uA as V,
  iA as W,
  gb as X,
  Js as Y,
  xc as Z,
  Ms as _,
  vl as a,
  Wt as a$,
  Qs as a0,
  nC as a1,
  oC as a2,
  XC as a3,
  RI as a4,
  CC as a5,
  bC as a6,
  aC as a7,
  Ys as a8,
  Bs as a9,
  _s as aA,
  ks as aB,
  KI as aC,
  ws as aD,
  kb as aE,
  Us as aF,
  Sa as aG,
  va as aH,
  aA as aI,
  Ib as aJ,
  $c as aK,
  Ua as aL,
  AA as aM,
  Ha as aN,
  bA as aO,
  sA as aP,
  Wa as aQ,
  IA as aR,
  xe as aS,
  oc as aT,
  $g as aU,
  de as aV,
  Cg as aW,
  q as aX,
  E as aY,
  UI as aZ,
  Pl as a_,
  Kc as aa,
  ys as ab,
  JC as ac,
  wa as ad,
  vs as ae,
  ye as af,
  Qn as ag,
  ps as ah,
  Ss as ai,
  Mc as aj,
  Ba as ak,
  MI as al,
  fs as am,
  Ds as an,
  Ja as ao,
  Ra as ap,
  fa as aq,
  oI as ar,
  qc as as,
  _c as at,
  w as au,
  cA as av,
  gA as aw,
  Es as ax,
  tA as ay,
  Fs as az,
  Bl as b,
  Ts as b0,
  eA as b1,
  nA as b2,
  De as b3,
  Hg as b4,
  Re as b5,
  _b as b6,
  lC as b7,
  Hs as b8,
  Ls as b9,
  Os as ba,
  Kb as bb,
  tg as bc,
  lA as bd,
  qs as be,
  Ig as bf,
  $s as bg,
  Jc as bh,
  VI as bi,
  sb as bj,
  K as bk,
  cb as bl,
  tb as bm,
  ub as bn,
  zs as bo,
  Vs as bp,
  ng as c,
  Xc as d,
  bc as e,
  nc as f,
  wI as g,
  GI as h,
  Eg as i,
  vg as j,
  sc as k,
  uc as l,
  OI as m,
  yi as n,
  js as o,
  Za as p,
  D as q,
  ig as r,
  Ps as s,
  $l as t,
  Fc as u,
  xC as v,
  k as w,
  Ne as x,
  DI as y,
  Ks as z
};
